import { shareReplay } from 'rxjs/operators';
import { HttpClient } from "@angular/common/http";
import { Injectable, EventEmitter } from "@angular/core";
//import { CryptoJS } from "crypto-js";
//import { StringBuilder } from "string-builder";
//import { Http, Response, Headers, ConnectionBackend } from "@angular/http";

import * as moment from "moment";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
@Injectable()
export class Utilities {
    constructor (
        private http: HttpClient
    ) {

    }
    getImage(imageUrl: string): Observable<Blob> {
        return this.http.get(imageUrl, { responseType: 'blob' }).pipe(shareReplay(1));
      }
    setData(userinfo) {
        this.updateData(userinfo);
        localStorage.setItem("storeLocationId", "*");
        localStorage.setItem(
            "locations",
            JSON.stringify([{ id: "*", text: "All Locations" }])
        );
        localStorage.setItem("auth_key", userinfo.auth_key);
        localStorage.setItem("merchantId", userinfo.merchantId);
    }

    updateData(userinfo) {
        localStorage.setItem("session", "active");
        localStorage.setItem("id", userinfo.id);
        localStorage.setItem("userId", userinfo.id);
        localStorage.setItem(
            "fullname",
            userinfo.userFirstName + " " + userinfo.userLastName
        );
        localStorage.setItem("companyName", userinfo.merchantCompanyName);
        localStorage.setItem("isAdmin", userinfo.isAdmin);
        localStorage.setItem("auth_key", userinfo.auth_key);
        localStorage.setItem("VerifyingToken", "false");
        localStorage.setItem(
            "permissions",
            JSON.stringify(userinfo.permissions)
        );
        localStorage.setItem("merchantId", userinfo.merchantId);
    }

    cleanData() {
        localStorage.removeItem("id");
        localStorage.removeItem("userId");
        localStorage.removeItem("fullname");
        localStorage.removeItem("companyName");
        localStorage.removeItem("storeLocationId");
        localStorage.removeItem("locations");
        localStorage.removeItem("VerifyingToken");
        localStorage.removeItem("isAdmin");
        localStorage.removeItem("session");
        localStorage.removeItem("permissions");
        localStorage.removeItem("profileImage");
        localStorage.removeItem("colorImage");
        localStorage.removeItem("titleImage");
        localStorage.removeItem("RolesType");
        localStorage.removeItem("auth_key");
        localStorage.removeItem("merchantId");
        localStorage.removeItem("MID");
        localStorage.removeItem("isTestModeOn");
    }
}

export namespace API2 {
    @Injectable()
    export class Main {
        lastImage = localStorage.getItem("profileImage");
        fullname: string = localStorage.getItem("fullname");
        role: string = localStorage.getItem("role");
        globalpermissions = {};
        method: string = "POST";
        headers = {
            Accept: "application/json",
            "Content-Type": "text/plain"
        };

        elasticheaders = {
            "Content-Type": "application/x-ndjson",
            Authorization: "Basic " + btoa("elastic:W5fwegYyUqdm1JHmioBx")
        };

        elasticheaders2 = {
            "Content-Type": "application/json",
            Authorization: "Basic " + btoa("elastic:W5fwegYyUqdm1JHmioBx")
        };

        logout() {
            //TODO: CLean cookies
        }

        getWidget(params, cookie) {
            var merchantId = cookie.get("merchantId");
            this.elasticheaders2.Authorization = cookie.get("token");
            var valid_parameters = true;
            var options = ["1", "2", "3", "4", "5", "6"];

            if (
                params["type"] &&
                params["storeLocationId"] &&
                params["params"]
            ) {
                if (params["type"] == "all") {
                    options.forEach(option => {
                        valid_parameters = this.validate_widget(
                            option,
                            params["params"]
                        );
                    });
                } else {
                    if (options.includes(params["type"])) {
                        valid_parameters = this.validate_widget(
                            params["type"],
                            params["params"]
                        );
                    } else {
                        valid_parameters = false;
                    }
                }
                if (!valid_parameters) {
                    return this.reportError();
                } else {
                    if (params["type"] == "all") {
                        var response = this.all(
                            merchantId,
                            params["params"],
                            params["storeLocationId"]
                        );
                    } else {
                        var response = this.single(
                            merchantId,
                            params["type"],
                            params["params"]["widget" + params["type"]],
                            params["storeLocationId"]
                        );
                    }
                    return response;
                }
            } else {
                return this.reportError();
            }
        }

        validate_widget(option, params) {
            var valid_parameters = true;
            switch (option) {
                case "1":
                    if (!params["widget1"]) {
                        valid_parameters = false;
                    } else {
                        var widget1 = params["widget1"];
                        if (
                            !widget1["gte"] ||
                            !widget1["lte"] ||
                            !widget1["timeoffset"]
                        ) {
                            valid_parameters = false;
                        }
                    }
                    break;
                case "2":
                    if (!params["widget2"]) {
                        valid_parameters = false;
                    } else {
                        var widget2 = params["widget2"];
                        if (
                            !widget2["gte"] ||
                            !widget2["lte"] ||
                            !widget2["timeoffset"]
                        ) {
                            valid_parameters = false;
                        }
                    }
                    break;
                case "3":
                    if (!params["widget3"]) {
                        valid_parameters = false;
                    }
                    break;
                case "4":
                    if (!params["widget4"]) {
                        valid_parameters = false;
                    } else {
                        var widget4 = params["widget4"];
                        if (
                            !widget4["gte"] ||
                            !widget4["gte"] ||
                            !widget4["gte2"] ||
                            !widget4["lte2"] ||
                            !widget4["period"] ||
                            !widget4["timeoffset"]
                        ) {
                            valid_parameters = false;
                        }
                    }
                    break;
                case "5":
                    if (!params["widget5"]) {
                        valid_parameters = false;
                    } else {
                        var widget5 = params["widget5"];
                        if (
                            !widget5["gte"] ||
                            !widget5["lte"] ||
                            !widget5["gte2"] ||
                            !widget5["lte2"] ||
                            !widget5["categories"] ||
                            !widget5["timeoffset"]
                        ) {
                            valid_parameters = false;
                        }
                    }
                    break;
                case "6":
                    if (!params["widget6"]) {
                        valid_parameters = false;
                    } else {
                        var widget6 = params["widget6"];
                        if (
                            !widget6["gte"] ||
                            !widget6["lte"] ||
                            !widget6["timeoffset"]
                        ) {
                            valid_parameters = false;
                        }
                    }
                    break;
                default:
                    if (!params["widget1"]) {
                        valid_parameters = false;
                    } else {
                        var idget1 = params["widget1"];
                        if (
                            !widget1["gte"] ||
                            !widget1["lte"] ||
                            !widget1["timeoffset"]
                        ) {
                            valid_parameters = false;
                        }
                    }
                    break;
            }
            return valid_parameters;
        }

        single(merchantId, widget, params, storeLocationId) {
            var requests = [];
            console.log(widget);
            switch (widget) {
                case "1":
                    requests = requests.concat(
                        this.widget1_requests(
                            merchantId,
                            params,
                            storeLocationId
                        )
                    );
                    break;
                case "2":
                    requests = requests.concat(
                        this.widget2_requests(
                            merchantId,
                            params,
                            storeLocationId
                        )
                    );
                    break;
                case "3":
                    requests = requests.concat(
                        this.widget3_requests(
                            merchantId,
                            params,
                            storeLocationId
                        )
                    );
                    break;
                case "4":
                    requests = requests.concat(
                        this.widget4_requests(
                            merchantId,
                            params,
                            storeLocationId
                        )
                    );
                    break;
                case "5":
                    requests = requests.concat(
                        this.widget5_requests(
                            merchantId,
                            params,
                            storeLocationId
                        )
                    );
                    break;
                case "6":
                    requests = requests.concat(
                        this.widget6_requests(
                            merchantId,
                            params,
                            storeLocationId
                        )
                    );
                    break;
                default:
                    requests = requests.concat(
                        this.widget1_requests(
                            merchantId,
                            params,
                            storeLocationId
                        )
                    );
                    break;
            }
            return this.callReports(requests);
        }

        all(merchantId, params, storeLocationId) {
            // Main params
            var widget1 = params["widget1"]; // gte,lte
            var widget2 = params["widget2"]; // gte,lte
            var widget3 = params["widget3"]; // gte,lte
            var widget4 = params["widget4"]; // gte,lte,gte2,lte2, type
            var widget5 = params["widget5"]; // gte,lte,gte2,lte2, categories
            var widget6 = params["widget6"]; // gte,lte

            var requests = [];
            requests = requests.concat(
                this.widget1_requests(merchantId, widget1, storeLocationId)
            );
            requests = requests.concat(
                this.widget2_requests(merchantId, widget2, storeLocationId)
            );
            requests = requests.concat(
                this.widget3_requests(merchantId, widget3, storeLocationId)
            );
            requests = requests.concat(
                this.widget4_requests(merchantId, widget4, storeLocationId)
            );
            requests = requests.concat(
                this.widget5_requests(merchantId, widget5, storeLocationId)
            );
            requests = requests.concat(
                this.widget6_requests(merchantId, widget6, storeLocationId)
            );

            return this.callReports(requests);
        }

        widget1_requests(merchantId, params, storeLocationId) {
            var requests = [];
            var gte = params["gte"];
            var lte = params["lte"];
            var timeoffset = params["timeoffset"];
            var conditions =
                '[{"exists":{"field":"paymentId"}},{"bool":{"should":[{"term":{"paymentStatusId":{"value":3}}},{"term":{"paymentStatusId":{"value":4}}},{"nested":{"path":"refunds","query":{"bool":{"must":[[{"match":{"refunds.reason.keyword":"QSA"}},{"match":{"refunds.paymentStatusId": 5}}]]}}}}]}},{"term":{"merchantId":{"value": "' +
                merchantId +
                '"}}},{"range":{"@timestamp":{"gte":"' +
                gte +
                '","lte":"' +
                lte +
                '","format":"MM-dd-yyyy","time_zone": "' +
                timeoffset +
                '"}}}';
            if (storeLocationId == "*") {
                conditions = conditions + "]";
            } else {
                conditions =
                    conditions +
                    ',{"term": {"storeLocationId": {"value": "' +
                    storeLocationId +
                    '"}}}]';
            }

            if (gte == lte) {
                var lteHist = moment(lte, "MM-DD-YYYY")
                    .add(1, "days")
                    .format("MM-DD-YYYY");

                requests.push(
                    '{"index":"eatos-orders","ignore_unavailable":true}'
                );
                requests.push(
                    '{"size":0,"query":{"bool":{"must":' +
                    conditions +
                    '}},"aggs": {"gross": {"sum": {"script": "doc[\'paid\'].value + doc[\'totalDiscount\'].value - doc[\'discountNoQSA\'].value"}}}}'
                );
                requests.push(
                    '{"index":"eatos-orders","ignore_unavailable":true}'
                );
                requests.push(
                    '{"size":0,"query":{"bool":{"must":' +
                    conditions +
                    '}},"aggs":{"by_day":{"date_histogram":{"field":"@timestamp","calendar_interval":"1h","format":"MM-dd-yyyy\'T\'HH","min_doc_count":0,"time_zone": "' +
                    timeoffset +
                    '","extended_bounds":{"min":"' +
                    gte +
                    'T00","max":"' +
                    lteHist +
                    'T00"}},"aggs":{"gross":{"sum":{"script": "doc[\'paid\'].value + doc[\'totalDiscount\'].value - doc[\'discountNoQSA\'].value"}}}}}}'
                );
                return requests;
            } else {
                requests.push(
                    '{"index":"eatos-orders","ignore_unavailable":true}'
                );
                requests.push(
                    '{"size":0,"query":{"bool":{"must":' +
                    conditions +
                    '}},"aggs": {"gross": {"sum": {"script": "doc[\'paid\'].value + doc[\'totalDiscount\'].value - doc[\'discountNoQSA\'].value"}}}}'
                );
                requests.push(
                    '{"index":"eatos-orders","ignore_unavailable":true}'
                );
                requests.push(
                    '{"size":0,"query":{"bool":{"must":' +
                    conditions +
                    '}},"aggs":{"by_day":{"date_histogram":{"field":"@timestamp","calendar_interval":"day","format":"MM-dd-yyyy","min_doc_count":0,"time_zone": "' +
                    timeoffset +
                    '","extended_bounds":{"min":"' +
                    gte +
                    '","max":"' +
                    lte +
                    '"}},"aggs":{"gross":{"sum":{"script": "doc[\'paid\'].value + doc[\'totalDiscount\'].value - doc[\'discountNoQSA\'].value"}}}}}}'
                );

                return requests;
            }
        }

        widget2_requests(merchantId, params, storeLocationId) {
            var requests = [];
            var gte = params["gte"];
            var lte = params["lte"];
            var timeoffset = params["timeoffset"];
            var conditions =
                '[{"exists":{"field":"paymentId"}},{"bool":{"should":[{"term":{"paymentStatusId":{"value":3}}},{"term":{"paymentStatusId":{"value":4}}},{"nested":{"path":"refunds","query":{"bool":{"must":[[{"match":{"refunds.reason.keyword":"QSA"}},{"match":{"refunds.paymentStatusId": 5}}]]}}}}]}},{"term":{"merchantId":{"value": "' +
                merchantId +
                '"}}},{"range":{"@timestamp":{"gte":"' +
                gte +
                '","lte":"' +
                lte +
                '","format":"MM-dd-yyyy","time_zone": "' +
                timeoffset +
                '"}}}';
            if (storeLocationId == "*") {
                conditions = conditions + "]";
            } else {
                conditions =
                    conditions +
                    ',{"term": {"storeLocationId": {"value": "' +
                    storeLocationId +
                    '"}}}]';
            }
            if (gte == lte) {
                var lteHist = moment(lte, "MM-DD-YYYY")
                    .add(1, "days")
                    .format("MM-DD-YYYY");
                //echo(lteHist);
                requests.push(
                    '{"index":"eatos-orders","ignore_unavailable":true}'
                );
                requests.push(
                    '{"size":0,"query":{"bool":{"must": ' +
                    conditions +
                    '}},"aggs": {"count": {"value_count": {"field": "orderId.keyword"}}}}'
                );
                requests.push(
                    '{"index":"eatos-orders","ignore_unavailable":true}'
                );
                requests.push(
                    '{"size":0,"query":{"bool":{"must":' +
                    conditions +
                    '}},"aggs":{"by_day":{"date_histogram":{"field":"@timestamp","calendar_interval":"1h","min_doc_count":0,"format":"MM-dd-yyyy\'T\'HH","time_zone": "' +
                    timeoffset +
                    '","extended_bounds":{"min":"' +
                    gte +
                    'T00","max":"' +
                    lteHist +
                    'T00"}},"aggs":{"count":{"value_count":{"field":"orderId.keyword"}}}}}}'
                );
                return requests;
            } else {
                requests.push(
                    '{"index":"eatos-orders","ignore_unavailable":true}'
                );
                requests.push(
                    '{"size":0,"query":{"bool":{"must": ' +
                    conditions +
                    '}},"aggs": {"count": {"value_count": {"field": "orderId.keyword"}}}}'
                );
                requests.push(
                    '{"index":"eatos-orders","ignore_unavailable":true}'
                );
                requests.push(
                    '{"size":0,"query":{"bool":{"must":' +
                    conditions +
                    '}},"aggs":{"by_day":{"date_histogram":{"field":"@timestamp","calendar_interval":"day","min_doc_count":0,"format":"MM-dd-yyyy","time_zone": "' +
                    timeoffset +
                    '","extended_bounds":{"min":"' +
                    gte +
                    '","max":"' +
                    lte +
                    '"}},"aggs":{"count":{"value_count":{"field":"orderId.keyword"}}}}}}'
                );
                return requests;
            }
        }

        widget3_requests(merchantId, params, storeLocationId) {
            var requests = [];
            var conditions =
                '[{"term":{"merchantId":{"value": "' +
                merchantId +
                '"}}},{"term":{"status":{"value": 1}}}]';
            requests.push(
                '{"index":"eatos-locations","ignore_unavailable":true}'
            );
            requests.push(
                '{"size":0,"query":{"bool":{"must":' +
                conditions +
                '}},"aggs":{"by_name":{"terms":{"field":"caption.keyword","size":9999,"order":{"_count":"desc"}},"aggs":{"geohash_grid":{"geohash_grid":{"field":"coordinates"},"aggs":{"geo_centroid":{"geo_centroid":{"field":"coordinates"}}}}}}}}'
            );
            return requests;
        }

        widget4_requests(merchantId, params, storeLocationId) {
            var requests = [];
            var gte1 = params["gte"];
            var lte1 = params["lte"];
            var gte2 = params["gte2"];
            var lte2 = params["lte2"];
            var timeoffset = params["timeoffset"];
            var period = params["period"];
            var conditions1 =
                '[{"exists":{"field":"paymentId"}},{"bool":{"should":[{"term":{"paymentStatusId":{"value":3}}},{"term":{"paymentStatusId":{"value":4}}},{"nested":{"path":"refunds","query":{"bool":{"must":[[{"match":{"refunds.reason.keyword":"QSA"}},{"match":{"refunds.paymentStatusId": 5}}]]}}}}]}},{"term":{"merchantId":{"value": "' +
                merchantId +
                '"}}},{"range":{"@timestamp":{"gte":"' +
                gte1 +
                '","lte":"' +
                lte1 +
                '","format":"MM-dd-yyyy","time_zone": "' +
                timeoffset +
                '"}}}';
            var conditions2 =
                '[{"exists":{"field":"paymentId"}},{"bool":{"should":[{"term":{"paymentStatusId":{"value":3}}},{"term":{"paymentStatusId":{"value":4}}},{"nested":{"path":"refunds","query":{"bool":{"must":[[{"match":{"refunds.reason.keyword":"QSA"}},{"match":{"refunds.paymentStatusId": 5}}]]}}}}]}},{"term":{"merchantId":{"value": "' +
                merchantId +
                '"}}},{"range":{"@timestamp":{"gte":"' +
                gte2 +
                '","lte":"' +
                lte2 +
                '","format":"MM-dd-yyyy","time_zone": "' +
                timeoffset +
                '"}}}';
            if (storeLocationId == "*") {
                conditions1 = conditions1 + "]";
                conditions2 = conditions2 + "]";
            } else {
                conditions1 =
                    conditions1 +
                    ',{"term": {"storeLocationId": {"value": "' +
                    storeLocationId +
                    '"}}}]';
                conditions2 =
                    conditions2 +
                    ',{"term": {"storeLocationId": {"value": "' +
                    storeLocationId +
                    '"}}}]';
            }

            var tz = "America/Los_Angeles";
            if (period == "week") {
                requests.push(
                    '{"index":"eatos-orders","ignore_unavailable":true}'
                );
                requests.push(
                    '{"size":0,"query":{"bool":{"must":' +
                    conditions1 +
                    '}},"aggs":{"totalPrice":{"sum":{"script": "doc[\'paid\'].value + doc[\'totalDiscount\'].value - doc[\'discountNoQSA\'].value"}},"perWeekDay":{"terms":{"script":"int day = Instant.ofEpochMilli(doc[\'@timestamp\'].value.toInstant().toEpochMilli()).atZone(ZoneId.of(\'' +
                    tz +
                    "')).dayOfWeek.getValue();(day == 1 ? 'MONDAY' : (day == 2 ? 'TUESDAY' : ((day == 3 ? 'WEDNESDAY' : ((day == 4 ? 'THURSDAY' : ((day == 5 ? 'FRIDAY' : ((day == 6 ? 'SATURDAY' : 'SUNDAY'))))))))))\"},\"aggs\":{\"totalPrice\":{\"sum\":{\"script\": \"doc['paid'].value + doc['totalDiscount'].value\"}}}}}}"
                );
                requests.push(
                    '{"index":"eatos-orders","ignore_unavailable":true}'
                );
                requests.push(
                    '{"size":0,"query":{"bool":{"must":' +
                    conditions2 +
                    '}},"aggs":{"totalPrice":{"sum":{"script": "doc[\'paid\'].value + doc[\'totalDiscount\'].value - doc[\'discountNoQSA\'].value"}},"perWeekDay":{"terms":{"script":"int day = Instant.ofEpochMilli(doc[\'@timestamp\'].value.toInstant().toEpochMilli()).atZone(ZoneId.of(\'' +
                    tz +
                    "')).dayOfWeek.getValue();(day == 1 ? 'MONDAY' : (day == 2 ? 'TUESDAY' : ((day == 3 ? 'WEDNESDAY' : ((day == 4 ? 'THURSDAY' : ((day == 5 ? 'FRIDAY' : ((day == 6 ? 'SATURDAY' : 'SUNDAY'))))))))))\"},\"aggs\":{\"totalPrice\":{\"sum\":{\"script\": \"doc['paid'].value + doc['totalDiscount'].value\"}}}}}}"
                );
            } else {
                requests.push(
                    '{"index":"eatos-orders","ignore_unavailable":true}'
                );
                requests.push(
                    '{"size":0,"query":{"bool":{"must":' +
                    conditions1 +
                    '}},"aggs":{"totalPrice":{"sum":{"script": "doc[\'paid\'].value + doc[\'totalDiscount\'].value - doc[\'discountNoQSA\'].value"}},"perMonthDay":{"terms":{"script":"Instant.ofEpochMilli(doc[\'@timestamp\'].value.toInstant().toEpochMilli()).atZone(ZoneId.of(\'' +
                    tz +
                    '\')).dayOfMonth"},"aggs":{"totalPrice":{"sum":{"script": "doc[\'paid\'].value + doc[\'totalDiscount\'].value - doc[\'discountNoQSA\'].value"}}}}}}'
                );
                requests.push(
                    '{"index":"eatos-orders","ignore_unavailable":true}'
                );
                requests.push(
                    '{"size":0,"query":{"bool":{"must":' +
                    conditions2 +
                    '}},"aggs":{"totalPrice":{"sum":{"script": "doc[\'paid\'].value + doc[\'totalDiscount\'].value - doc[\'discountNoQSA\'].value"}},"perMonthDay":{"terms":{"script":"Instant.ofEpochMilli(doc[\'@timestamp\'].value.toInstant().toEpochMilli()).atZone(ZoneId.of(\'' +
                    tz +
                    '\')).dayOfMonth"},"aggs":{"totalPrice":{"sum":{"script": "doc[\'paid\'].value + doc[\'totalDiscount\'].value - doc[\'discountNoQSA\'].value"}}}}}}'
                );
            }
            return requests;
        }

        widget5_requests(merchantId, params, storeLocationId) {
            var requests = [];
            var gte1 = params["gte"];
            var lte1 = params["lte"];
            var gte2 = params["gte2"];
            var lte2 = params["lte2"];
            var timeoffset = params["timeoffset"];
            var categories = params["categories"];

            var conditions1 =
                '[{"exists":{"field":"paymentId"}},{"bool":{"should":[{"term":{"paymentStatusId":{"value":3}}},{"term":{"paymentStatusId":{"value":4}}},{"nested":{"path":"refunds","query":{"bool":{"must":[[{"match":{"refunds.reason.keyword":"QSA"}},{"match":{"refunds.paymentStatusId": 5}}]]}}}}]}},{"term":{"merchantId":{"value": "' +
                merchantId +
                '"}}},{"range":{"@timestamp":{"gte":"' +
                gte1 +
                '","lte":"' +
                lte1 +
                '","format":"MM-dd-yyyy","time_zone": "' +
                timeoffset +
                '"}}}';
            var conditions2 =
                '[{"exists":{"field":"paymentId"}},{"bool":{"should":[{"term":{"paymentStatusId":{"value":3}}},{"term":{"paymentStatusId":{"value":4}}},{"nested":{"path":"refunds","query":{"bool":{"must":[[{"match":{"refunds.reason.keyword":"QSA"}},{"match":{"refunds.paymentStatusId": 5}}]]}}}}]}},{"term":{"merchantId":{"value": "' +
                merchantId +
                '"}}},{"range":{"@timestamp":{"gte":"' +
                gte2 +
                '","lte":"' +
                lte2 +
                '","format":"MM-dd-yyyy","time_zone": "' +
                timeoffset +
                '"}}}';
            if (storeLocationId == "*") {
                conditions1 = conditions1 + "]";
                conditions2 = conditions2 + "]";
            } else {
                conditions1 =
                    conditions1 +
                    ',{"term": {"storeLocationId": {"value": "' +
                    storeLocationId +
                    '"}}}]';
                conditions2 =
                    conditions2 +
                    ',{"term": {"storeLocationId": {"value": "' +
                    storeLocationId +
                    '"}}}]';
            }
            requests.push(
                '{"index":"eatos-orders-products","ignore_unavailable":true}'
            );
            requests.push(
                '{"size": 0, "query": { "bool": {"must": ' +
                conditions1 +
                '}},"aggs":{"categories":{"terms":{"field":"product.main_category.productCategoryName.keyword","size":9999},"aggs":{"total":{"sum":{"field":"product.main_category.amount"}}}}}}'
            );
            requests.push(
                '{"index":"eatos-orders-products","ignore_unavailable":true}'
            );
            requests.push(
                '{"size": 0, "query": { "bool": {"must": ' +
                conditions2 +
                '}},"aggs":{"categories":{"terms":{"field":"product.main_category.productCategoryName.keyword","size":9999},"aggs":{"total":{"sum":{"field":"product.main_category.amount"}}}}}}'
            );
            return requests;
        }

        widget6_requests(merchantId, params, storeLocationId) {
            var requests = [];
            var gte = params["gte"];
            var lte = params["lte"];
            var timeoffset = params["timeoffset"];
            var conditions =
                '[{"exists":{"field":"paymentId"}},{"bool":{"should":[{"term":{"paymentStatusId":{"value":3}}},{"term":{"paymentStatusId":{"value":4}}},{"nested":{"path":"refunds","query":{"bool":{"must":[[{"match":{"refunds.reason.keyword":"QSA"}},{"match":{"refunds.paymentStatusId": 5}}]]}}}}]}},{"term":{"merchantId":{"value": "' +
                merchantId +
                '"}}},{"range":{"@timestamp":{"gte":"' +
                gte +
                '","lte":"' +
                lte +
                '","format":"MM-dd-yyyy","time_zone": "' +
                timeoffset +
                '"}}}';
            if (storeLocationId == "*") {
                var conditions = conditions + "]";
            } else {
                var conditions =
                    conditions +
                    ',{"term": {"storeLocationId": {"value": "' +
                    storeLocationId +
                    '"}}}]';
            }
            requests.push(
                '{"index":"eatos-orders-products","ignore_unavailable":true}'
            );
            requests.push(
                '{"size": 0,"query": {"bool": {"must": ' +
                conditions +
                '}},"aggs": {"categories": {"terms": {"field": "product.productDisplayName.keyword","size": 10,"order":{"total":"desc"}},"aggs":{"total":{"sum":{"field":"product.variants.quantity"}}}}}}'
            ); /* "aggs": {"categories": {"terms": {"field": "product.productDisplayName.keyword","size": 5}}} */
            return requests;
        }
        salestodayreport(params, cookie) {
            var merchantId = cookie.get("merchantId");
            this.elasticheaders2.Authorization = cookie.get("token");

            var requests = [];

            if (params["option"] == "pickers") {
                // OrderTypes
                requests.push(
                    '{"index":"eatos-orders","ignore_unavailable":true}'
                );
                requests.push(
                    '{"size":0,"query":{"bool":{"must":[{"match_all":{}},{"term":{"merchantId":{"value": "' +
                    merchantId +
                    '"}}}]}},"aggs":{"by_ordertypeid":{"terms":{"field":"type.id","size":9999,"order":{"_count":"desc"}},"aggs":{"by_ordertype":{"terms":{"field":"type.name.keyword","size":9999,"order":{"_count":"desc"}}}}}}}'
                );
                // Shifts
                requests.push(
                    '{"index":"eatos-orders","ignore_unavailable":true}'
                );
                requests.push(
                    '{"size":0,"query":{"bool":{"must":[{"match_all":{}},{"term":{"merchantId":{"value": "' +
                    merchantId +
                    '"}}}]}},"aggs":{"by_shiftid":{"terms":{"field":"shift.id.keyword","size":9999,"order":{"_count":"desc"}},"aggs":{"by_shift":{"terms":{"field":"shift.name.keyword","size":9999,"order":{"_count":"desc"}}}}}}}'
                );
                // PaymentStatuses
                requests.push(
                    '{"index":"eatos-orders","ignore_unavailable":true}'
                );
                requests.push(
                    '{"size":0,"query":{"bool":{"must":[{"match_all":{}},{"term":{"merchantId":{"value": "' +
                    merchantId +
                    '"}}}]}},"aggs":{"by_paymentstatusid":{"terms":{"field":"paymentStatusId","size":9999,"order":{"_count":"desc"}},"aggs":{"by_paymentstatus":{"terms":{"field":"paymentStatus.name.keyword","size":9999,"order":{"_count":"desc"}}}}}}}'
                );
                // PaymentTypes
                requests.push(
                    '{"index":"eatos-orders","ignore_unavailable":true}'
                );
                requests.push(
                    '{"size":0,"query":{"bool":{"must":[{"match_all":{}},{"term":{"merchantId":{"value": "' +
                    merchantId +
                    '"}}}]}},"aggs":{"by_paymenttypeid":{"terms":{"field":"transactionTypes.id","size":9999,"order":{"_count":"desc"}},"aggs":{"by_paymenttype":{"terms":{"field":"transactionTypes.name.keyword","size":9999,"order":{"_count":"desc"}}}}}}}'
                );
            } else {
                if (params["gte"] && params["lte"] && params["timeoffset"]) {
                    var gte = params["gte"];
                    var lte = params["lte"];
                    var lteHist = moment(lte, "DD-MM-YYYY")
                        .add(1, "days")
                        .format("DD-MM-YYYY");
                    var timeoffset = params["timeoffset"];
                    // Conditions
                    var conditions =
                        '[{"exists":{"field":"paymentId"}},{"bool":{"must_not":[{"term":{"paymentStatusId":{"value":1}}}]}},{"term":{"merchantId":{"value": "' +
                        merchantId +
                        '"}}},{"range":{"@timestamp":{"gte": "' +
                        gte +
                        '","lte":"' +
                        lte +
                        '","format":"dd-MM-yyyy","time_zone": "' +
                        timeoffset +
                        '"}}}';
                    if (params["storeLocationId"]) {
                        conditions =
                            conditions +
                            ',{"term": {"storeLocationId": {"value": "' +
                            params["storeLocationId"] +
                            '"}}}';
                    }
                    if (params["statuses"] && params["statuses"].length > 0) {
                        // statuses is an array
                        var base = '{"bool":{"should":[';
                        var statuses_sentences = [];
                        params["statuses"].forEach(status => {
                            statuses_sentences.push(
                                '{"term":{"status.id":{"value":' +
                                status +
                                "}}}"
                            );
                        });

                        base = base + statuses_sentences.join(",");
                        base = base + "]}}";
                        conditions = conditions + "," + base;
                    }
                    if (params["type"]) {
                        conditions =
                            conditions +
                            ',{"term": {"type.id": {"value": ' +
                            params["type"] +
                            "}}}";
                    }
                    if (params["shift"]) {
                        conditions =
                            conditions +
                            ',{"term": {"shift.id": {"value": "' +
                            params["shift"] +
                            '"}}}';
                    }
                    if (params["paymentStatus"]) {
                        conditions =
                            conditions +
                            ',{"term": {"paymentStatusId": {"value": ' +
                            params["paymentStatus"] +
                            "}}}";
                    }
                    if (params["transactionTypes"]) {
                        conditions =
                            conditions +
                            ',{"term": {"transactionTypes.id": {"value": ' +
                            params["transactionTypes"] +
                            "}}}";
                    }
                    conditions = conditions + "]";
                    if (params["option"] == "upside") {
                        // Total average income
                        requests.push(
                            '{"index":"eatos-orders","ignore_unavailable":true}'
                        );
                        requests.push(
                            '{"size":0,"query":{"bool":{"must": ' +
                            conditions +
                            '}},"aggs":{"totalPrice":{"avg":{"script": "doc[\'paid\'].value  + doc[\'totalDiscount\'].value - doc[\'discountNoQSA\'].value"}}}}'
                        );
                        // Total Income
                        requests.push(
                            '{"index":"eatos-orders","ignore_unavailable":true}'
                        );
                        requests.push(
                            '{"size":0,"query":{"bool":{"must": ' +
                            conditions +
                            '}},"aggs":{"totalPrice":{"sum":{"script": "doc[\'paid\'].value  + doc[\'totalDiscount\'].value - doc[\'discountNoQSA\'].value"}},"products_count":{"sum":{"field":"products.variants.quantity"}},"custom_count":{"sum":{"field":"customItems.quantity"}}}}'
                        );
                        // Total Products
                        // requests.push( '{"index":"eatos-orders","ignore_unavailable":true}');
                        // requests.push( '{"size":0,"query":{"bool":{"must": '+conditions+'}},"aggs":{"products_count":{"value_count":{"field":"products.variants.quantity"}}}}');
                        // Timeline
                        requests.push(
                            '{"index":"eatos-orders","ignore_unavailable":true}'
                        );
                        requests.push(
                            '{"size":0,"query":{"bool":{"must":' +
                            conditions +
                            '}},"aggs":{"by_hour":{"date_histogram":{"field":"@timestamp","calendar_interval":"1h","format":"dd-MM-yyyy\'T\'HH","min_doc_count":0,"extended_bounds":{"min": "' +
                            gte +
                            'T00","max": "' +
                            lteHist +
                            'T00"}},"aggs":{"totalPrice":{"sum":{"field":"paid"}}}}}}'
                        );
                        // Comps
                        requests.push(
                            '{"index":"eatos-comps","ignore_unavailable":true}'
                        );
                        requests.push(
                            '{"size":0,"query":{"bool":{"must":' +
                            conditions +
                            ',"must_not":[{"term":{"type.keyword":{"value":"Product"}}}]}},"aggs":{"reason":{"terms":{"field":"reason.keyword","size":9999},"aggs":{"total":{"sum":{"field":"amount"}}}}}}'
                        );
                        // transactions
                        requests.push(
                            '{"index":"eatos-orders","ignore_unavailable":true}'
                        );
                        requests.push(
                            '{"size":0,"query":{"bool":{"must":' +
                            conditions +
                            '}},"aggs":{"transactions":{"sum":{"field":"transactions"}},"perWeekDay":{"terms":{"script":"(doc[\'@timestamp\'].value.dayOfWeek == 1 ? \'MONDAY\' : (doc[\'@timestamp\'].value.dayOfWeek == 2 ? \'TUESDAY\' : ((doc[\'@timestamp\'].value.dayOfWeek == 3 ? \'WEDNESDAY\' : ((doc[\'@timestamp\'].value.dayOfWeek == 4 ? \'THURSDAY\' : ((doc[\'@timestamp\'].value.dayOfWeek == 5 ? \'FRIDAY\' : ((doc[\'@timestamp\'].value.dayOfWeek == 6 ? \'SATURDAY\' : \'SUNDAY\'))))))))))"},"aggs":{"transactions":{"sum":{"field":"transactions"}}}}}}'
                        );
                    } else {
                        if (
                            params["from"] &&
                            params["step"] &&
                            params["order"] &&
                            params["direction"]
                        ) {
                            // Table
                            var order = params["order"];
                            var direction = params["direction"];
                            var from = params["from"];
                            var step = params["step"];
                            requests.push(
                                '{"index":"eatos-orders","ignore_unavailable":true}'
                            );
                            requests.push(
                                '{"from": ' +
                                from +
                                ', "size": ' +
                                step +
                                ', "query":{"bool":{"must":' +
                                conditions +
                                '}},"sort":[{"' +
                                order +
                                '":{"order":"' +
                                direction +
                                '"}}]}'
                            );
                        } else {
                            if (params["order"] && params["direction"]) {
                                if (!params["size"]) params["size"] = 10
                                var order = params["order"];
                                var direction = params["direction"];
                                // Table all
                                requests.push(
                                    '{"index":"eatos-orders","ignore_unavailable":true}'
                                );
                                requests.push(
                                    '{"size": ' + params["size"] + ', "query":{"bool":{"must":' +
                                    conditions +
                                    '}},"sort":[{"' +
                                    order +
                                    '":{"order":"' +
                                    direction +
                                    '"}}]}'
                                );
                            } else {
                                return this.reportError();
                            }
                        }
                    }
                } else {
                    return this.reportError();
                }
            }
            return this.callReports(requests);
        }

        refundAndVoidsreport(params, cookie) {
            var merchantId = cookie.get("merchantId");
            this.elasticheaders2.Authorization = cookie.get("token");
            var requests = [];
            if (params["gte"] && params["lte"] && params["timeoffset"]) {
                var gte = params["gte"];
                var lte = params["lte"];
                var timeoffset = params["timeoffset"];
                // Conditions
                var conditions =
                    '[{"exists":{"field":"paymentId"}},{"bool":{"must_not":[{"term":{"paymentStatusId":{"value":1}}}]}},{"term":{"merchantId":{"value": "' +
                    merchantId +
                    '"}}},{"range":{"@timestamp":{"gte": "' +
                    gte +
                    '","lte":"' +
                    lte +
                    '","format":"dd-MM-yyyy","time_zone": "' +
                    timeoffset +
                    '"}}}';
                if (params["storeLocationId"]) {
                    conditions =
                        conditions +
                        ',{"term": {"storeLocationId": {"value": "' +
                        params["storeLocationId"] +
                        '"}}}';
                }
                if (params["statuses"] && params["statuses"].length > 0) {
                    // statuses is an array
                    var base = '{"bool":{"should":[';
                    var statuses_sentences = [];
                    params["statuses"].forEach(status => {
                        statuses_sentences.push(
                            '{"term":{"status.id":{"value":' + status + "}}}"
                        );
                    });

                    base = base + statuses_sentences.join(",");
                    base = base + "]}}";
                    conditions = conditions + "," + base;
                }
                if (params["type"]) {
                    conditions =
                        conditions +
                        ',{"term": {"type.id": {"value": ' +
                        params["type"] +
                        "}}}";
                }
                if (params["shift"]) {
                    conditions =
                        conditions +
                        ',{"term": {"shift.id": {"value": "' +
                        params["shift"] +
                        '"}}}';
                }
                conditions =
                    conditions +
                    ',{"bool":{"should":[{"term": {"paymentStatusId": {"value": 4}}},{"term": {"paymentStatusId": {"value": 5}}}]}}';
                if (params["transactionTypes"]) {
                    conditions =
                        conditions +
                        ',{"term": {"transactionTypes.id": {"value": ' +
                        params["transactionTypes"] +
                        "}}}";
                }
                conditions = conditions + "]";

                // Table
                var order = params["order"];
                var direction = params["direction"];
                var from = params["from"];
                var step = params["step"];
                requests.push(
                    '{"index":"eatos-orders","ignore_unavailable":true}'
                );
                requests.push(
                    '{"from": ' +
                    from +
                    ', "size": ' +
                    step +
                    ', "query":{"bool":{"must":' +
                    conditions +
                    '}},"sort":[{"' +
                    order +
                    '":{"order":"' +
                    direction +
                    '"}}]}'
                );
            } else {
                return this.reportError();
            }
            return this.callReports(requests);
        }
        payrollReport(params, cookie) {
            var merchantId = cookie.get("merchantId");
            this.elasticheaders2.Authorization = cookie.get("token");
            var requests = [];

            if (params["option"] == "pickers") {
                // PaymentTypes
                requests.push(
                    '{"index":"eatos-jobtypes","ignore_unavailable":true}'
                );
                requests.push(
                    '{"size":9999,"query":{"bool":{"must":[{"term":{"merchantId":{"value":"' +
                    merchantId +
                    '"}}}]}}}'
                );
                requests.push(
                    '{"index":"eatos-users","ignore_unavailable":true}'
                );
                requests.push(
                    '{"size":9999,"query":{"bool":{"must":[{"term":{"merchantId":{"value":"' +
                    merchantId +
                    '"}}}]}}}'
                );
            } else {
                if (params["gte"] && params["lte"] && params["timeoffset"]) {
                    var gte = params["gte"];
                    var lte = params["lte"];
                    var timeoffset = params["timeoffset"];
                    // Conditions
                    var conditions =
                        '[{"term":{"employee.merchantId":{"value": "' +
                        merchantId +
                        '"}}},{"term":{"status":{"value": 1}}},{"range":{"@timestamp":{"gte": "' +
                        gte +
                        '","lte":"' +
                        lte +
                        '","format":"dd-MM-yyyy","time_zone": "' +
                        timeoffset +
                        '"}}}';
                    if (params["storeLocationId"]) {
                        conditions =
                            conditions +
                            ',{"term": {"employee.storeLocationId": {"value": "' +
                            params["storeLocationId"] +
                            '"}}}';
                    }
                    if (params["jobtypes"] && params["jobtypes"].length > 0) {
                        // roles is an array
                        var base = '{"bool":{"should":[';
                        var jobtypes_sentences = [];
                        params["jobtypes"].forEach(jobtype => {
                            jobtypes_sentences.push(
                                '{"term":{"workingPart.jobTypeName.keyword":{"value":"' +
                                jobtype +
                                '"}}}'
                            );
                        });

                        base = base + jobtypes_sentences.join(",");
                        base = base + "]}}";
                        conditions = conditions + "," + base;
                    }

                    if (params["employees"] && params["employees"].length > 0) {
                        // roles is an array
                        var base = '{"bool":{"should":[';
                        var employees_sentences = [];
                        params["employees"].forEach(employee => {
                            employees_sentences.push(
                                '{"term":{"employee._id.$oid.keyword":{"value":"' +
                                employee +
                                '"}}}'
                            );
                        });

                        base = base + employees_sentences.join(",");
                        base = base + "]}}";
                        conditions = conditions + "," + base;
                    }

                    if (params["roles"] && params["roles"].length > 0) {
                        // roles is an array
                        var base = '{"bool":{"should":[';
                        var roles_sentences = [];
                        params["roles"].forEach(role => {
                            roles_sentences.push(
                                '{"term":{"employee.roleId":{"value":' +
                                role +
                                "}}}"
                            );
                        });

                        base = base + roles_sentences.join(",");
                        base = base + "]}}";
                        conditions = conditions + "," + base;
                    }
                    conditions = conditions + "]";
                    requests.push(
                        '{"index":"eatos-labor-hours-daily","ignore_unavailable":true}'
                    );
                    requests.push(
                        '{"size":0,"query":{"bool":{"must":' +
                        conditions +
                        '}},"aggs":{"employeeId":{"terms":{"field":"employee._id.$oid.keyword","size":9999},"aggs":{"jobType":{"terms":{"field":"workingPart.jobTypeName.keyword","size":9999},"aggs":{"labor":{"terms":{"field":"workingPart.startAt","size":9999},"aggs":{"startAt":{"terms":{"field":"workingPart.startAt"}},"endAt":{"terms":{"field":"workingPart.endAt"}},"name":{"terms":{"field":"employee.employeeFirstName.keyword"}},"internalEmployeeId":{"terms":{"field":"internalEmployeeId.keyword"}},"rate":{"terms":{"field":"rate"}},"department":{"terms":{"field":"department.keyword"}},"data_labors":{"nested":{"path":"data_labors"},"aggs":{"regular":{"sum":{"field":"data_labors.baseSeconds"}},"over":{"sum":{"script": "doc[\'data_labors.overSeconds\'].value + doc[\'data_labors.doubleSeconds\'].value"}},"regularPayment":{"sum":{"field":"data_labors.regPayment"}},"overPayment":{"sum":{"script": "doc[\'data_labors.overPayment\'].value + doc[\'data_labors.doublePayment\'].value"}},"cost":{"sum":{"script":"doc[\'data_labors.regPayment\'].value + doc[\'data_labors.overPayment\'].value + doc[\'data_labors.doublePayment\'].value + doc[\'data_labors.trainingPayment\'].value"}}}}}},"data_labors":{"nested":{"path":"data_labors"},"aggs":{"regular":{"sum":{"field":"data_labors.baseSeconds"}},"over":{"sum":{"script": "doc[\'data_labors.overSeconds\'].value + doc[\'data_labors.doubleSeconds\'].value"}},"regularPayment":{"sum":{"field":"data_labors.regPayment"}},"overPayment":{"sum":{"script": "doc[\'data_labors.overPayment\'].value + doc[\'data_labors.doublePayment\'].value"}},"cost":{"sum":{"script":"doc[\'data_labors.regPayment\'].value + doc[\'data_labors.overPayment\'].value + doc[\'data_labors.doublePayment\'].value + doc[\'data_labors.trainingPayment\'].value"}}}}}},"data_labors":{"nested":{"path":"data_labors"},"aggs":{"regular":{"sum":{"field":"data_labors.baseSeconds"}},"over":{"sum":{"script": "doc[\'data_labors.overSeconds\'].value + doc[\'data_labors.doubleSeconds\'].value"}},"cost":{"sum":{"script":"doc[\'data_labors.regPayment\'].value + doc[\'data_labors.overPayment\'].value + doc[\'data_labors.doublePayment\'].value + doc[\'data_labors.trainingPayment\'].value"}}}},"name":{"terms":{"field":"employee.employeeFirstName.keyword"}}}},"data_labors":{"nested":{"path":"data_labors"},"aggs":{"regular":{"sum":{"field":"data_labors.baseSeconds"}},"over":{"sum":{"script": "doc[\'data_labors.overSeconds\'].value + doc[\'data_labors.doubleSeconds\'].value"}},"cost":{"sum":{"script":"doc[\'data_labors.regPayment\'].value + doc[\'data_labors.overPayment\'].value + doc[\'data_labors.doublePayment\'].value + doc[\'data_labors.trainingPayment\'].value"}}}}}}'
                    );
                } else {
                    return this.reportError();
                }
            }
            return this.callReports(requests);
        }
        adpPayrollReport(params, cookie) {
            var merchantId = cookie.get("merchantId");
            this.elasticheaders2.Authorization = cookie.get("token");
            var requests = [];
            if (params["gte"] && params["lte"] && params["timeoffset"]) {
                var gte = params["gte"];
                var lte = params["lte"];
                var timeoffset = params["timeoffset"];
                // Conditions
                var conditions =
                    '[{"term":{"employee.merchantId":{"value": "' +
                    merchantId +
                    '"}}},{"term":{"status":{"value": 1}}},{"range":{"@timestamp":{"gte": "' +
                    gte +
                    '","lte":"' +
                    lte +
                    '","format":"dd-MM-yyyy","time_zone": "' +
                    timeoffset +
                    '"}}}';
                if (params["storeLocationId"]) {
                    conditions =
                        conditions +
                        ',{"term": {"employee.storeLocationId": {"value": "' +
                        params["storeLocationId"] +
                        '"}}}';
                }
                if (params["jobtypes"] && params["jobtypes"].length > 0) {
                    // roles is an array
                    var base = '{"bool":{"should":[';
                    var jobtypes_sentences = [];
                    params["jobtypes"].forEach(jobtype => {
                        jobtypes_sentences.push(
                            '{"term":{"workingPart.jobTypeId":{"value":"' +
                            jobtype +
                            '"}}}'
                        );
                    });
                    base = base + jobtypes_sentences.join(",");
                    base = base + "]}}";
                    conditions = conditions + "," + base;
                }

                if (params["employees"] && params["employees"].length > 0) {
                    // roles is an array
                    base = '{"bool":{"should":[';
                    var employees_sentences = [];
                    params["employees"].forEach(employee => {
                        employees_sentences.push(
                            '{"term":{"employee._id.$oid.keyword":{"value":"' +
                            employee +
                            '"}}}'
                        );
                    });
                    base = base + employees_sentences.join(",");
                    base = base + "]}}";
                    conditions = conditions + "," + base;
                }

                if (params["roles"] && params["roles"].length > 0) {
                    // roles is an array
                    base = '{"bool":{"should":[';
                    var roles_sentences = [];
                    params["roles"].forEach(role => {
                        roles_sentences.push(
                            '{"term":{"employee.roleId.keyword":{"value":"' +
                            role +
                            '"}}}'
                        );
                    });
                    base = base + roles_sentences.join(",");
                    base = base + "]}}";
                    conditions = conditions + "," + base;
                }
                conditions = conditions + "]";
                requests.push(
                    '{"index":"eatos-labor-hours-daily","ignore_unavailable":true}'
                );
                requests.push(
                    '{"size":0,"query":{"bool":{"must":' +
                    conditions +
                    '}},"aggs":{"employeeId":{"terms":{"field":"employee._id.$oid.keyword","size":9999},"aggs":{"jobType":{"terms":{"field":"workingPart.jobTypeName.keyword","size":9999},"aggs":{"internalEmployeeId":{"terms":{"field":"internalEmployeeId.keyword"}},"fileNumber":{"terms":{"field":"employee.employeeADPId.keyword"}},"department":{"terms":{"field":"employee.departmentId"}},"rate":{"terms":{"field":"employee.baseRate"}},"data_labors":{"nested":{"path":"data_labors"},"aggs":{"regular":{"sum":{"field":"data_labors.baseSeconds"}},"over":{"sum":{"script": "doc[\'data_labors.overSeconds\'].value + doc[\'data_labors.doubleSeconds\'].value"}},"jobCode":{"terms":{"field":"data_labors.jobCode.keyword"}},"regularPayment":{"sum":{"field":"data_labors.regPayment"}},"overPayment":{"sum":{"script": "doc[\'data_labors.overPayment\'].value + doc[\'data_labors.doublePayment\'].value"}},"cost":{"sum":{"script":"doc[\'data_labors.regPayment\'].value + doc[\'data_labors.overPayment\'].value + doc[\'data_labors.trainingPayment\'].value"}}}}}}}}}}'
                );
            } else {
                return this.reportError();
            }
            return this.callReports(requests);
        }

        saleshistoric(params, cookie) {
            var merchantId = cookie.get("merchantId");
            this.elasticheaders2.Authorization = cookie.get("token");
            var requests = [];

            if (params["option"] == "pickers") {
                // PaymentTypes
                requests.push(
                    '{"index":"eatos-orders","ignore_unavailable":true}'
                );
                requests.push(
                    '{"size":0,"query":{"bool":{"must":[{"match_all":{}},{"term":{"merchantId":{"value": "' +
                    merchantId +
                    '"}}}]}},"aggs":{"by_paymenttypeid":{"terms":{"field":"transactionTypes.id","size":9999,"order":{"_count":"desc"}},"aggs":{"by_paymenttype":{"terms":{"field":"transactionTypes.name.keyword","size":9999,"order":{"_count":"desc"}}}}}}}'
                );
            } else {
                if (params["gte"] && params["lte"] && params["timeoffset"]) {
                    var gte = params["gte"];
                    var lte = params["lte"];
                    var timeoffset = params["timeoffset"];
                    // Conditions
                    var conditions =
                        '[{"exists":{"field":"paymentId"}},{"bool":{"must_not":[{"term":{"paymentStatusId":{"value":1}}}]}},{"term":{"merchantId":{"value": "' +
                        merchantId +
                        '"}}},{"range":{"@timestamp":{"gte": "' +
                        gte +
                        '","lte":"' +
                        lte +
                        '","format":"dd-MM-yyyy","time_zone": "' +
                        timeoffset +
                        '"}}}';
                    if (params["storeLocationId"]) {
                        conditions =
                            conditions +
                            ',{"term": {"storeLocationId": {"value": "' +
                            params["storeLocationId"] +
                            '"}}}';
                    }
                    if (params["type"]) {
                        conditions =
                            conditions +
                            ',{"term": {"type.id": {"value": ' +
                            params["type"] +
                            "}}}";
                    }
                    if (params["transactionTypes"]) {
                        conditions =
                            conditions +
                            ',{"term": {"transactionTypes.id": {"value": ' +
                            params["transactionTypes"] +
                            "}}}";
                    }
                    if (params["paymentStatus"]) {
                        conditions =
                            conditions +
                            ',{"term": {"paymentStatusId": {"value": ' +
                            params["paymentStatus"] +
                            "}}}";
                    }
                    if (params["statuses"] && params["statuses"].lenth > 0) {
                        // statuses is an array
                        var base = '{"bool":{"should":[';
                        var statuses_sentences = [];
                        params["statuses"].forEach(status => {
                            statuses_sentences.push(
                                '{"term":{"status.id":{"value":' +
                                status +
                                "}}}"
                            );
                        });

                        base = base + statuses_sentences.join(",");
                        base = base + "]}}";
                        conditions = conditions + "," + base;
                    }
                    if (params["customerOrigin"]) {
                        if (params["customerOrigin"] == "New") {
                            conditions =
                                conditions +
                                ',{"term": {"RepeatedCustomer": {"value": 0}}}';
                        } else {
                            conditions =
                                conditions +
                                ',{"term": {"NewCustomer": {"value": 0}}}';
                        }
                    }
                    conditions = conditions + "]";
                    // Total average income
                    requests.push(
                        '{"index":"eatos-orders","ignore_unavailable":true}'
                    );
                    requests.push(
                        '{"size":0,"query":{"bool":{"must":' +
                        conditions +
                        "}},\"aggs\":{\"totalPrice\":{\"avg\":{\"script\": \"doc['paid'].value + doc['totalDiscount'].value - doc['discountNoQSA'].value\"}},\"perWeekDay\":{\"terms\":{\"script\":\"(doc['@timestamp'].value.dayOfWeek == 1 ? 'MONDAY' : (doc['@timestamp'].value.dayOfWeek == 2 ? 'TUESDAY' : ((doc['@timestamp'].value.dayOfWeek == 3 ? 'WEDNESDAY' : ((doc['@timestamp'].value.dayOfWeek == 4 ? 'THURSDAY' : ((doc['@timestamp'].value.dayOfWeek == 5 ? 'FRIDAY' : ((doc['@timestamp'].value.dayOfWeek == 6 ? 'SATURDAY' : 'SUNDAY'))))))))))\"},\"aggs\":{\"totalPrice\":{\"avg\":{\"script\": \"doc['paid'].value + doc['totalDiscount'].value\"}}}}}}"
                    );
                    // Total Income
                    requests.push(
                        '{"index":"eatos-orders","ignore_unavailable":true}'
                    );
                    requests.push(
                        '{"size":0,"query":{"bool":{"must":' +
                        conditions +
                        "}},\"aggs\":{\"totalPrice\":{\"sum\":{\"script\": \"doc['paid'].value + doc['totalDiscount'].value - doc['discountNoQSA'].value\"}},\"perWeekDay\":{\"terms\":{\"script\":\"(doc['@timestamp'].value.dayOfWeek == 1 ? 'MONDAY' : (doc['@timestamp'].value.dayOfWeek == 2 ? 'TUESDAY' : ((doc['@timestamp'].value.dayOfWeek == 3 ? 'WEDNESDAY' : ((doc['@timestamp'].value.dayOfWeek == 4 ? 'THURSDAY' : ((doc['@timestamp'].value.dayOfWeek == 5 ? 'FRIDAY' : ((doc['@timestamp'].value.dayOfWeek == 6 ? 'SATURDAY' : 'SUNDAY'))))))))))\"},\"aggs\":{\"totalPrice\":{\"sum\":{\"script\": \"doc['paid'].value + doc['totalDiscount'].value\"}}}}}}"
                    );
                    // Transactions
                    requests.push(
                        '{"index":"eatos-orders","ignore_unavailable":true}'
                    );
                    requests.push(
                        '{"size":0,"query":{"bool":{"must":' +
                        conditions +
                        '}},"aggs":{"transactions":{"sum":{"field":"transactions"}},"perWeekDay":{"terms":{"script":"(doc[\'@timestamp\'].value.dayOfWeek == 1 ? \'MONDAY\' : (doc[\'@timestamp\'].value.dayOfWeek == 2 ? \'TUESDAY\' : ((doc[\'@timestamp\'].value.dayOfWeek == 3 ? \'WEDNESDAY\' : ((doc[\'@timestamp\'].value.dayOfWeek == 4 ? \'THURSDAY\' : ((doc[\'@timestamp\'].value.dayOfWeek == 5 ? \'FRIDAY\' : ((doc[\'@timestamp\'].value.dayOfWeek == 6 ? \'SATURDAY\' : \'SUNDAY\'))))))))))"},"aggs":{"transactions":{"sum":{"field":"transactions"}}}}}}'
                    );
                    // Timeline
                    requests.push(
                        '{"index":"eatos-orders","ignore_unavailable":true}'
                    );
                    requests.push(
                        '{"size":0,"query":{"bool":{"must":' +
                        conditions +
                        '}},"aggs":{"by_day":{"date_histogram":{"field":"@timestamp","calendar_interval":"day","format":"dd-MM-yyyy","min_doc_count":0,"extended_bounds":{"min":"' +
                        gte +
                        '","max":"' +
                        lte +
                        '"}},"aggs":{"totalPrice":{"sum":{"script": "doc[\'paid\'].value + doc[\'totalDiscount\'].value - doc[\'discountNoQSA\'].value"}}}}}}'
                    );
                    // Table
                    requests.push(
                        '{"index":"eatos-orders","ignore_unavailable":true}'
                    );
                    requests.push(
                        '{"size":0,"query":{"bool":{"must":' +
                        conditions +
                        '}},"aggs":{"by_day":{"date_histogram":{"field":"@timestamp","calendar_interval":"day","min_doc_count":1},"aggs":{"total":{"sum":{"script": "doc[\'paid\'].value + doc[\'totalDiscount\'].value - doc[\'discountNoQSA\'].value"}},"average":{"avg":{"script": "doc[\'paid\'].value + doc[\'totalDiscount\'].value - doc[\'discountNoQSA\'].value"}},"transactionsCount":{"sum":{"field":"transactions"}},"NewCustomerTotal":{"sum":{"field":"NewCustomer"}},"RepeatedCustomerTotal":{"sum":{"field":"RepeatedCustomer"}}}}}}'
                    );
                } else {
                    return this.reportError();
                }
            }
            return this.callReports(requests);
        }

        productmixreport(params, cookie) {
            var merchantId = cookie.get("merchantId");
            this.elasticheaders2.Authorization = cookie.get("token");
            var requests = [];

            if (params["option"] == "pickers") {
                // Courses
                requests.push(
                    '{"index":"eatos-orders-products","ignore_unavailable":true}'
                );
                requests.push(
                    '{"size":0,"query":{"bool":{"must":[{"term":{"merchantId":{"value":"' +
                    merchantId +
                    '"}}}]}},"aggs":{"course":{"terms":{"field":"product.categories.courseName.keyword","size":9999}}}}'
                );
                // Courses
                requests.push(
                    '{"index":"eatos-orders-products","ignore_unavailable":true}'
                );
                requests.push(
                    '{"size":0,"query":{"bool":{"must":[{"term":{"merchantId":{"value":"' +
                    merchantId +
                    '"}}}]}},"aggs":{"category":{"terms":{"field":"product.categories.productCategoryName.keyword","size":9999}}}}'
                );
                // Menus
                requests.push(
                    '{"index":"eatos-orders-products","ignore_unavailable":true}'
                );
                requests.push(
                    '{"size":0,"query":{"bool":{"must":[{"term":{"merchantId":{"value":"' +
                    merchantId +
                    '"}}}]}},"aggs":{"menus":{"terms":{"field":"product.menu.name.keyword","size":9999},"aggs":{"name":{"terms":{"field":"product.menu.name.keyword","size":9999}}}}}}'
                );
            } else {
                if (params["gte"] && params["lte"] && params["timeoffset"]) {
                    var gte = params["gte"];
                    var lte = params["lte"];
                    var timeoffset = params["timeoffset"];
                    // Conditions
                    var tips =
                        '[{"term":{"paymentStatusId":{"value":3}}},{"term":{"paymentStatusId":{"value":4}}},{"nested":{"path":"refunds","query":{"bool":{"must":[{"match":{"refunds.reason.keyword":"QSA"}},{"match":{"refunds.paymentStatusId": 5}}]}}}}]';

                    var conditions =
                        '[{"exists":{"field":"paymentId"}},{"bool":{"should":' +
                        tips +
                        '}},{"term":{"merchantId":{"value": "' +
                        merchantId +
                        '"}}},{"range":{"@timestamp":{"gte": "' +
                        gte +
                        '","lte":"' +
                        lte +
                        '","format":"dd-MM-yyyy","time_zone": "' +
                        timeoffset +
                        '"}}}';
                    if (params["storeLocationId"]) {
                        conditions =
                            conditions +
                            ',{"term": {"storeLocationId": {"value": "' +
                            params["storeLocationId"] +
                            '"}}}';
                    }
                    if (params["course"]) {
                        conditions =
                            conditions +
                            ',{"term": {"product.categories.courseName.keyword": {"value": "' +
                            params["course"] +
                            '"}}}';
                    }
                    if (params["category"]) {
                        conditions =
                            conditions +
                            ',{"term": {"product.categories.productCategoryName.keyword": {"value": "' +
                            params["category"] +
                            '"}}}';
                    }
                    if (params["menu"]) {
                        conditions =
                            conditions +
                            ',{"term": {"product.menu.name.keyword": {"value": "' +
                            params["menu"] +
                            '"}}}';
                    }
                    conditions = conditions + "]";
                    // Table
                    requests.push(
                        '{"index":"eatos-orders-products","ignore_unavailable":true}'
                    );
                    requests.push(
                        '{"size":0,"query":{"bool":{"must":' +
                        conditions +
                        '}},"aggs":{"menu_id":{"terms":{"field":"product.menu.name.keyword"},"aggs":{"menu":{"terms":{"field":"product.menu.name.keyword"},"aggs":{"total":{"sum":{"field":"product.price"}},"category_id":{"terms":{"field":"product.categories.productCategoryId.keyword"},"aggs":{"category_name":{"terms":{"field":"product.categories.productCategoryName.keyword"},"aggs":{"total":{"sum":{"field":"product.price"}},"product":{"terms":{"field":"product.productId.keyword"},"aggs":{"name":{"terms":{"field":"product.productDisplayName.keyword"}},"price":{"avg":{"field":"product.price"}},"total":{"sum":{"field":"product.price"}},"quantity":{"sum":{"field":"product.variants.quantity"}},"discounts":{"sum":{"field":"discount"}},"adjustments":{"sum":{"field":"adjustments"}},"course":{"terms":{"field":"product.categories.courseName.keyword"}}}}}}}}}}}}}}'
                    );
                } else {
                    return this.reportError();
                }
            }
            return this.callReports(requests);
        }

        categoriesmix(params, cookie) {
            var merchantId = cookie.get("merchantId");
            this.elasticheaders2.Authorization = cookie.get("token");
            var requests = [];
            if (params["gte"] && params["lte"] && params["timeoffset"]) {
                var gte = params["gte"];
                var lte = params["lte"];
                var timeoffset = params["timeoffset"];
                // Conditions
                var tips =
                    '[{"term":{"paymentStatusId":{"value":3}}},{"term":{"paymentStatusId":{"value":4}}},{"nested":{"path":"refunds","query":{"bool":{"must":[{"match":{"refunds.reason.keyword":"QSA"}},{"match":{"refunds.paymentStatusId": 5}}]}}}}]';

                var conditions =
                    '[{"exists":{"field":"paymentId"}},{"bool":{"should":' +
                    tips +
                    '}},{"term":{"merchantId":{"value": "' +
                    merchantId +
                    '"}}},{"range":{"@timestamp":{"gte": "' +
                    gte +
                    '","lte":"' +
                    lte +
                    '","format":"dd-MM-yyyy","time_zone": "' +
                    timeoffset +
                    '"}}}';
                if (params["storeLocationId"]) {
                    conditions =
                        conditions +
                        ',{"term": {"storeLocationId": {"value": "' +
                        params["storeLocationId"] +
                        '"}}}';
                }
                conditions = conditions + "]";
                // Table
                requests.push(
                    '{"index":"eatos-orders-products","ignore_unavailable":true}'
                );
                requests.push(
                    '{"size":0,"query":{"bool":{"must":' +
                    conditions +
                    '}},"aggs":{"menu_id":{"terms":{"field":"product.menu.name.keyword","size":9999},"aggs":{"menu":{"terms":{"field":"product.menu.name.keyword","size":9999},"aggs":{"total":{"sum":{"field":"total"}},"category_id":{"terms":{"field":"product.categories.productCategoryId.keyword","size":9999},"aggs":{"category_name":{"terms":{"field":"product.categories.productCategoryName.keyword","size":9999},"aggs":{"total":{"sum":{"field":"total"}},"quantity":{"sum":{"field":"product.variants.quantity"}},"discounts":{"sum":{"field":"discount"}},"adjustments":{"sum":{"field":"adjustments"}}}}}}}}}}}}'
                );
            } else {
                return this.reportError();
            }

            return this.callReports(requests);
        }

        comps(params, cookie) {
            var merchantId = cookie.get("merchantId");
            this.elasticheaders2.Authorization = cookie.get("token");
            var requests = [];
            if (params["option"] == "pickers") {
                // Reasons
                requests.push(
                    '{"index":"eatos-comps","ignore_unavailable":true}'
                );
                requests.push(
                    '{"size":0,"query":{"bool":{"must":[{"term":{"merchantId":{"value": "' +
                    merchantId +
                    '"}}}]}},"aggs":{"by_reason":{"terms":{"field":"reason.keyword","size":9999}}}}'
                );
                // Servers
                requests.push(
                    '{"index":"eatos-users","ignore_unavailable":true}'
                );
                requests.push(
                    '{"size":9999,"query":{"bool":{"must":[{"term":{"merchantId":{"value":"' +
                    merchantId +
                    '"}}}]}}}'
                );
                // Authorizer
                requests.push(
                    '{"index":"eatos-users","ignore_unavailable":true}'
                );
                requests.push(
                    '{"size":9999,"query":{"bool":{"must":[{"term":{"merchantId":{"value":"' +
                    merchantId +
                    '"}}}]}}}'
                );
            } else {
                if (params["gte"] && params["lte"] && params["timeoffset"]) {
                    var gte = params["gte"];
                    var lte = params["lte"];
                    var timeoffset = params["timeoffset"];
                    // Conditions
                    var tips =
                        '[{"term":{"paymentStatusId":{"value":3}}},{"term":{"paymentStatusId":{"value":4}}},{"nested":{"path":"refunds","query":{"bool":{"must":[{"match":{"refunds.reason.keyword":"QSA"}},{"match":{"refunds.paymentStatusId": 5}}]}}}}]';

                    var conditions =
                        '[{"term":{"merchantId":{"value": "' +
                        merchantId +
                        '"}}},{"bool":{"should":' +
                        tips +
                        '}},{"range":{"@timestamp":{"gte": "' +
                        gte +
                        '","lte":"' +
                        lte +
                        '","format":"dd-MM-yyyy","time_zone": "' +
                        timeoffset +
                        '"}}}';
                    if (params["storeLocationId"]) {
                        conditions =
                            conditions +
                            ',{"term": {"storeLocationId": {"value": "' +
                            params["storeLocationId"] +
                            '"}}}';
                    }
                    if (params["reason"]) {
                        conditions =
                            conditions +
                            ',{"term": {"reason.keyword": {"value": "' +
                            params["reason"] +
                            '"}}}';
                    }
                    if (params["server"]) {
                        conditions =
                            conditions +
                            ',{"term": {"server.id": {"value": "' +
                            params["server"] +
                            '"}}}';
                    }
                    if (params["authorizer"]) {
                        conditions =
                            conditions +
                            ',{"term": {"authorizer.id": {"value": ' +
                            params["authorizer"] +
                            "}}}";
                    }
                    conditions = conditions + "]";
                    if (params["option"] == "upside") {
                        // Total Quantity
                        requests.push(
                            '{"index":"eatos-comps","ignore_unavailable":true}'
                        );
                        requests.push(
                            '{"size":0,"query":{"bool":{"must":' +
                            conditions +
                            '}},"aggs":{}}'
                        );
                        // Total Amount
                        requests.push(
                            '{"index":"eatos-comps","ignore_unavailable":true}'
                        );
                        requests.push(
                            '{"size":0,"query":{"bool":{"must":' +
                            conditions +
                            '}},"aggs":{"by_total":{"sum":{"field":"amount"}}}}'
                        );
                        // By Reason Bar
                        requests.push(
                            '{"index":"eatos-comps","ignore_unavailable":true}'
                        );
                        requests.push(
                            '{"size":0,"query":{"bool":{"must":' +
                            conditions +
                            '}},"aggs":{"by_reason":{"terms":{"field":"reason.keyword","size":5, "order":{"total":"desc"}},"aggs":{"total":{"sum":{"field":"amount"}}}}}}'
                        );
                        // By Server Bar
                        requests.push(
                            '{"index":"eatos-comps","ignore_unavailable":true}'
                        );
                        requests.push(
                            '{"size":0,"query":{"bool":{"must":' +
                            conditions +
                            '}},"aggs":{"by_server":{"terms":{"field":"server.name.keyword","size":5, "order":{"total":"desc"}},"aggs":{"total":{"sum":{"field":"amount"}}}}}}'
                        );
                        // By Authorizer Bar
                        requests.push(
                            '{"index":"eatos-comps","ignore_unavailable":true}'
                        );
                        requests.push(
                            '{"size":0,"query":{"bool":{"must":' +
                            conditions +
                            '}},"aggs":{"by_authorizer":{"terms":{"field":"authorizer.name.keyword","size":5, "order":{"total":"desc"}},"aggs":{"total":{"sum":{"field":"amount"}}}}}}'
                        );
                    } else {
                        if (
                            params["from"] &&
                            params["step"] &&
                            params["order"] &&
                            params["direction"]
                        ) {
                            // Table
                            var order = params["order"];
                            var direction = params["direction"];
                            var from = params["from"];
                            var step = params["step"];
                            requests.push(
                                '{"index":"eatos-comps","ignore_unavailable":true}'
                            );
                            requests.push(
                                '{"from": ' +
                                from +
                                ', "size": ' +
                                step +
                                ', "query":{"bool":{"must":' +
                                conditions +
                                '}},"sort":[{"' +
                                order +
                                '":{"order":"' +
                                direction +
                                '"}}]}'
                            );
                        } else {
                            if (params["order"] && params["direction"]) {
                                order = params["order"];
                                direction = params["direction"];
                                // Table all
                                requests.push(
                                    '{"index":"eatos-comps","ignore_unavailable":true}'
                                );
                                requests.push(
                                    '{"size": 9999, "query":{"bool":{"must":' +
                                    conditions +
                                    '}},"sort":[{"' +
                                    order +
                                    '":{"order":"' +
                                    direction +
                                    '"}}]}'
                                );
                            } else {
                                return this.reportError();
                            }
                        }
                    }
                } else {
                    return this.reportError();
                }
            }
            return this.callReports(requests);
        }

        employeesreport(params, cookie) {
            var merchantId = cookie.get("merchantId");
            this.elasticheaders2.Authorization = cookie.get("token");
            var requests = [];
            if (params["option"] == "pickers") {
                // PaymentTypes
                requests.push(
                    '{"index":"eatos-jobtypes","ignore_unavailable":true}'
                );
                requests.push(
                    '{"size":9999,"query":{"bool":{"must":[{"term":{"merchantId":{"value":"' +
                    merchantId +
                    '"}}},{"range": {"seconds": {"gt": 0}}}]}}}'
                );
            } else {
                if (params["gte"] && params["lte"]) {
                    var gte = params["gte"];
                    var lte = params["lte"];
                    var regseconds = "'jobtypes.regseconds'";
                    var overtimeseconds = "'jobtypes.overtimeseconds'";
                    var doubletimeseconds = "'jobtypes.doubletimeseconds'";
                    var regpayment = "'jobtypes.regpayment'";
                    var overtimepayment = "'jobtypes.overtimepayment'";
                    var doubletimepayment = "'jobtypes.doubletimepayment'";
                    var totalPrice = "'regseconds'";
                    var declaredTips = "'regseconds'";
                    var cashTips = "'regseconds'";

                    // "field": "regseconds"
                    // Conditions
                    var conditions =
                        '[{"term":{"merchantId.keyword":{"value": "' +
                        merchantId +
                        '"}}},{"range":{"@timestamp":{"gte": "' +
                        gte +
                        '","lte":"' +
                        lte +
                        '","format":"dd-MM-yyyy"}}},{"range": {"seconds": {"gt": 0}}}';
                    if (params["storeLocationId"]) {
                        conditions =
                            conditions +
                            ',{"term": {"storeLocationId.keyword": {"value": "' +
                            params["storeLocationId"] +
                            '"}}}';
                    }
                    if (params["jobType"]) {
                        conditions =
                            conditions +
                            ',{"nested":{"path":"jobtypes","query":{"term":{"jobtypes.jobType.name.keyword":{"value":"' +
                            params["jobType"] +
                            '"}}}}}';
                    }
                    conditions = conditions + "]";
                    // For Barchart and table
                    requests.push(
                        '{"index":"eatos-labor-hours,eatos-labor-sales","ignore_unavailable":true}'
                    );
                    requests.push(
                        '{"size":0,"query":{"bool":{"must":' +
                        conditions +
                        '}},"aggs":{"by_employee":{"terms":{"field":"employee._id.$oid.keyword","size":9999},"aggs":{"name":{"terms":{"field":"employee.employeeFirstName.keyword","size":9999}},"jobtypes":{"nested":{"path":"jobtypes"},"aggs":{"employee_jobs":{"terms":{"field":"jobtypes.jobType.name.keyword","size":9999}}}},"regseconds":{"nested":{"path":"jobtypes"},"aggs":{"regseconds":{"sum":{"script":{"source":"doc[' +
                        regseconds +
                        "].value > 0 ? doc[" +
                        regseconds +
                        '].value:0"}}}}},"overtimeseconds":{"nested":{"path":"jobtypes"},"aggs":{"overtimeseconds":{"sum":{"script":{"source":"doc[' +
                        overtimeseconds +
                        "].value + doc[" +
                        doubletimeseconds +
                        '].value"}}}}}, "regpayment":{"nested":{"path":"jobtypes"},"aggs":{"regpayment":{"sum":{"script":{"source":"doc[' +
                        regpayment +
                        "].value > 0 ? doc[" +
                        regpayment +
                        '].value:0"}}}}},"overtimepayment":{"nested":{"path":"jobtypes"},"aggs":{"overtimepayment":{"sum":{"script":{"source":"doc[' +
                        overtimepayment +
                        "].value + doc[" +
                        doubletimepayment +
                        '].value"}}}}},"totalPrice":{"sum":{"field":"paid"}},"declaredTips": {"sum": {"field": "declaredTips"}},"cashTips": {"sum": {"field": "cashTips"}},"cardTips": {"sum": {"field": "cardTips"}}}}}}'
                    );
                } else {
                    return this.reportError();
                }
            }
            return this.callReports(requests);
        }

        rolesreport(params, cookie) {
            var merchantId = cookie.get("merchantId");
            this.elasticheaders2.Authorization = cookie.get("token");
            var requests = [];
            if (params["gte"] && params["lte"]) {
                var gte = params["gte"];
                var lte = params["lte"];
                var seconds = "'jobtypes.seconds'";
                var regseconds = "'jobtypes.regseconds'";
                var overtimeseconds = "'jobtypes.overtimeseconds'";
                var regpayment = "'jobtypes.regpayment'";
                var overtimepayment = "'jobtypes.overtimepayment'";
                // Conditions
                var conditions =
                    '[{"term":{"merchantId.keyword":{"value": "' +
                    merchantId +
                    '"}}},{"range":{"@timestamp":{"gte": "' +
                    gte +
                    '","lte":"' +
                    lte +
                    '","format":"dd-MM-yyyy"}}}';
                if (params["storeLocationId"]) {
                    conditions =
                        conditions +
                        ',{"term": {"storeId.keyword": {"value": "' +
                        params["storeLocationId"] +
                        '"}}}';
                }
                conditions = conditions + "]";
                // For Graph
                requests.push(
                    '{"index":"eatos-labor-hours","ignore_unavailable":true}'
                );
                requests.push(
                    '{"size":0,"query":{"bool":{"must":' +
                    conditions +
                    '}},"aggs":{"in_days":{"date_histogram":{"field":"@timestamp","calendar_interval":"day","format":"dd-MM-yyyy","min_doc_count":0,"extended_bounds":{"min":"' +
                    gte +
                    '","max":"' +
                    lte +
                    '"}},"aggs":{"jobtypes":{"nested":{"path":"jobtypes"},"aggs":{"id":{"terms":{"field":"jobtypes.jobType.employeeRoleName.keyword","size":9999},"aggs":{"name":{"terms":{"field":"jobtypes.jobType.employeeRoleName.keyword","size":9999}},"seconds":{"sum":{"script":{"source":"doc[' +
                    seconds +
                    "].value > 0 ? doc[" +
                    seconds +
                    '].value : 0"}}}}}}}}}}}'
                );
                // For Tables
                requests.push(
                    '{"index":"eatos-labor-hours,eatos-labor-sales","ignore_unavailable":true}'
                );
                requests.push(
                    '{"size":300,"query":{"bool":{"must":' +
                    conditions +
                    '}},"aggs":{"nestes_jobtypes":{"nested":{"path":"jobtypes"}, "aggs":{"id":{"terms":{"field":"jobtypes.jobType.employeeRoleName.keyword","size":9999}, "aggs":{"name":{"terms":{"field":"jobtypes.jobType.employeeRoleName.keyword","size":9999}}, "seconds": {"sum": {"script":{"source":"doc[' +
                    seconds +
                    "].value > 0 ? doc[" +
                    seconds +
                    '].value : 0"}}}, "regseconds":{"sum":{"script":{"source":"doc[' +
                    regseconds +
                    "].value > 0 ? doc[" +
                    regseconds +
                    '].value : 0"}}}, "overtimeseconds":{"sum":{"script":{"source":"doc[' +
                    overtimeseconds +
                    "].value > 0 ? doc[" +
                    overtimeseconds +
                    '].value : 0"}}}, "regpayment":{"sum":{"script":{"source":"doc[' +
                    regpayment +
                    "].value > 0 ? doc[" +
                    regpayment +
                    '].value : 0"}}},"overtimepayment":{"sum":{"script":{"source":"doc[' +
                    overtimepayment +
                    "].value > 0 ? doc[" +
                    overtimepayment +
                    '].value : 0"}}},"totalPrice":{"sum":{"field":"jobtypes.totalPrice"}}, "cashTips":{"sum":{"field":"jobtypes.cashTips"}},"cardTips":{"sum":{"field":"jobtypes.cardTips"}},"allTips":{"sum":{"field":"jobtypes.allTips"}}}}}}}}'
                );
            } else {
                return this.reportError();
            }
            return this.callReports(requests);
        }

        async dailyoperatingreport(params, cookie) {
            var merchantId = cookie.get("merchantId");
            this.elasticheaders2.Authorization = cookie.get("token");
            var requests = [];
            if (
                params["gte"] &&
                params["lte"] &&
                params["prev_gte"] &&
                params["prev_lte"] &&
                params["month_gte"] &&
                params["month_lte"] &&
                params["month_ly_gte"] &&
                params["month_ly_lte"] &&
                params["ly_gte"] &&
                params["ly_lte"]
            ) {
                var gte = params["gte"]; //Week
                var lte = params["lte"]; //Week
                var prev_gte = params["prev_gte"];
                var prev_lte = params["prev_lte"];
                var month_gte = params["month_gte"];
                var month_lte = params["month_lte"];
                var month_ly_gte = params["month_ly_gte"];
                var month_ly_lte = params["month_ly_lte"];
                var ly_gte = params["ly_gte"];
                var ly_lte = params["ly_lte"];
                var mon_gte = params["mon_gte"];
                var mon_lte = params["mon_lte"];
                var tue_gte = params["tue_gte"];
                var tue_lte = params["tue_lte"];
                var wed_gte = params["wed_gte"];
                var wed_lte = params["wed_lte"];
                var thu_gte = params["thu_gte"];
                var thu_lte = params["thu_lte"];
                var fri_gte = params["fri_gte"];
                var fri_lte = params["fri_lte"];
                var sat_gte = params["sat_gte"];
                var sat_lte = params["sat_lte"];
                var sun_gte = params["sun_gte"];
                var sun_lte = params["sun_lte"];
                var time_zone = params["time_zone"];
                var gte_f = params["gte_f"];
                var lte_f = params["lte_f"];
                var gte_labor = params["gte_labor"];
                var custom_gte = params["custom_gte"];
                var custom_lte = params["custom_lte"];
                var custom_gte_format = params["custom_gte_format"];
                var custom_lte_format = params["custom_lte_format"];
                var custom_lte_format2 = params["custom_lte_format2"];
                var tipsIncluded = params["tipsIncluded"]; //True or false; 0 or 1

                //Do you want gross (Tip==1) 0r Net (Tip==0)
                if (tipsIncluded) {
                    var tips =
                        '[{"term":{"paymentStatusId":{"value":3}}},{"term":{"paymentStatusId":{"value":4}}},{"nested":{"path":"refunds","query":{"bool":{"must":[{"match":{"refunds.reason.keyword":"QSA"}},{"match":{"refunds.paymentStatusId": 5}}]}}}}]';
                } else {
                    var tips =
                        '[{"term":{"paymentStatusId":{"value":3}}},{"term":{"paymentStatusId":{"value":4}}},{"nested":{"path":"refunds","query":{"bool":{"must":[{"match":{"refunds.reason.keyword":"QSA"}},{"match":{"refunds.paymentStatusId": 5}}]}}}}]';
                }

                var conditionsGross =
                    '[{"exists":{"field":"paymentId"}},{"bool":{"should":' +
                    tips +
                    '}},{"term":{"merchantId":{"value": "' +
                    merchantId +
                    '"}}},{"range":{"@timestamp":{"gte": ' +
                    custom_gte +
                    ',"lte":' +
                    custom_lte +
                    "}}}";
                if (params["storeLocationId"]) {
                    conditionsGross =
                        conditionsGross +
                        ',{"term": {"storeLocationId": {"value": "' +
                        params["storeLocationId"] +
                        '"}}}';
                }
                conditionsGross = conditionsGross + "]";
                // Conditions
                var conditions =
                    '[{"exists":{"field":"paymentId"}},{"bool":{"should":[{"term":{"paymentStatusId":{"value":3}}},{"term":{"paymentStatusId":{"value":4}}},{"nested":{"path":"refunds","query":{"bool":{"must":[[{"match":{"refunds.reason.keyword":"QSA"}},{"match":{"refunds.paymentStatusId": 5}}]]}}}}]}},{"term":{"merchantId":{"value": "' +
                    merchantId +
                    '"}}},{"range":{"@timestamp":{"gte": "' +
                    custom_gte +
                    '","lte":"' +
                    custom_lte +
                    '"}}}';
                if (params["storeLocationId"]) {
                    conditions =
                        conditions +
                        ',{"term": {"storeLocationId": {"value": "' +
                        params["storeLocationId"] +
                        '"}}}';
                }
                conditions = conditions + "]";
                var conditions2 =
                    '[{"exists":{"field":"paymentId"}},{"bool":{"should":[{"term":{"paymentStatusId":{"value":3}}},{"term":{"paymentStatusId":{"value":4}}},{"nested":{"path":"refunds","query":{"bool":{"must":[[{"match":{"refunds.reason.keyword":"QSA"}},{"match":{"refunds.paymentStatusId": 5}}]]}}}}]}},{"term":{"merchantId":{"value": "' +
                    merchantId +
                    '"}}}';
                if (params["storeLocationId"]) {
                    conditions2 =
                        conditions2 +
                        ',{"term": {"storeLocationId": {"value": "' +
                        params["storeLocationId"] +
                        '"}}}';
                }
                conditions2 = conditions2 + "]";

                // First Table
                /**0 */ requests.push(
                    '{"index":"eatos-orders-products","ignore_unavailable":true}'
                );
                /**0 */ requests.push(
                    '{"size":0,"query":{"bool":{"must":' +
                    conditions +
                    '}},"aggs":{"shift":{"terms":{"field":"service.keyword", "size": 9999},"aggs":{"service_name":{"terms":{"field":"service.keyword"}},"total":{"sum":{"script":"doc[\'total\'].value"}},"totalCustomizationPrice":{"sum":{"field":"product.main_category.totalCustomizationPrice"}},"this_week":{"date_histogram":{"field":"@timestamp","calendar_interval":"day","min_doc_count":0,"time_zone":"' +
                    time_zone +
                    '","format":"dd-MM-yyyy","extended_bounds":{"min":"' +
                    gte_f +
                    '","max":"' +
                    lte_f +
                    '"}},"aggs":{"total":{"sum":{"script":"doc[\'total\'].value"}},"totalCustomizationPrice":{"sum":{"field":"product.main_category.totalCustomizationPrice"}}}},"categories":{"terms":{"field":"product.main_category.productCategoryName.keyword"},"aggs":{"category_name":{"terms":{"field":"product.main_category.productCategoryName.keyword"}},"total":{"sum":{"script":"doc[\'total\'].value"}},"totalCustomizationPrice":{"sum":{"field":"product.main_category.totalCustomizationPrice"}},"this_week":{"date_histogram":{"field":"@timestamp","calendar_interval":"day","min_doc_count":0,"time_zone":"' +
                    time_zone +
                    '","format":"dd-MM-yyyy","extended_bounds":{"min":"' +
                    gte_f +
                    '","max":"' +
                    lte_f +
                    '"}},"aggs":{"total":{"sum":{"script":"doc[\'total\'].value"}},"totalCustomizationPrice":{"sum":{"field":"product.main_category.totalCustomizationPrice"}}}}}}}},"this_week":{"date_histogram":{"field":"@timestamp","calendar_interval":"day","min_doc_count":0,"time_zone":"' +
                    time_zone +
                    '","format":"dd-MM-yyyy","extended_bounds":{"min":"' +
                    gte_f +
                    '","max":"' +
                    lte_f +
                    '"}},"aggs":{"total":{"sum":{"script":"doc[\'total\'].value"}},"totalCustomizationPrice":{"sum":{"field":"product.main_category.totalCustomizationPrice"}}}}}}'
                );
                /**1 */ requests.push(
                    '{"index":"eatos-orders-products","ignore_unavailable":true}'
                );
                /*1 */ requests.push(
                    '{"size":0,"query":{"bool":{"must":' +
                    conditions2 +
                    '}},"aggs":{"shift":{"terms":{"field":"service.keyword", "size": 9999},"aggs":{"monday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    mon_gte +
                    '","lte": "' +
                    mon_lte +
                    '"}}},"aggs": {"total": {"sum": {"script":"doc[\'total\'].value"}},"totalCustomizationPrice":{"sum":{"field":"product.main_category.totalCustomizationPrice"}}}},"tuesday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    tue_gte +
                    '","lte": "' +
                    tue_lte +
                    '"}}},"aggs": {"total": {"sum": {"script":"doc[\'total\'].value"}},"totalCustomizationPrice":{"sum":{"field":"product.main_category.totalCustomizationPrice"}}}},"wednesday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    wed_gte +
                    '","lte": "' +
                    wed_lte +
                    '"}}},"aggs": {"total": {"sum": {"script":"doc[\'total\'].value"}},"totalCustomizationPrice":{"sum":{"field":"product.main_category.totalCustomizationPrice"}}}},"thursday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    thu_gte +
                    '","lte": "' +
                    thu_lte +
                    '"}}},"aggs": {"total": {"sum": {"script":"doc[\'total\'].value"}},"totalCustomizationPrice":{"sum":{"field":"product.main_category.totalCustomizationPrice"}}}},"friday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    fri_gte +
                    '","lte": "' +
                    fri_lte +
                    '"}}},"aggs": {"total": {"sum": {"script":"doc[\'total\'].value"}},"totalCustomizationPrice":{"sum":{"field":"product.main_category.totalCustomizationPrice"}}}},"saturday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    sat_gte +
                    '","lte": "' +
                    sat_lte +
                    '"}}},"aggs": {"total": {"sum": {"script":"doc[\'total\'].value"}},"totalCustomizationPrice":{"sum":{"field":"product.main_category.totalCustomizationPrice"}}}},"sunday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    sun_gte +
                    '","lte": "' +
                    sun_lte +
                    '"}}},"aggs": {"total": {"sum": {"script":"doc[\'total\'].value"}},"totalCustomizationPrice":{"sum":{"field":"product.main_category.totalCustomizationPrice"}}}},"service_name":{"terms":{"field":"service.keyword"}},"categories":{"terms":{"field":"product.main_category.productCategoryName.keyword"},"aggs":{"category_name":{"terms":{"field":"product.main_category.productCategoryName.keyword"}},"monday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    mon_gte +
                    '","lte": "' +
                    mon_lte +
                    '"}}},"aggs": {"total": {"sum": {"script":"doc[\'total\'].value"}},"totalCustomizationPrice":{"sum":{"field":"product.main_category.totalCustomizationPrice"}}}},"tuesday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    tue_gte +
                    '","lte": "' +
                    tue_lte +
                    '"}}},"aggs": {"total": {"sum": {"script":"doc[\'total\'].value"}},"totalCustomizationPrice":{"sum":{"field":"product.main_category.totalCustomizationPrice"}}}},"wednesday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    wed_gte +
                    '","lte": "' +
                    wed_lte +
                    '"}}},"aggs": {"total": {"sum": {"script":"doc[\'total\'].value"}},"totalCustomizationPrice":{"sum":{"field":"product.main_category.totalCustomizationPrice"}}}},"thursday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    thu_gte +
                    '","lte": "' +
                    thu_lte +
                    '"}}},"aggs": {"total": {"sum": {"script":"doc[\'total\'].value"}},"totalCustomizationPrice":{"sum":{"field":"product.main_category.totalCustomizationPrice"}}}},"friday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    fri_gte +
                    '","lte": "' +
                    fri_lte +
                    '"}}},"aggs": {"total": {"sum": {"script":"doc[\'total\'].value"}},"totalCustomizationPrice":{"sum":{"field":"product.main_category.totalCustomizationPrice"}}}},"saturday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    sat_gte +
                    '","lte": "' +
                    sat_lte +
                    '"}}},"aggs": {"total": {"sum": {"script":"doc[\'total\'].value"}},"totalCustomizationPrice":{"sum":{"field":"product.main_category.totalCustomizationPrice"}}}},"sunday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    sun_gte +
                    '","lte": "' +
                    sun_lte +
                    '"}}},"aggs": {"total": {"sum": {"script":"doc[\'total\'].value"}},"totalCustomizationPrice":{"sum":{"field":"product.main_category.totalCustomizationPrice"}}}},"prev_week":{"filter":{"range":{"@timestamp":{"gte":"' +
                    prev_gte +
                    '","lte":"' +
                    prev_lte +
                    '"}}},"aggs":{"total":{"sum":{"script":"doc[\'total\'].value"}},"totalCustomizationPrice":{"sum":{"field":"product.main_category.totalCustomizationPrice"}}}},"this_week":{"filter":{"range":{"@timestamp":{"gte":"' +
                    gte +
                    '","lte":"' +
                    lte +
                    '"}}},"aggs":{"total":{"sum":{"script":"doc[\'total\'].value"}},"totalCustomizationPrice":{"sum":{"field":"product.main_category.totalCustomizationPrice"}}}},"this_month":{"filter":{"range":{"@timestamp":{"gte":"' +
                    month_gte +
                    '","lte":"' +
                    month_lte +
                    '"}}},"aggs":{"total":{"sum":{"script":"doc[\'total\'].value"}},"totalCustomizationPrice":{"sum":{"field":"product.main_category.totalCustomizationPrice"}}}},"month_last_year":{"filter":{"range":{"@timestamp":{"gte":"' +
                    month_ly_gte +
                    '","lte":"' +
                    month_ly_lte +
                    '"}}},"aggs":{"total":{"sum":{"script":"doc[\'total\'].value"}},"totalCustomizationPrice":{"sum":{"field":"product.main_category.totalCustomizationPrice"}}}},"last_year":{"filter":{"range":{"@timestamp":{"gte":"' +
                    ly_gte +
                    '","lte":"' +
                    ly_lte +
                    '"}}},"aggs":{"total":{"sum":{"script":"doc[\'total\'].value"}},"totalCustomizationPrice":{"sum":{"field":"product.main_category.totalCustomizationPrice"}}}}}},"prev_week":{"filter":{"range":{"@timestamp":{"gte":"' +
                    prev_gte +
                    '","lte":"' +
                    prev_lte +
                    '"}}},"aggs":{"total":{"sum":{"script":"doc[\'total\'].value"}},"totalCustomizationPrice":{"sum":{"field":"product.main_category.totalCustomizationPrice"}}}},"this_week":{"filter":{"range":{"@timestamp":{"gte":"' +
                    gte +
                    '","lte":"' +
                    lte +
                    '"}}},"aggs":{"total":{"sum":{"script":"doc[\'total\'].value"}},"totalCustomizationPrice":{"sum":{"field":"product.main_category.totalCustomizationPrice"}}}},"this_month":{"filter":{"range":{"@timestamp":{"gte":"' +
                    month_gte +
                    '","lte":"' +
                    month_lte +
                    '"}}},"aggs":{"total":{"sum":{"script":"doc[\'total\'].value"}},"totalCustomizationPrice":{"sum":{"field":"product.main_category.totalCustomizationPrice"}}}},"month_last_year":{"filter":{"range":{"@timestamp":{"gte":"' +
                    month_ly_gte +
                    '","lte":"' +
                    month_ly_lte +
                    '"}}},"aggs":{"total":{"sum":{"script":"doc[\'total\'].value"}},"totalCustomizationPrice":{"sum":{"field":"product.main_category.totalCustomizationPrice"}}}},"last_year":{"filter":{"range":{"@timestamp":{"gte":"' +
                    ly_gte +
                    '","lte":"' +
                    ly_lte +
                    '"}}},"aggs":{"total":{"sum":{"script":"doc[\'total\'].value"}},"totalCustomizationPrice":{"sum":{"field":"product.main_category.totalCustomizationPrice"}}}}}},"prev_week":{"filter":{"range":{"@timestamp":{"gte":"' +
                    prev_gte +
                    '","lte":"' +
                    prev_lte +
                    '"}}},"aggs":{"total":{"sum":{"script":"doc[\'total\'].value"}},"totalCustomizationPrice":{"sum":{"field":"product.main_category.totalCustomizationPrice"}}}},"this_week":{"filter":{"range":{"@timestamp":{"gte":"' +
                    gte +
                    '","lte":"' +
                    lte +
                    '"}}},"aggs":{"total":{"sum":{"script":"doc[\'total\'].value"}},"totalCustomizationPrice":{"sum":{"field":"product.main_category.totalCustomizationPrice"}}}},"this_month":{"filter":{"range":{"@timestamp":{"gte":"' +
                    month_gte +
                    '","lte":"' +
                    month_lte +
                    '"}}},"aggs":{"total":{"sum":{"script":"doc[\'total\'].value"}},"totalCustomizationPrice":{"sum":{"field":"product.main_category.totalCustomizationPrice"}}}},"month_last_year":{"filter":{"range":{"@timestamp":{"gte":"' +
                    month_ly_gte +
                    '","lte":"' +
                    month_ly_lte +
                    '"}}},"aggs":{"total":{"sum":{"script":"doc[\'total\'].value"}},"totalCustomizationPrice":{"sum":{"field":"product.main_category.totalCustomizationPrice"}}}},"last_year":{"filter":{"range":{"@timestamp":{"gte":"' +
                    ly_gte +
                    '","lte":"' +
                    ly_lte +
                    '"}}},"aggs":{"total":{"sum":{"script":"doc[\'total\'].value"}},"totalCustomizationPrice":{"sum":{"field":"product.main_category.totalCustomizationPrice"}}}},"sunday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    sun_gte +
                    '","lte": "' +
                    sun_lte +
                    '"}}},"aggs": {"total": {"sum": {"script":"doc[\'total\'].value"}},"totalCustomizationPrice":{"sum":{"field":"product.main_category.totalCustomizationPrice"}}}},"saturday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    sat_gte +
                    '","lte": "' +
                    sat_lte +
                    '"}}},"aggs": {"total": {"sum": {"script":"doc[\'total\'].value"}},"totalCustomizationPrice":{"sum":{"field":"product.main_category.totalCustomizationPrice"}}}},"friday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    fri_gte +
                    '","lte": "' +
                    fri_lte +
                    '"}}},"aggs": {"total": {"sum": {"script":"doc[\'total\'].value"}},"totalCustomizationPrice":{"sum":{"field":"product.main_category.totalCustomizationPrice"}}}},"thursday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    thu_gte +
                    '","lte": "' +
                    thu_lte +
                    '"}}},"aggs": {"total": {"sum": {"script":"doc[\'total\'].value"}},"totalCustomizationPrice":{"sum":{"field":"product.main_category.totalCustomizationPrice"}}}},"wednesday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    wed_gte +
                    '","lte": "' +
                    wed_lte +
                    '"}}},"aggs": {"total": {"sum": {"script":"doc[\'total\'].value"}},"totalCustomizationPrice":{"sum":{"field":"product.main_category.totalCustomizationPrice"}}}},"tuesday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    tue_gte +
                    '","lte": "' +
                    tue_lte +
                    '"}}},"aggs": {"total": {"sum": {"script":"doc[\'total\'].value"}},"totalCustomizationPrice":{"sum":{"field":"product.main_category.totalCustomizationPrice"}}}},"monday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    mon_gte +
                    '","lte": "' +
                    mon_lte +
                    '"}}},"aggs": {"total": {"sum": {"script":"doc[\'total\'].value"}},"totalCustomizationPrice":{"sum":{"field":"product.main_category.totalCustomizationPrice"}}}}}}'
                );
                // Thirth Table
                /**2 */ requests.push(
                    '{"index":"eatos-orders-products","ignore_unavailable":true}'
                );
                /**2 */ requests.push(
                    '{"size":0,"query":{"bool":{"must":' +
                    conditions +
                    '}},"aggs":{"type":{"terms":{"field":"type.id", "size": 9999},"aggs":{"type_name":{"terms":{"field":"type.name.keyword"}},"total":{"sum":{"script":"doc[\'total\'].value"}},"tuesday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    tue_gte +
                    '","lte": "' +
                    tue_lte +
                    '"}}},"aggs": {"total": {"sum": {"script":"doc[\'total\'].value"}}}},"monday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    mon_gte +
                    '","lte": "' +
                    mon_lte +
                    '"}}},"aggs": {"total": {"sum": {"script":"doc[\'total\'].value"}}}},"this_week":{"date_histogram":{"field":"@timestamp","calendar_interval":"day","min_doc_count":0,"time_zone":"' +
                    time_zone +
                    '","format":"dd-MM-yyyy","extended_bounds":{"min":"' +
                    gte_f +
                    '","max":"' +
                    lte_f +
                    '"}},"aggs":{"total":{"sum":{"script":"doc[\'total\'].value"}}}}}},"this_week":{"date_histogram":{"field":"@timestamp","calendar_interval":"day","min_doc_count":0,"time_zone":"' +
                    time_zone +
                    '","format":"dd-MM-yyyy","extended_bounds":{"min":"' +
                    gte_f +
                    '","max":"' +
                    lte_f +
                    '"}},"aggs":{"total":{"sum":{"script":"doc[\'total\'].value"}}}}}}'
                );
                /**3 */ requests.push(
                    '{"index":"eatos-orders-products","ignore_unavailable":true}'
                );
                /**3 */ requests.push(
                    '{"size":0,"query":{"bool":{"must":' +
                    conditions2 +
                    '}},"aggs":{"type":{"terms":{"field":"type.id", "size": 9999},"aggs":{"name":{"terms":{"field":"type.name.keyword"}},"prev_week":{"filter":{"range":{"@timestamp":{"gte":"' +
                    prev_gte +
                    '","lte":"' +
                    prev_lte +
                    '"}}},"aggs":{"total":{"sum":{"script":"doc[\'total\'].value"}}}},"sunday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    sun_gte +
                    '","lte": "' +
                    sun_lte +
                    '"}}},"aggs": {"total": {"sum": {"script":"doc[\'total\'].value"}}}},"saturday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    sat_gte +
                    '","lte": "' +
                    sat_lte +
                    '"}}},"aggs": {"total": {"sum": {"script":"doc[\'total\'].value"}}}},"friday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    fri_gte +
                    '","lte": "' +
                    fri_lte +
                    '"}}},"aggs": {"total": {"sum": {"script":"doc[\'total\'].value"}}}},"thursday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    thu_gte +
                    '","lte": "' +
                    thu_lte +
                    '"}}},"aggs": {"total": {"sum": {"script":"doc[\'total\'].value"}}}},"wednesday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    wed_gte +
                    '","lte": "' +
                    wed_lte +
                    '"}}},"aggs": {"total": {"sum": {"script":"doc[\'total\'].value"}}}},"tuesday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    tue_gte +
                    '","lte": "' +
                    tue_lte +
                    '"}}},"aggs": {"total": {"sum": {"script":"doc[\'total\'].value"}}}},"monday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    mon_gte +
                    '","lte": "' +
                    mon_lte +
                    '"}}},"aggs": {"total": {"sum": {"script":"doc[\'total\'].value"}}}},"this_week":{"filter":{"range":{"@timestamp":{"gte":"' +
                    gte +
                    '","lte":"' +
                    lte +
                    '"}}},"aggs":{"total":{"sum":{"script":"doc[\'total\'].value"}}}},"this_month":{"filter":{"range":{"@timestamp":{"gte":"' +
                    month_gte +
                    '","lte":"' +
                    month_lte +
                    '"}}},"aggs":{"total":{"sum":{"script":"doc[\'total\'].value"}}}},"month_last_year":{"filter":{"range":{"@timestamp":{"gte":"' +
                    month_ly_gte +
                    '","lte":"' +
                    month_ly_lte +
                    '"}}},"aggs":{"total":{"sum":{"script":"doc[\'total\'].value"}}}},"last_year":{"filter":{"range":{"@timestamp":{"gte":"' +
                    ly_gte +
                    '","lte":"' +
                    ly_lte +
                    '"}}},"aggs":{"total":{"sum":{"script":"doc[\'total\'].value"}}}}}},"prev_week":{"filter":{"range":{"@timestamp":{"gte":"' +
                    prev_gte +
                    '","lte":"' +
                    prev_lte +
                    '"}}},"aggs":{"total":{"sum":{"script":"doc[\'total\'].value"}}}},"this_week":{"filter":{"range":{"@timestamp":{"gte":"' +
                    gte +
                    '","lte":"' +
                    lte +
                    '"}}},"aggs":{"total":{"sum":{"script":"doc[\'total\'].value"}}}},"this_month":{"filter":{"range":{"@timestamp":{"gte":"' +
                    month_gte +
                    '","lte":"' +
                    month_lte +
                    '"}}},"aggs":{"total":{"sum":{"script":"doc[\'total\'].value"}}}},"month_last_year":{"filter":{"range":{"@timestamp":{"gte":"' +
                    month_ly_gte +
                    '","lte":"' +
                    month_ly_lte +
                    '"}}},"aggs":{"total":{"sum":{"script":"doc[\'total\'].value"}}}},"last_year":{"filter":{"range":{"@timestamp":{"gte":"' +
                    ly_gte +
                    '","lte":"' +
                    ly_lte +
                    '"}}},"aggs":{"total":{"sum":{"script":"doc[\'total\'].value"}}}},"sunday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    sun_gte +
                    '","lte": "' +
                    sun_lte +
                    '"}}},"aggs": {"total": {"sum": {"script":"doc[\'total\'].value"}}}},"saturday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    sat_gte +
                    '","lte": "' +
                    sat_lte +
                    '"}}},"aggs": {"total": {"sum": {"script":"doc[\'total\'].value"}}}},"friday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    fri_gte +
                    '","lte": "' +
                    fri_lte +
                    '"}}},"aggs": {"total": {"sum": {"script":"doc[\'total\'].value"}}}},"thursday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    thu_gte +
                    '","lte": "' +
                    thu_lte +
                    '"}}},"aggs": {"total": {"sum": {"script":"doc[\'total\'].value"}}}},"wednesday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    wed_gte +
                    '","lte": "' +
                    wed_lte +
                    '"}}},"aggs": {"total": {"sum": {"script":"doc[\'total\'].value"}}}},"tuesday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    tue_gte +
                    '","lte": "' +
                    tue_lte +
                    '"}}},"aggs": {"total": {"sum": {"script":"doc[\'total\'].value"}}}},"monday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    mon_gte +
                    '","lte": "' +
                    mon_lte +
                    '"}}},"aggs": {"total": {"sum": {"script":"doc[\'total\'].value"}}}}}}'
                );
                // Fourth Table
                /*4 */ requests.push(
                    '{"index":"eatos-comps","ignore_unavailable":true}'
                );
                /*4*/ requests.push(
                    '{"size":0,"query":{"bool":{"must":' +
                    conditions +
                    '}},"aggs":{"reason":{"terms":{"field":"reasonName.keyword", "size": 9999},"aggs":{"total":{"sum":{"field":"amount"}},"this_week":{"date_histogram":{"field":"@timestamp","calendar_interval":"day","min_doc_count":0,"time_zone":"' +
                    time_zone +
                    '","format":"dd-MM-yyyy","extended_bounds":{"min":"' +
                    gte_f +
                    '","max":"' +
                    lte_f +
                    '"}},"aggs":{"total":{"sum":{"field":"amount"}}}}}},"reasonCat":{"terms":{"field":"reason.keyword", "size": 9999},"aggs":{"total":{"sum":{"field":"amount"}},"this_week":{"date_histogram":{"field":"@timestamp","calendar_interval":"day","min_doc_count":0,"time_zone":"' +
                    time_zone +
                    '","format":"dd-MM-yyyy","extended_bounds":{"min":"' +
                    gte_f +
                    '","max":"' +
                    lte_f +
                    '"}},"aggs":{"total":{"sum":{"field":"amount"}}}}}},"this_week":{"date_histogram":{"field":"@timestamp","calendar_interval":"day","min_doc_count":0,"time_zone":"' +
                    time_zone +
                    '","format":"dd-MM-yyyy","extended_bounds":{"min":"' +
                    gte_f +
                    '","max":"' +
                    lte_f +
                    '"}},"aggs":{"total":{"sum":{"field":"amount"}}}}}}'
                );
                /*5*/ requests.push(
                    '{"index":"eatos-comps","ignore_unavailable":true}'
                );
                /*5*/ requests.push(
                    '{"size":0,"query":{"bool":{"must":' +
                    conditions2 +
                    '}},"aggs":{"reason":{"terms":{"field":"reasonName.keyword", "size": 9999},"aggs":{"prev_week":{"filter":{"range":{"@timestamp":{"gte":"' +
                    prev_gte +
                    '","lte":"' +
                    prev_lte +
                    '"}}},"aggs":{"total":{"sum":{"field":"amount"}}}},"this_week":{"filter":{"range":{"@timestamp":{"gte":"' +
                    gte +
                    '","lte":"' +
                    lte +
                    '"}}},"aggs":{"total":{"sum":{"field":"amount"}}}},"this_month":{"filter":{"range":{"@timestamp":{"gte":"' +
                    month_gte +
                    '","lte":"' +
                    month_lte +
                    '"}}},"aggs":{"total":{"sum":{"field":"amount"}}}},"month_last_year":{"filter":{"range":{"@timestamp":{"gte":"' +
                    month_ly_gte +
                    '","lte":"' +
                    month_ly_lte +
                    '"}}},"aggs":{"total":{"sum":{"field":"amount"}}}},"last_year":{"filter":{"range":{"@timestamp":{"gte":"' +
                    ly_gte +
                    '","lte":"' +
                    ly_lte +
                    '"}}},"aggs":{"total":{"sum":{"field":"amount"}}}}}},"reasonCat":{"terms":{"field":"reason.keyword", "size": 9999},"aggs":{"prev_week":{"filter":{"range":{"@timestamp":{"gte":"' +
                    prev_gte +
                    '","lte":"' +
                    prev_lte +
                    '"}}},"aggs":{"total":{"sum":{"field":"amount"}}}},"this_week":{"filter":{"range":{"@timestamp":{"gte":"' +
                    gte +
                    '","lte":"' +
                    lte +
                    '"}}},"aggs":{"total":{"sum":{"field":"amount"}}}},"this_month":{"filter":{"range":{"@timestamp":{"gte":"' +
                    month_gte +
                    '","lte":"' +
                    month_lte +
                    '"}}},"aggs":{"total":{"sum":{"field":"amount"}}}},"month_last_year":{"filter":{"range":{"@timestamp":{"gte":"' +
                    month_ly_gte +
                    '","lte":"' +
                    month_ly_lte +
                    '"}}},"aggs":{"total":{"sum":{"field":"amount"}}}},"last_year":{"filter":{"range":{"@timestamp":{"gte":"' +
                    ly_gte +
                    '","lte":"' +
                    ly_lte +
                    '"}}},"aggs":{"total":{"sum":{"field":"amount"}}}}}},"prev_week":{"filter":{"range":{"@timestamp":{"gte":"' +
                    prev_gte +
                    '","lte":"' +
                    prev_lte +
                    '"}}},"aggs":{"total":{"sum":{"field":"amount"}}}},"this_week":{"filter":{"range":{"@timestamp":{"gte":"' +
                    gte +
                    '","lte":"' +
                    lte +
                    '"}}},"aggs":{"total":{"sum":{"field":"amount"}}}},"this_month":{"filter":{"range":{"@timestamp":{"gte":"' +
                    month_gte +
                    '","lte":"' +
                    month_lte +
                    '"}}},"aggs":{"total":{"sum":{"field":"amount"}}}},"month_last_year":{"filter":{"range":{"@timestamp":{"gte":"' +
                    month_ly_gte +
                    '","lte":"' +
                    month_ly_lte +
                    '"}}},"aggs":{"total":{"sum":{"field":"amount"}}}},"last_year":{"filter":{"range":{"@timestamp":{"gte":"' +
                    ly_gte +
                    '","lte":"' +
                    ly_lte +
                    '"}}},"aggs":{"total":{"sum":{"field":"amount"}}}},"sunday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    sun_gte +
                    '","lte": "' +
                    sun_lte +
                    '"}}},"aggs": {"total": {"sum": {"field": "total"}}}},"saturday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    sat_gte +
                    '","lte": "' +
                    sat_lte +
                    '"}}},"aggs": {"total": {"sum": {"field": "total"}}}},"friday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    fri_gte +
                    '","lte": "' +
                    fri_lte +
                    '"}}},"aggs": {"total": {"sum": {"field": "total"}}}},"thursday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    thu_gte +
                    '","lte": "' +
                    thu_lte +
                    '"}}},"aggs": {"total": {"sum": {"field": "total"}}}},"wednesday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    wed_gte +
                    '","lte": "' +
                    wed_lte +
                    '"}}},"aggs": {"total": {"sum": {"field": "total"}}}},"tuesday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    tue_gte +
                    '","lte": "' +
                    tue_lte +
                    '"}}},"aggs": {"total": {"sum": {"field": "total"}}}},"monday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    mon_gte +
                    '","lte": "' +
                    mon_lte +
                    '"}}},"aggs": {"total": {"sum": {"field": "total"}}}}}}'
                );
                // Fifth Table
                var conditions3 =
                    '[{"term":{"merchantId":{"value": "' +
                    merchantId +
                    '"}}},{"range":{"@timestamp":{"gte": "' +
                    custom_gte +
                    '","lte":"' +
                    custom_lte +
                    '"}}}';
                if (params["storeLocationId"]) {
                    conditions3 =
                        conditions3 +
                        ',{"term": {"storeId.keyword": {"value": "' +
                        params["storeLocationId"] +
                        '"}}}';
                }
                conditions3 = conditions3 + "]";
                var conditions4 =
                    '[{"term":{"merchantId":{"value": "' + merchantId + '"}}}';
                if (params["storeLocationId"]) {
                    conditions4 =
                        conditions4 +
                        ',{"term": {"storeId.keyword": {"value": "' +
                        params["storeLocationId"] +
                        '"}}}';
                }
                conditions4 = conditions4 + "]";
                //6
                requests.push(
                    '{"index":"eatos-labor-hours","ignore_unavailable":true}'
                ); //"this_week":{"date_histogram":{"field":"@timestamp","calendar_interval":"day","min_doc_count":0,"time_zone":"'+time_zone+'","format":"dd-MM-yyyy","extended_bounds":{"min":"'+gte_f+'","max":"'+lte_f+'"}}
                requests.push(
                    '{"size":0,"query":{"bool":{"must":' +
                    conditions3 +
                    '}},"aggs":{"this_week":{"date_histogram":{"field":"@timestamp","calendar_interval":"day","min_doc_count":0,"time_zone":"' +
                    time_zone +
                    '","format":"dd-MM-yyyy","extended_bounds":{"min":"' +
                    gte_f +
                    '","max":"' +
                    lte_f +
                    '"}},"aggs":{"regular":{"sum":{"field":"regpayment"}},"overtime":{"sum":{"field":"overtimepayment"}}}}}}'
                );
                //7
                requests.push(
                    '{"index":"eatos-labor-hours","ignore_unavailable":true}'
                );
                requests.push(
                    '{"size":0,"query":{"bool":{"must":' +
                    conditions4 +
                    '}},"aggs":{"prev_week":{"filter":{"range":{"@timestamp":{"gte":"' +
                    prev_gte +
                    '","lte":"' +
                    prev_lte +
                    '"}}},"aggs":{"regular":{"sum":{"field":"regpayment"}},"overtime":{"sum":{"field":"overtimepayment"}}}},"this_week":{"filter":{"range":{"@timestamp":{"gte":"' +
                    gte +
                    '","lte":"' +
                    lte +
                    '"}}},"aggs":{"regular":{"sum":{"field":"regpayment"}},"overtime":{"sum":{"field":"overtimepayment"}}}},"this_month":{"filter":{"range":{"@timestamp":{"gte":"' +
                    month_gte +
                    '","lte":"' +
                    month_lte +
                    '"}}},"aggs":{"regular":{"sum":{"field":"regpayment"}},"overtime":{"sum":{"field":"overtimepayment"}}}},"month_last_year":{"filter":{"range":{"@timestamp":{"gte":"' +
                    month_ly_gte +
                    '","lte":"' +
                    month_ly_lte +
                    '"}}},"aggs":{"regular":{"sum":{"field":"regpayment"}},"overtime":{"sum":{"field":"overtimepayment"}}}},"last_year":{"filter":{"range":{"@timestamp":{"gte":"' +
                    ly_gte +
                    '","lte":"' +
                    ly_lte +
                    '"}}},"aggs":{"regular":{"sum":{"field":"regpayment"}},"overtime":{"sum":{"field":"overtimepayment"}}}}}}'
                );
                // 8 Sixth Table
                requests.push(
                    '{"index":"eatos-labor-hours","ignore_unavailable":true}'
                );
                requests.push(
                    '{"size":0,"query":{"bool":{"must":' +
                    conditions3 +
                    '}},"aggs":{"this_week":{"date_histogram":{"field":"@timestamp","calendar_interval":"day","min_doc_count":0,"time_zone":"' +
                    time_zone +
                    '","format":"dd-MM-yyyy","extended_bounds":{"min":"' +
                    gte_f +
                    '","max":"' +
                    lte_f +
                    '"}},"aggs":{"regular":{"sum":{"field":"regseconds"}},"overtime":{"sum":{"field":"overtimeseconds"}}}}}}'
                );
                //9
                requests.push(
                    '{"index":"eatos-labor-hours","ignore_unavailable":true}'
                );
                requests.push(
                    '{"size":0,"query":{"bool":{"must":' +
                    conditions4 +
                    '}},"aggs":{"prev_week":{"filter":{"range":{"@timestamp":{"gte":"' +
                    prev_gte +
                    '","lte":"' +
                    prev_lte +
                    '"}}},"aggs":{"regular":{"sum":{"field":"regseconds"}},"overtime":{"sum":{"field":"overtimeseconds"}}}},"this_week":{"filter":{"range":{"@timestamp":{"gte":"' +
                    gte +
                    '","lte":"' +
                    lte +
                    '"}}},"aggs":{"regular":{"sum":{"field":"regseconds"}},"overtime":{"sum":{"field":"overtimeseconds"}}}},"this_month":{"filter":{"range":{"@timestamp":{"gte":"' +
                    month_gte +
                    '","lte":"' +
                    month_lte +
                    '"}}},"aggs":{"regular":{"sum":{"field":"regseconds"}},"overtime":{"sum":{"field":"overtimeseconds"}}}},"month_last_year":{"filter":{"range":{"@timestamp":{"gte":"' +
                    month_ly_gte +
                    '","lte":"' +
                    month_ly_lte +
                    '"}}},"aggs":{"regular":{"sum":{"field":"regseconds"}},"overtime":{"sum":{"field":"overtimeseconds"}}}},"last_year":{"filter":{"range":{"@timestamp":{"gte":"' +
                    ly_gte +
                    '","lte":"' +
                    ly_lte +
                    '"}}},"aggs":{"regular":{"sum":{"field":"regseconds"}},"overtime":{"sum":{"field":"overtimeseconds"}}}}}}'
                );
                //Last Table
                //10
                requests.push(
                    '{"index":"eatos-labor-hours-daily","ignore_unavailable":true}'
                );
                var bar = 1;
                var conditions5 =
                    '[{"term":{"employee.merchantId":{"value": "' +
                    merchantId +
                    '"}}}, {"term":{"workingPart.statusTime":{"value": ' +
                    bar +
                    "}}}";
                if (params["storeLocationId"]) {
                    conditions5 =
                        conditions5 +
                        ',{"term": {"employee.storeLocationId": {"value": "' +
                        params["storeLocationId"] +
                        '"}}}';
                }
                conditions5 = conditions5 + "]";
                //, esta es la once //Quinta tabla "sort":[{"data_labors.startSch":{"order":"asc"}}],
                requests.push(
                    '{"size":0,"sort":[{"data_labors.startSch":{"order":"desc"}}],"query":{"bool":{"must":' +
                    conditions5 +
                    '}},"aggs":{"total":{"nested":{"path":"data_labors"},"aggs":{"services":{"terms":{"field":"data_labors.serviceName.keyword", "size": 9999},"aggs":{"department"' +
                    ':{"terms":{"field":"data_labors.department.keyword", "size": 9999},"aggs":' +
                    '{"prev_week":{"filter":{"range":{"data_labors.timeStamp":{"gte":"' +
                    prev_gte +
                    '","lte":"' +
                    prev_lte +
                    '"}}},"aggs":{"regular_payment":' +
                    '{"sum":{"field":"data_labors.regPayment"}},"body_count":{"terms":{"field":"data_labors.scheduleCount.keyword"}},"body_count_dep":{"terms":{"field":"data_labors.departmentCount.keyword"}},"ovetime_payment":{"sum":{"field":"data_labors.overPayment"}},"regular_time":{"sum":{"field":"data_labors.baseSeconds"}},"ovetime_time":{"sum":{"field":"data_labors.overSeconds"}},"training_payment":{"sum":{"field":"data_labors.trainingPayment"}},"training_time":{"sum":{"field":"data_labors.trainingSeconds"}}}},"this_week":{"filter":{"range":{"data_labors.timeStamp":{"gte":"' +
                    gte_labor +
                    '","lte":"' +
                    lte +
                    '"}}},"aggs":{"regular_payment":{"sum":{"field":"data_labors.regPayment"}},"body_count":{"terms":{"field":"data_labors.scheduleCount.keyword"}},"body_count_dep":{"terms":{"field":"data_labors.departmentCount.keyword"}},"ovetime_payment":{"sum":{"field":"data_labors.overPayment"}},"regular_time":{"sum":{"field":"data_labors.baseSeconds"}},"ovetime_time":{"sum":{"field":"data_labors.overSeconds"}},"training_payment":{"sum":{"field":"data_labors.trainingPayment"}},"training_time":{"sum":{"field":"data_labors.trainingSeconds"}}}},"this_month":{"filter":{"range":{"data_labors.timeStamp":{"gte":"' +
                    month_gte +
                    '","lte":"' +
                    month_lte +
                    '"}}},"aggs":{"regular_payment":{"sum":{"field":"data_labors.regPayment"}},"body_count":{"terms":{"field":"data_labors.scheduleCount.keyword"}},"body_count_dep":{"terms":{"field":"data_labors.departmentCount.keyword"}},"ovetime_payment":{"sum":{"field":"data_labors.overPayment"}},"regular_time":{"sum":{"field":"data_labors.baseSeconds"}},"ovetime_time":{"sum":{"field":"data_labors.overSeconds"}},"training_payment":{"sum":{"field":"data_labors.trainingPayment"}},"training_time":{"sum":{"field":"data_labors.trainingSeconds"}}}},"month_last_year":{"filter":{"range":{"data_labors.timeStamp":{"gte":"' +
                    month_ly_gte +
                    '","lte":"' +
                    month_ly_lte +
                    '"}}},"aggs":{"regular_payment":{"sum":{"field":"data_labors.regPayment"}},"body_count":{"terms":{"field":"data_labors.scheduleCount.keyword"}},"body_count_dep":{"terms":{"field":"data_labors.departmentCount.keyword"}},"ovetime_payment":{"sum":{"field":"data_labors.overPayment"}},"regular_time":{"sum":{"field":"data_labors.baseSeconds"}},"ovetime_time":{"sum":{"field":"data_labors.overSeconds"}},"training_payment":{"sum":{"field":"data_labors.trainingPayment"}},"training_time":{"sum":{"field":"data_labors.trainingSeconds"}}}},"last_year":{"filter":{"range":{"data_labors.timeStamp":{"gte":"' +
                    ly_gte +
                    '","lte":"' +
                    ly_lte +
                    '"}}},"aggs":{"regular_payment":{"sum":{"field":"data_labors.regPayment"}},"body_count":{"terms":{"field":"data_labors.scheduleCount.keyword"}},"body_count_dep":{"terms":{"field":"data_labors.departmentCount.keyword"}},"ovetime_payment":{"sum":{"field":"data_labors.overPayment"}},"regular_time":{"sum":{"field":"data_labors.baseSeconds"}},"ovetime_time":{"sum":{"field":"data_labors.overSeconds"}},"training_payment":{"sum":{"field":"data_labors.trainingPayment"}},"training_time":{"sum":{"field":"data_labors.trainingSeconds"}}}},"monday":{"filter":{"range":{"data_labors.timeStamp":{"gte":"' +
                    mon_gte +
                    '","lte":"' +
                    mon_lte +
                    '"}}},"aggs":{"regular_payment":{"sum":{"field":"data_labors.regPayment"}},"body_count":{"terms":{"field":"data_labors.scheduleCount.keyword"}},"body_count_dep":{"terms":{"field":"data_labors.departmentCount.keyword"}},"ovetime_payment":{"sum":{"field":"data_labors.overPayment"}},"regular_time":{' +
                    '"sum":{"field":"data_labors.baseSeconds"}},"ovetime_time":{"sum":{"field":"data_labors.overSeconds"}},"training_payment":{"sum":{"field":"data_labors.trainingPayment"}},"training_time":{"sum":{"field":"data_labors.trainingSeconds"}}}},"tuesday":{"filter":{"range":{"data_labors.timeStamp":{"gte":"' +
                    tue_gte +
                    '","lte":"' +
                    tue_lte +
                    '"}}},"aggs":{"regular_payment":{"sum":{"field":"data_labors.regPayment"}},"body_count":{"terms":{"field":"data_labors.scheduleCount.keyword"}},"body_count_dep":{"terms":{"field":"data_labors.departmentCount.keyword"}},"ovetime_payment":{"sum":{"field":"data_labors.overPayment"}},"regular_time":{"sum":{"field":"data_labors.baseSeconds"}},"ovetime_time":{"sum":{"field":"data_labors.overSeconds"}},"training_payment":{"sum":{"field":"data_labors.trainingPayment"}},"training_time":{"sum":{"field":"data_labors.trainingSeconds"}}}},"wednesday":{"filter":{"range":{"data_labors.timeStamp":{"gte":"' +
                    wed_gte +
                    '","lte":"' +
                    wed_lte +
                    '"}}},"aggs":{"regular_payment":{"sum":{"field":"data_labors.regPayment"}},"body_count":{"terms":{"field":"data_labors.scheduleCount.keyword"}},"body_count_dep":{"terms":{"field":"data_labors.departmentCount.keyword"}},"ovetime_payment":{"sum":{"field":"data_labors.overPayment"}},"regular_time":{"sum":{"field":"data_labors.baseSeconds"}},"ovetime_time":{"sum":{"field":"data_labors.overSeconds"}},"training_payment":{"sum":{"field":"data_labors.trainingPayment"}},"training_time":{"sum":{"field":"data_labors.trainingSeconds"}}}},"thursday":{"filter":{"range":{"data_labors.timeStamp":{"gte":"' +
                    thu_gte +
                    '","lte":"' +
                    thu_lte +
                    '"}}},"aggs":{"regular_payment":{"sum":{"field":"data_labors.regPayment"}},"body_count":{"terms":{"field":"data_labors.scheduleCount.keyword"}},"body_count_dep":{"terms":{"field":"data_labors.departmentCount.keyword"}},"ovetime_payment":{"sum":{"field":"data_labors.overPayment"}},"regular_time":{"sum":{"field":"data_labors.baseSeconds"}},"ovetime_time":{"sum":{"field":"data_labors.overSeconds"}},"training_payment":{"sum":{"field":"data_labors.trainingPayment"}},"training_time":{"sum":{"field":"data_labors.trainingSeconds"}}}},"friday":{"filter":{"range":{"data_labors.timeStamp":{"gte":"' +
                    fri_gte +
                    '","lte":"' +
                    fri_lte +
                    '"}}},"aggs":{"regular_payment":{"sum":{"field":"data_labors.regPayment"}},"body_count":{"terms":{"field":"data_labors.scheduleCount.keyword"}},"body_count_dep":{"terms":{"field":"data_labors.departmentCount.keyword"}},"ovetime_payment":{"sum":{"field":"data_labors.overPayment"}},"regular_time":{"sum":{"field":"data_labors.baseSeconds"}},"ovetime_time":{"sum":{"field":"data_labors.overSeconds"}},"training_payment":{"sum":{"field":"data_labors.trainingPayment"}},"training_time":{"sum":{"field":"data_labors.trainingSeconds"}}}},"saturday":{"filter":{"range":{"data_labors.timeStamp":{"gte":"' +
                    sat_gte +
                    '","lte":"' +
                    sat_lte +
                    '"}}},"aggs":{"regular_payment":{"sum":{"field":"data_labors.regPayment"}},"body_count":{"terms":{"field":"data_labors.scheduleCount.keyword"}},"body_count_dep":{"terms":{"field":"data_labors.departmentCount.keyword"}},"ovetime_payment":{"sum":{"field":"data_labors.overPayment"}},"regular_time":{"sum":{"field":"data_labors.baseSeconds"}},"ovetime_time":{"sum":{"field":"data_labors.overSeconds"}},"training_payment":{"sum":{"field":"data_labors.trainingPayment"}},"training_time":{"sum":{"field":"data_labors.trainingSeconds"}}}},"sunday":{"filter":{"range":{"data_labors.timeStamp":{"gte":"' +
                    sun_gte +
                    '","lte":"' +
                    sun_lte +
                    '"}}},"aggs":{"regular_payment":{"sum":{"field":"data_labors.regPayment"}},"body_count":{"terms":{"field":"data_labors.scheduleCount.keyword"}},"body_count_dep":{"terms":{"field":"data_labors.departmentCount.keyword"}},"ovetime_payment":{"sum":{"field":"data_labors.overPayment"}},"regular_time":{"sum":{"field":"data_labors.baseSeconds"}},"ovetime_time":{"sum":{"field":"data_labors.overSeconds"}},"training_payment":{"sum":{"field":"data_labors.trainingPayment"}},"training_time":{"sum":{"field":"data_labors.trainingSeconds"}}}}}},"prev_week":{"filter":{"range":{"data_labors.timeStamp":{"gte":"' +
                    prev_gte +
                    '","lte":"' +
                    prev_lte +
                    '"}}},"aggs":{"regular_payment":{"sum":{"field":"data_labors.regPayment"}},"body_count":{"terms":{"field":"data_labors.scheduleCount.keyword"}},"body_count_dep":{"terms":{"field":"data_labors.departmentCount.keyword"}},"ovetime_payment":{"sum":{"field":"data_labors.overPayment"}},"regular_time":{"sum":{"field":"data_labors.baseSeconds"}},"ovetime_time":{"sum":{"field":"data_labors.overSeconds"}},"training_payment":{"sum":{"field":"data_labors.trainingPayment"}},"training_time":{"sum":{"field":"data_labors.trainingSeconds"}}}},"this_week":{"filter":{"range":{"data_labors.timeStamp":{"gte":"' +
                    gte_labor +
                    '","lte":"' +
                    lte +
                    '"}}},"aggs":{"regular_payment":{"sum":{"field":"data_labors.regPayment"}},"body_count":{"terms":{"field":"data_labors.scheduleCount.keyword"}},"body_count_dep":{"terms":{"field":"data_labors.departmentCount.keyword"}},"ovetime_payment":{"sum":{"field":"data_labors.overPayment"}},"regular_time":{"sum":{"field":"data_labors.baseSeconds"}},"ovetime_time":{"sum":{"field":"data_labors.overSeconds"}},"training_payment":{"sum":{"field":"data_labors.trainingPayment"}},"training_time":{"sum":{"field":"data_labors.trainingSeconds"}}}},"this_month":{"filter":{"range":{"data_labors.timeStamp":{"gte":"' +
                    month_gte +
                    '","lte":"' +
                    month_lte +
                    '"}}},"aggs":{"regular_payment":{"sum":{"field":"data_labors.regPayment"}},"body_count":{"terms":{"field":"data_labors.scheduleCount.keyword"}},"body_count_dep":{"terms":{"field":"data_labors.departmentCount.keyword"}},"ovetime_payment":{"sum":{"field":"data_labors.overPayment"}},"regular_time":{"sum":{"field":"data_labors.baseSeconds"}},"ovetime_time":{"sum":{"field":"data_labors.overSeconds"}},"training_payment":{"sum":{"field":"data_labors.trainingPayment"}},"training_time":{"sum":{"field":"data_labors.trainingSeconds"}}}},"month_last_year":{"filter":{"range":{"data_labors.timeStamp":{"gte":"' +
                    month_ly_gte +
                    '","lte":"' +
                    month_ly_lte +
                    '"}}},"aggs":{"regular_payment":{"sum":{"field":"data_labors.regPayment"}},"body_count":{"terms":{"field":"data_labors.scheduleCount.keyword"}},"body_count_dep":{"terms":{"field":"data_labors.departmentCount.keyword"}},"ovetime_payment":{"sum":{"field":"data_labors.overPayment"}},"regular_time":{"sum":{"field":"data_labors.baseSeconds"}},"ovetime_time":{"sum":{"field":"data_labors.overSeconds"}},"training_payment":{"sum":{"field":"data_labors.trainingPayment"}},"training_time":{"sum":{"field":"data_labors.trainingSeconds"}}}},"last_year":{"filter":{"range":{"data_labors.timeStamp":{"gte":"' +
                    ly_gte +
                    '","lte":"' +
                    ly_lte +
                    '"}}},"aggs":{"regular_payment":{"sum":{"field":"data_labors.regPayment"}},"body_count":{"terms":{"field":"data_labors.scheduleCount.keyword"}},"body_count_dep":{"terms":{"field":"data_labors.departmentCount.keyword"}},"ovetime_payment":{"sum":{"field":"data_labors.overPayment"}},"regular_time":{"sum":{"field":"data_labors.baseSeconds"}},"ovetime_time":{"sum":{"field":"data_labors.overSeconds"}},"training_payment":{"sum":{"field":"data_labors.trainingPayment"}},"training_time":{"sum":{"field":"data_labors.trainingSeconds"}}}},"monday":{"filter":{"range":{"data_labors.timeStamp":{"gte":"' +
                    mon_gte +
                    '","lte":"' +
                    mon_lte +
                    '"}}},"aggs":{"regular_payment":{"sum":{"field":"data_labors.regPayment"}},"body_count":{"terms":{"field":"data_labors.scheduleCount.keyword"}},"body_count_dep":{"terms":{"field":"data_labors.departmentCount.keyword"}},"ovetime_payment":{"sum":{"field":"data_labors.overPayment"}},"regular_time":{"sum":{"field":"data_labors.baseSeconds"}},"ovetime_time":{"sum":{"field":"data_labors.overSeconds"}},"training_payment":{"sum":{"field":"data_labors.trainingPayment"}},"training_time":{"sum":{"field":"data_labors.trainingSeconds"}}}},"tuesday":{"filter":{"range":{"data_labors.timeStamp":{"gte":"' +
                    tue_gte +
                    '","lte":"' +
                    tue_lte +
                    '"}}},"aggs":{"regular_payment":{"sum":{"field":"data_labors.regPayment"}},"body_count":{"terms":{"field":"data_labors.scheduleCount.keyword"}},"body_count_dep":{"terms":{"field":"data_labors.departmentCount.keyword"}},"ovetime_payment":{"sum":{"field":"data_labors.overPayment"}},"regular_time":{"sum":{"field":"data_labors.baseSeconds"}},"ovetime_time":{"sum":{"field":"data_labors.overSeconds"}},"training_payment":{"sum":{"field":"data_labors.trainingPayment"}},"training_time":{"sum":{"field":"data_labors.trainingSeconds"}}}},"wednesday":{"filter":{"range":{"data_labors.timeStamp":{"gte":"' +
                    wed_gte +
                    '","lte":"' +
                    wed_lte +
                    '"}}},"aggs":{"regular_payment":{"sum":{"field":"data_labors.regPayment"}},"body_count":{"terms":{"field":"data_labors.scheduleCount.keyword"}},"body_count_dep":{"terms":{"field":"data_labors.departmentCount.keyword"}},"ovetime_payment":{"sum":{"field":"data_labors.overPayment"}},' +
                    '"regular_time":{"sum":{"field":"data_labors.baseSeconds"}},"ovetime_time":{"sum":{"field":"data_labors.overSeconds"}},"training_payment":{"sum":{"field":"data_labors.trainingPayment"}},"training_time":{"sum":{"field":"data_labors.trainingSeconds"}}}},"thursday":{"filter":{"range":{"data_labors.timeStamp":{"gte":"' +
                    thu_gte +
                    '","lte":"' +
                    thu_lte +
                    '"}}},"aggs":{"regular_payment":{"sum":{"field":"data_labors.regPayment"}},"body_count":{"terms":{"field":"data_labors.scheduleCount.keyword"}},"body_count_dep":{"terms":{"field":"data_labors.departmentCount.keyword"}},"ovetime_payment":{"sum":{"field":"data_labors.overPayment"}},"regular_time":{"sum":{"field":"data_labors.baseSeconds"}},"ovetime_time":{"sum":{"field":"data_labors.overSeconds"}},"training_payment":{"sum":{"field":"data_labors.trainingPayment"}},"training_time":{"sum":{"field":"data_labors.trainingSeconds"}}}},"friday":{"filter":{"range":{"data_labors.timeStamp":{"gte":"' +
                    fri_gte +
                    '","lte":"' +
                    fri_lte +
                    '"}}},"aggs":{"regular_payment":{"sum":{"field":"data_labors.regPayment"}},"body_count":{"terms":{"field":"data_labors.scheduleCount.keyword"}},"body_count_dep":{"terms":{"field":"data_labors.departmentCount.keyword"}},"ovetime_payment":{"sum":{"field":"data_labors.overPayment"}},"regular_time":{"sum":{"field":"data_labors.baseSeconds"}},"ovetime_time":{"sum":{"field":"data_labors.overSeconds"}},"training_payment":{"sum":{"field":"data_labors.trainingPayment"}},"training_time":{"sum":{"field":"data_labors.trainingSeconds"}}}},"saturday":{"filter":{"range":{"data_labors.timeStamp":{"gte":"' +
                    sat_gte +
                    '","lte":"' +
                    sat_lte +
                    '"}}},"aggs":{"regular_payment":{"sum":{"field":"data_labors.regPayment"}},"body_count":{"terms":{"field":"data_labors.scheduleCount.keyword"}},"body_count_dep":{"terms":{"field":"data_labors.departmentCount.keyword"}},"ovetime_payment":{"sum":{"field":"data_labors.overPayment"}},"regular_time":{"sum":{"field":"data_labors.baseSeconds"}},"ovetime_time":{"sum":{"field":"data_labors.overSeconds"}},"training_payment":{"sum":{"field":"data_labors.trainingPayment"}},"training_time":{"sum":{"field":"data_labors.trainingSeconds"}}}},"sunday":{"filter":{"range":{"data_labors.timeStamp":{"gte":"' +
                    sun_gte +
                    '","lte":"' +
                    sun_lte +
                    '"}}},"aggs":{"regular_payment":{"sum":{"field":"data_labors.regPayment"}},"body_count":{"terms":{"field":"data_labors.scheduleCount.keyword"}},"body_count_dep":{"terms":{"field":"data_labors.departmentCount.keyword"}},"ovetime_payment":{"sum":{"field":"data_labors.overPayment"}},"regular_time":{"sum":{"field":"data_labors.baseSeconds"}},"ovetime_time":{"sum":{"field":"data_labors.overSeconds"}},"training_payment":{"sum":{"field":"data_labors.trainingPayment"}},"training_time":{"sum":{"field":"data_labors.trainingSeconds"}}}}}}}}}}'
                );
                //11
                requests.push(
                    '{"index":"eatos-orders","ignore_unavailable":true}'
                );
                requests.push(
                    '{"size":0,"query":{"bool":{"must":' +
                    conditions +
                    '}},"aggs":{"shift":{"terms":{"field":"service.keyword"},"aggs":{"service_name":{"terms":{"field":"service.keyword"}},"total":{"sum":{"field":"paymentAmount"}},"seats":{"value_count": {"field": "orderId.keyword"}},"this_week":{"date_histogram":{"field":"@timestamp","calendar_interval":"day","min_doc_count":0,"time_zone":"' +
                    time_zone +
                    '","format":"dd-MM-yyyy","extended_bounds":{"min":"' +
                    gte_f +
                    '","max":"' +
                    lte_f +
                    '"}},"aggs":{"total":{"sum":{"field":"paymentAmount"}},"seats":{"value_count": {"field": "orderId.keyword"}}}},"categories":{"terms":{"field":"product.main_category.productCategoryId"},"aggs":{"category_name":{"terms":{"field":"product.main_category.productCategoryName.keyword"}},"total":{"sum":{"field":"paymentAmount"}},"seats":{"value_count": {"field": "orderId.keyword"}},"this_week":{"date_histogram":{"field":"@timestamp","calendar_interval":"day","min_doc_count":0,"time_zone":"' +
                    time_zone +
                    '","format":"dd-MM-yyyy","extended_bounds":{"min":"' +
                    gte_f +
                    '","max":"' +
                    lte_f +
                    '"}},"aggs":{"total":{"sum":{"field":"paymentAmount"}},"seats":{"value_count": {"field": "orderId.keyword"}}}}}}}},"this_week":{"date_histogram":{"field":"@timestamp","calendar_interval":"day","min_doc_count":0,"time_zone":"' +
                    time_zone +
                    '","format":"dd-MM-yyyy","extended_bounds":{"min":"' +
                    gte_f +
                    '","max":"' +
                    lte_f +
                    '"}},"aggs":{"total":{"sum":{"field":"paymentAmount"}},"seats":{"value_count": {"field": "orderId.keyword"}}}}}}'
                );
                //12
                requests.push(
                    '{"index":"eatos-orders","ignore_unavailable":true}'
                );
                requests.push(
                    '{"size":0,"query":{"bool":{"must":' +
                    conditions2 +
                    '}},"aggs":{"shift":{"terms":{"field":"service.keyword"},"aggs":{"monday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    mon_gte +
                    '","lte": "' +
                    mon_lte +
                    '"}}},"aggs": {"total": {"sum": {"field": "totalPrice"}},"seats":{"value_count": {"field": "orderId.keyword"}}}},"tuesday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    tue_gte +
                    '","lte": "' +
                    tue_lte +
                    '"}}},"aggs": {"total": {"sum": {"field": "totalPrice"}},"seats":{"value_count": {"field": "orderId.keyword"}}}},"wednesday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    wed_gte +
                    '","lte": "' +
                    wed_lte +
                    '"}}},"aggs": {"total": {"sum": {"field": "totalPrice"}},"seats":{"value_count": {"field": "orderId.keyword"}}}},"thursday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    thu_gte +
                    '","lte": "' +
                    thu_lte +
                    '"}}},"aggs": {"total": {"sum": {"field": "totalPrice"}},"seats":{"value_count": {"field": "orderId.keyword"}}}},"friday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    fri_gte +
                    '","lte": "' +
                    fri_lte +
                    '"}}},"aggs": {"total": {"sum": {"field": "totalPrice"}},"seats":{"value_count": {"field": "orderId.keyword"}}}},"saturday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    sat_gte +
                    '","lte": "' +
                    sat_lte +
                    '"}}},"aggs": {"total": {"sum": {"field": "totalPrice"}},"seats":{"value_count": {"field": "orderId.keyword"}}}},"sunday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    sun_gte +
                    '","lte": "' +
                    sun_lte +
                    '"}}},"aggs": {"total": {"sum": {"field": "totalPrice"}},"seats":{"value_count": {"field": "orderId.keyword"}}}},"service_name":{"terms":{"field":"service.keyword"}},"categories":{"terms":{"field":"product.main_category.productCategoryName.keyword"},"aggs":{"category_name":{"terms":{"field":"product.main_category.productCategoryName.keyword"}},"monday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    mon_gte +
                    '","lte": "' +
                    mon_lte +
                    '"}}},"aggs": {"total": {"sum": {"field": "totalPrice"}},"seats":{"value_count": {"field": "orderId.keyword"}}}},"tuesday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    tue_gte +
                    '","lte": "' +
                    tue_lte +
                    '"}}},"aggs": {"total": {"sum": {"field": "totalPrice"}},"seats":{"value_count": {"field": "orderId.keyword"}}}},"wednesday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    wed_gte +
                    '","lte": "' +
                    wed_lte +
                    '"}}},"aggs": {"total": {"sum": {"field": "totalPrice"}},"seats":{"value_count": {"field": "orderId.keyword"}}}},"thursday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    thu_gte +
                    '","lte": "' +
                    thu_lte +
                    '"}}},"aggs": {"total": {"sum": {"field": "totalPrice"}},"seats":{"value_count": {"field": "orderId.keyword"}}}},"friday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    fri_gte +
                    '","lte": "' +
                    fri_lte +
                    '"}}},"aggs": {"total": {"sum": {"field": "totalPrice"}},"seats":{"value_count": {"field": "orderId.keyword"}}}},"saturday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    sat_gte +
                    '","lte": "' +
                    sat_lte +
                    '"}}},"aggs": {"total": {"sum": {"field": "totalPrice"}},"seats":{"value_count": {"field": "orderId.keyword"}}}},"sunday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    sun_gte +
                    '","lte": "' +
                    sun_lte +
                    '"}}},"aggs": {"total": {"sum": {"field": "totalPrice"}},"seats":{"value_count": {"field": "orderId.keyword"}}}},"prev_week":{"filter":{"range":{"@timestamp":{"gte":"' +
                    prev_gte +
                    '","lte":"' +
                    prev_lte +
                    '"}}},"aggs":{"total":{"sum":{"field":"subTotal"}},"seats":{"value_count": {"field": "orderId.keyword"}}}},"this_week":{"filter":{"range":{"@timestamp":{"gte":"' +
                    gte +
                    '","lte":"' +
                    lte +
                    '"}}},"aggs":{"total":{"sum":{"field":"subTotal"}},"seats":{"value_count": {"field": "orderId.keyword"}}}},"this_month":{"filter":{"range":{"@timestamp":{"gte":"' +
                    month_gte +
                    '","lte":"' +
                    month_lte +
                    '"}}},"aggs":{"total":{"sum":{"field":"subTotal"}},"seats":{"value_count": {"field": "orderId.keyword"}}}},"month_last_year":{"filter":{"range":{"@timestamp":{"gte":"' +
                    month_ly_gte +
                    '","lte":"' +
                    month_ly_lte +
                    '"}}},"aggs":{"total":{"sum":{"field":"subTotal"}},"seats":{"value_count": {"field": "orderId.keyword"}}}},"last_year":{"filter":{"range":{"@timestamp":{"gte":"' +
                    ly_gte +
                    '","lte":"' +
                    ly_lte +
                    '"}}},"aggs":{"total":{"sum":{"field":"subTotal"}},"seats":{"value_count": {"field": "orderId.keyword"}}}}}},"prev_week":{"filter":{"range":{"@timestamp":{"gte":"' +
                    prev_gte +
                    '","lte":"' +
                    prev_lte +
                    '"}}},"aggs":{"total":{"sum":{"field":"subTotal"}},"seats":{"value_count": {"field": "orderId.keyword"}}}},"this_week":{"filter":{"range":{"@timestamp":{"gte":"' +
                    gte +
                    '","lte":"' +
                    lte +
                    '"}}},"aggs":{"total":{"sum":{"field":"subTotal"}},"seats":{"value_count": {"field": "orderId.keyword"}}}},"this_month":{"filter":{"range":{"@timestamp":{"gte":"' +
                    month_gte +
                    '","lte":"' +
                    month_lte +
                    '"}}},"aggs":{"total":{"sum":{"field":"subTotal"}},"seats":{"value_count": {"field": "orderId.keyword"}}}},"month_last_year":{"filter":{"range":{"@timestamp":{"gte":"' +
                    month_ly_gte +
                    '","lte":"' +
                    month_ly_lte +
                    '"}}},"aggs":{"total":{"sum":{"field":"subTotal"}},"seats":{"value_count": {"field": "orderId.keyword"}}}},"last_year":{"filter":{"range":{"@timestamp":{"gte":"' +
                    ly_gte +
                    '","lte":"' +
                    ly_lte +
                    '"}}},"aggs":{"total":{"sum":{"field":"subTotal"}},"seats":{"value_count": {"field": "orderId.keyword"}}}}}},"prev_week":{"filter":{"range":{"@timestamp":{"gte":"' +
                    prev_gte +
                    '","lte":"' +
                    prev_lte +
                    '"}}},"aggs":{"total":{"sum":{"field":"subTotal"}},"seats":{"value_count": {"field": "orderId.keyword"}}}},"this_week":{"filter":{"range":{"@timestamp":{"gte":"' +
                    gte +
                    '","lte":"' +
                    lte +
                    '"}}},"aggs":{"total":{"sum":{"field":"subTotal"}},"seats":{"value_count": {"field": "orderId.keyword"}}}},"this_month":{"filter":{"range":{"@timestamp":{"gte":"' +
                    month_gte +
                    '","lte":"' +
                    month_lte +
                    '"}}},"aggs":{"total":{"sum":{"field":"subTotal"}},"seats":{"value_count": {"field": "orderId.keyword"}}}},"month_last_year":{"filter":{"range":{"@timestamp":{"gte":"' +
                    month_ly_gte +
                    '","lte":"' +
                    month_ly_lte +
                    '"}}},"aggs":{"total":{"sum":{"field":"subTotal"}},"seats":{"value_count": {"field": "orderId.keyword"}}}},"last_year":{"filter":{"range":{"@timestamp":{"gte":"' +
                    ly_gte +
                    '","lte":"' +
                    ly_lte +
                    '"}}},"aggs":{"total":{"sum":{"field":"subTotal"}},"seats":{"value_count": {"field": "orderId.keyword"}}}},"sunday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    sun_gte +
                    '","lte": "' +
                    sun_lte +
                    '"}}},"aggs": {"total": {"sum": {"field": "totalPrice"}},"seats":{"value_count": {"field": "orderId.keyword"}}}},"saturday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    sat_gte +
                    '","lte": "' +
                    sat_lte +
                    '"}}},"aggs": {"total": {"sum": {"field": "totalPrice"}},"seats":{"value_count": {"field": "orderId.keyword"}}}},"friday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    fri_gte +
                    '","lte": "' +
                    fri_lte +
                    '"}}},"aggs": {"total": {"sum": {"field": "totalPrice"}},"seats":{"value_count": {"field": "orderId.keyword"}}}},"thursday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    thu_gte +
                    '","lte": "' +
                    thu_lte +
                    '"}}},"aggs": {"total": {"sum": {"field": "totalPrice"}},"seats":{"value_count": {"field": "orderId.keyword"}}}},"wednesday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    wed_gte +
                    '","lte": "' +
                    wed_lte +
                    '"}}},"aggs": {"total": {"sum": {"field": "totalPrice"}},"seats":{"value_count": {"field": "orderId.keyword"}}}},"tuesday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    tue_gte +
                    '","lte": "' +
                    tue_lte +
                    '"}}},"aggs": {"total": {"sum": {"field": "totalPrice"}},"seats":{"value_count": {"field": "orderId.keyword"}}}},"monday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    mon_gte +
                    '","lte": "' +
                    mon_lte +
                    '"}}},"aggs": {"total": {"sum": {"field": "totalPrice"}},"seats":{"value_count": {"field": "orderId.keyword"}}}}}}'
                );

                /* New scripts First Graph */
                //13 Number of Bodies from Labor
                requests.push(
                    '{"index":"eatos-labor-services","ignore_unavailable":true}'
                );
                bar = 1;
                conditions5 =
                    '[{"term":{"employee.merchantId":{"value": "' +
                    merchantId +
                    '"}}}, {"term":{"workingPart.statusTime":{"value": ' +
                    bar +
                    '}}}, {"range":{"@timestamp":{"gte": "' +
                    custom_gte +
                    '","lte":"' +
                    custom_lte +
                    '"}}}';
                if (params["storeLocationId"]) {
                    conditions5 =
                        conditions5 +
                        ',{"term": {"employee.storeLocationId": {"value": "' +
                        params["storeLocationId"] +
                        '"}}}';
                }
                conditions5 = conditions5 + "]"; //Se le tiene que agregar un día extra para obtener los labors
                requests.push(
                    '{"size":0,"query":{"bool":{"must":' +
                    conditions5 +
                    '}},"aggs":{"time_interval":{"date_histogram":{"field":"@timestamp","calendar_interval":"day","min_doc_count":0,"time_zone":"' +
                    time_zone +
                    '","format":"dd-MM-yyyy","extended_bounds":{"min":"' +
                    custom_gte_format +
                    '","max":"' +
                    custom_lte_format +
                    '"}},"aggs":{"body_count":{"cardinality":{"field":"employee.employeeId"}}}}}}'
                );
                //15 Number of Seats
                conditions =
                    '[{"exists":{"field":"paymentId"}},{"bool":{"should":[{"term":{"paymentStatusId":{"value":3}}},{"term":{"paymentStatusId":{"value":4}}},{"nested":{"path":"refunds","query":{"bool":{"must":[[{"match":{"refunds.reason.keyword":"QSA"}},{"match":{"refunds.paymentStatusId": 5}}]]}}}}]}},{"term":{"merchantId":{"value": "' +
                    merchantId +
                    '"}}},{"range":{"@timestamp":{"gte": "' +
                    custom_gte +
                    '","lte":"' +
                    custom_lte +
                    '"}}}';
                if (params["storeLocationId"]) {
                    conditions =
                        conditions +
                        ',{"term": {"storeLocationId": {"value": "' +
                        params["storeLocationId"] +
                        '"}}}';
                }
                conditions = conditions + "]";
                //14
                requests.push(
                    '{"index":"eatos-orders","ignore_unavailable":true}'
                );
                requests.push(
                    '{"size":0,"query":{"bool":{"must":' +
                    conditions +
                    '}},"aggs":{"time_interval":{"date_histogram":{"field":"@timestamp","calendar_interval":"day","min_doc_count":0,"time_zone":"' +
                    time_zone +
                    '","format":"dd-MM-yyyy","extended_bounds":{"min":"' +
                    custom_gte_format +
                    '","max":"' +
                    custom_lte_format +
                    '"}},"aggs":{"seats":{"value_count": {"field": "orderId.keyword"}}}}}}'
                );
                /* New scripts First Graph */
                // By hours 15 en el json de vuelta
                requests.push(
                    '{"index":"eatos-labor-hours-daily","ignore_unavailable":true}'
                );
                requests.push(
                    '{"size":0,"query":{"bool":{"must":' +
                    conditions5 +
                    '}},"aggs":{"total":{"nested":{"path":"data_labors"},"aggs":{"time_interval":{"date_histogram":{"field":"data_labors.timeStamp","calendar_interval":"hour","min_doc_count":0,"time_zone":"' +
                    time_zone +
                    '","format":"dd-MM-yyyy","extended_bounds":{"min":"' +
                    custom_gte_format +
                    '","max":"' +
                    custom_lte_format2 +
                    '"}},"aggs":{"baseSeconds":{"sum":{"field":"data_labors.baseSeconds"}},"overSeconds":{"sum":{"field":"data_labors.overSeconds"}},"number":{"cardinality":{"field":"data_labors.employeeId"}}}}}}}}'
                );
                // Orders by Hours Too 16 en el json de vuelta
                requests.push(
                    '{"index":"eatos-orders","ignore_unavailable":true}'
                );
                requests.push(
                    '{"size":0,"query":{"bool":{"must":' +
                    conditions +
                    '}},"aggs":{"time_interval":{"date_histogram":{"field":"@timestamp","calendar_interval":"hour","min_doc_count":0,"time_zone":"' +
                    time_zone +
                    '","format":"dd-MM-yyyy","extended_bounds":{"min":"' +
                    custom_gte_format +
                    '","max":"' +
                    custom_lte_format2 +
                    '"}},"aggs":{"seats":{"value_count": {"field": "orderId.keyword"}}}}}}'
                );

                //GrossTransactionNet 17
                requests.push(
                    '{"index":"eatos-orders-products","ignore_unavailable":true}'
                );
                requests.push(
                    '{"size":0,"query":{"bool":{"must":' +
                    conditionsGross +
                    '}},"aggs":{"this_week":{"date_histogram":{"field":"@timestamp","calendar_interval":"day","min_doc_count":0,"time_zone":"' +
                    time_zone +
                    '","format":"dd-MM-yyyy","extended_bounds":{"min":"' +
                    custom_gte_format +
                    '","max":"' +
                    custom_lte_format2 +
                    '"}},"aggs":{"categories":{"terms":{"field":"product.main_category.productCategoryName.keyword","size":9999},"aggs":{"total":{"sum":{"field":"product.main_category.amount"}},"average":{"avg":{"script":"doc[\'product.main_category.amount\'].value - doc[\'product.main_category.totalCustomizationPrice\'].value"}},"subcategories":{"terms":{"field":"product.category.productCategoryName.keyword","size":9999},"aggs":{"total":{"sum":{"field":"product.category.amount"}},"totalCustomizationPrice":{"sum":{"field":"product.category.totalCustomizationPrice"}},"addonCount":{"sum":{"field":"product.addonCount"}},"quantity":{"sum":{"field":"quantity"}}}},"totalCustomizationPrice":{"sum":{"field":"product.main_category.totalCustomizationPrice"}},"addonCount":{"sum":{"field":"product.addonCount"}},"quantity":{"sum":{"field":"quantity"}}}}}}}}'
                );
                // Tax 18
                requests.push(
                    '{"index":"eatos-orders","ignore_unavailable":true}'
                );
                requests.push(
                    '{"size":10,"query":{"bool":{"must":' +
                    conditionsGross +
                    '}},"aggs":{"this_week":{"date_histogram":{"field":"@timestamp","calendar_interval":"day","min_doc_count":0,"time_zone":"' +
                    time_zone +
                    '","format":"dd-MM-yyyy","extended_bounds":{"min":"' +
                    custom_gte_format +
                    '","max":"' +
                    custom_lte_format2 +
                    '"}},"aggs":{"subtotal":{"sum":{"field":"subTotal"}},"tax":{"sum":{"field":"totalTax"}},"taxCount":{"sum":{"script":"doc[\'totalTax\'].value!= 0 ? 1 : 0"}},"serviceCharges":{"sum":{"field":"totalServiceCharge"}},"serviceChargeNoQSA": { "sum": { "field": "serviceChargeNoQSA" } },"serviceCount":{"sum":{"script":"doc[\'totalServiceCharge\'].value!= 0 ? 1 : 0"}},"tips":{"sum":{"field":"tips"}},"tipCount":{"sum":{"script":"doc[\'tips\'].value!= 0 ? 1 : 0"}},"total-without-discounts":{"sum":{"script":"doc[\'subTotal\'].value + doc[\'totalTax\'].value + doc[\'totalServiceCharge\'].value"}},"customItemsValue":{"sum":{"field":"customItemsValue"}},"customItemsQuantity":{"sum":{"field":"customItemsQuantity"}},"giftCardsQuantity":{"sum":{"field":"giftCardsQuantity"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}}}}'
                );
                //GrossTransactionNet  19
                requests.push(
                    '{"index":"eatos-orders-products","ignore_unavailable":true}'
                );
                requests.push(
                    '{"size":0,"query":{"bool":{"must":' +
                    conditionsGross +
                    '}},"aggs":{"this_week":{"date_histogram":{"field":"@timestamp","calendar_interval":"hour","min_doc_count":0,"time_zone":"' +
                    time_zone +
                    '","format":"dd-MM-yyyy","extended_bounds":{"min":"' +
                    custom_gte_format +
                    '","max":"' +
                    custom_lte_format2 +
                    '"}},"aggs":{"categories":{"terms":{"field":"product.main_category.productCategoryName.keyword","size":9999},"aggs":{"total":{"sum":{"field":"product.main_category.amount"}},"average":{"avg":{"script":"doc[\'product.main_category.amount\'].value - doc[\'product.main_category.totalCustomizationPrice\'].value"}},"subcategories":{"terms":{"field":"product.category.productCategoryName.keyword","size":9999},"aggs":{"total":{"sum":{"field":"product.category.amount"}},"totalCustomizationPrice":{"sum":{"field":"product.category.totalCustomizationPrice"}},"addonCount":{"sum":{"field":"product.addonCount"}},"quantity":{"sum":{"field":"quantity"}}}},"totalCustomizationPrice":{"sum":{"field":"product.main_category.totalCustomizationPrice"}},"addonCount":{"sum":{"field":"product.addonCount"}},"quantity":{"sum":{"field":"quantity"}}}}}}}}'
                );
                // Tax 20
                requests.push(
                    '{"index":"eatos-orders","ignore_unavailable":true}'
                );
                requests.push(
                    '{"size":10,"query":{"bool":{"must":' +
                    conditionsGross +
                    '}},"aggs":{"this_week":{"date_histogram":{"field":"@timestamp","calendar_interval":"hour","min_doc_count":0,"time_zone":"' +
                    time_zone +
                    '","format":"dd-MM-yyyy","extended_bounds":{"min":"' +
                    custom_gte_format +
                    '","max":"' +
                    custom_lte_format2 +
                    '"}},"aggs":{"subtotal":{"sum":{"field":"subTotal"}},"tax":{"sum":{"field":"totalTax"}},"taxCount":{"sum":{"script":"doc[\'totalTax\'].value!= 0 ? 1 : 0"}},"serviceCharges":{"sum":{"field":"totalServiceCharge"}},"serviceChargeNoQSA": { "sum": { "field": "serviceChargeNoQSA" } },"serviceCount":{"sum":{"script":"doc[\'totalServiceCharge\'].value!= 0 ? 1 : 0"}},"tips":{"sum":{"field":"tips"}},"tipCount":{"sum":{"script":"doc[\'tips\'].value!= 0 ? 1 : 0"}},"total-without-discounts":{"sum":{"script":"doc[\'subTotal\'].value + doc[\'totalTax\'].value + doc[\'totalServiceCharge\'].value"}},"customItemsValue":{"sum":{"field":"customItemsValue"}},"customItemsQuantity":{"sum":{"field":"customItemsQuantity"}},"giftCardsQuantity":{"sum":{"field":"giftCardsQuantity"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}}}}'
                );
                // 21
                // Information of Labor by days divided by department  #Recibir toda la info y filtrarla aquí, es lo mejor, así se le podrá agregar más data después en el mismo query
                requests.push(
                    '{"index":"eatos-labor-hours-daily","ignore_unavailable":true}'
                );
                requests.push(
                    '{"size":0,"query":{"bool":{"must":' +
                    conditions5 +
                    '}},"aggs":{"total":{"nested":{"path":"data_labors"},"aggs":{"time_interval":{"date_histogram":{"field":"data_labors.timeStamp","calendar_interval":"day","min_doc_count":0,"time_zone":"' +
                    time_zone +
                    '","format":"dd-MM-yyyy","extended_bounds":{"min":"' +
                    custom_gte_format +
                    '","max":"' +
                    custom_lte_format +
                    '"}},"aggs":{"department":{"terms":{"field":"data_labors.department.keyword","size":9999},"aggs":{"regPayment":{"sum":{"field":"data_labors.regPayment"}},"overPayment":{"sum":{"script": "doc[\'data_labors.overPayment\'].value + doc[\'data_labors.doublePayment\'].value"}},"numberEmployees":{"cardinality":{"field":"data_labors.employeeId"}}}}}}}}}}'
                );
                // 22
                // The same from above but by hours
                requests.push(
                    '{"index":"eatos-labor-hours-daily","ignore_unavailable":true}'
                );
                requests.push(
                    '{"size":0,"query":{"bool":{"must":' +
                    conditions5 +
                    '}},"aggs":{"total":{"nested":{"path":"data_labors"},"aggs":{"time_interval":{"date_histogram":{"field":"data_labors.timeStamp","calendar_interval":"hour","min_doc_count":0,"time_zone":"' +
                    time_zone +
                    '","format":"dd-MM-yyyy","extended_bounds":{"min":"' +
                    custom_gte_format +
                    '","max":"' +
                    custom_lte_format2 +
                    '"}},"aggs":{"department":{"terms":{"field":"data_labors.department.keyword","size":9999},"aggs":{"regPayment":{"sum":{"field":"data_labors.regPayment"}},"overPayment":{"sum":{"script": "doc[\'data_labors.overPayment\'].value + doc[\'data_labors.doublePayment\'].value"}},"numberEmployees":{"cardinality":{"field":"data_labors.employeeId"}}}}}}}}}}'
                );
                /////////////////////////////////////////////////////
                //23 custom items and giftcard
                /**23 */ requests.push(
                    '{"index":"eatos-orders","ignore_unavailable":true}'
                );
                /*1 */ requests.push(
                    '{"size":0,"query":{"bool":{"must":' +
                    conditions2 +
                    '}},"aggs":{"shift":{"terms":{"field":"service.keyword", "size": 9999},"aggs":{"monday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    mon_gte +
                    '","lte": "' +
                    mon_lte +
                    '"}}},"aggs": {"total": {"sum": {"field": "total"}},"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}},"tuesday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    tue_gte +
                    '","lte": "' +
                    tue_lte +
                    '"}}},"aggs": {"total": {"sum": {"field": "total"}},"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}},"wednesday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    wed_gte +
                    '","lte": "' +
                    wed_lte +
                    '"}}},"aggs": {"total": {"sum": {"field": "total"}},"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}},"thursday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    thu_gte +
                    '","lte": "' +
                    thu_lte +
                    '"}}},"aggs": {"total": {"sum": {"field": "total"}},"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}},"friday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    fri_gte +
                    '","lte": "' +
                    fri_lte +
                    '"}}},"aggs": {"total": {"sum": {"field": "total"}},"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}},"saturday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    sat_gte +
                    '","lte": "' +
                    sat_lte +
                    '"}}},"aggs": {"total": {"sum": {"field": "total"}},"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}},"sunday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    sun_gte +
                    '","lte": "' +
                    sun_lte +
                    '"}}},"aggs": {"total": {"sum": {"field": "total"}},"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}},"service_name":{"terms":{"field":"service.keyword"}},"categories":{"terms":{"field":"product.main_category.productCategoryName.keyword"},"aggs":{"category_name":{"terms":{"field":"product.main_category.productCategoryName.keyword"}},"monday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    mon_gte +
                    '","lte": "' +
                    mon_lte +
                    '"}}},"aggs": {"total": {"sum": {"field": "total"}},"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}},"tuesday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    tue_gte +
                    '","lte": "' +
                    tue_lte +
                    '"}}},"aggs": {"total": {"sum": {"field": "total"}},"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}},"wednesday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    wed_gte +
                    '","lte": "' +
                    wed_lte +
                    '"}}},"aggs": {"total": {"sum": {"field": "total"}},"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}},"thursday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    thu_gte +
                    '","lte": "' +
                    thu_lte +
                    '"}}},"aggs": {"total": {"sum": {"field": "total"}},"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}},"friday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    fri_gte +
                    '","lte": "' +
                    fri_lte +
                    '"}}},"aggs": {"total": {"sum": {"field": "total"}},"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}},"saturday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    sat_gte +
                    '","lte": "' +
                    sat_lte +
                    '"}}},"aggs": {"total": {"sum": {"field": "total"}},"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}},"sunday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    sun_gte +
                    '","lte": "' +
                    sun_lte +
                    '"}}},"aggs": {"total": {"sum": {"field": "total"}},"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}},"prev_week":{"filter":{"range":{"@timestamp":{"gte":"' +
                    prev_gte +
                    '","lte":"' +
                    prev_lte +
                    '"}}},"aggs":{"total":{"sum":{"field":"total"}},"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}},"this_week":{"filter":{"range":{"@timestamp":{"gte":"' +
                    gte +
                    '","lte":"' +
                    lte +
                    '"}}},"aggs":{"total":{"sum":{"field":"total"}},"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}},"this_month":{"filter":{"range":{"@timestamp":{"gte":"' +
                    month_gte +
                    '","lte":"' +
                    month_lte +
                    '"}}},"aggs":{"total":{"sum":{"field":"total"}},"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}},"month_last_year":{"filter":{"range":{"@timestamp":{"gte":"' +
                    month_ly_gte +
                    '","lte":"' +
                    month_ly_lte +
                    '"}}},"aggs":{"total":{"sum":{"field":"total"}},"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}},"last_year":{"filter":{"range":{"@timestamp":{"gte":"' +
                    ly_gte +
                    '","lte":"' +
                    ly_lte +
                    '"}}},"aggs":{"total":{"sum":{"field":"total"}},"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}}}},"prev_week":{"filter":{"range":{"@timestamp":{"gte":"' +
                    prev_gte +
                    '","lte":"' +
                    prev_lte +
                    '"}}},"aggs":{"total":{"sum":{"field":"total"}},"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}},"this_week":{"filter":{"range":{"@timestamp":{"gte":"' +
                    gte +
                    '","lte":"' +
                    lte +
                    '"}}},"aggs":{"total":{"sum":{"field":"total"}},"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}},"this_month":{"filter":{"range":{"@timestamp":{"gte":"' +
                    month_gte +
                    '","lte":"' +
                    month_lte +
                    '"}}},"aggs":{"total":{"sum":{"field":"total"}},"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}},"month_last_year":{"filter":{"range":{"@timestamp":{"gte":"' +
                    month_ly_gte +
                    '","lte":"' +
                    month_ly_lte +
                    '"}}},"aggs":{"total":{"sum":{"field":"total"}},"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}},"last_year":{"filter":{"range":{"@timestamp":{"gte":"' +
                    ly_gte +
                    '","lte":"' +
                    ly_lte +
                    '"}}},"aggs":{"total":{"sum":{"field":"total"}},"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}}}},"prev_week":{"filter":{"range":{"@timestamp":{"gte":"' +
                    prev_gte +
                    '","lte":"' +
                    prev_lte +
                    '"}}},"aggs":{"total":{"sum":{"field":"total"}},"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}},"this_week":{"filter":{"range":{"@timestamp":{"gte":"' +
                    gte +
                    '","lte":"' +
                    lte +
                    '"}}},"aggs":{"total":{"sum":{"field":"total"}},"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}},"this_month":{"filter":{"range":{"@timestamp":{"gte":"' +
                    month_gte +
                    '","lte":"' +
                    month_lte +
                    '"}}},"aggs":{"total":{"sum":{"field":"total"}},"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}},"month_last_year":{"filter":{"range":{"@timestamp":{"gte":"' +
                    month_ly_gte +
                    '","lte":"' +
                    month_ly_lte +
                    '"}}},"aggs":{"total":{"sum":{"field":"total"}},"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}},"last_year":{"filter":{"range":{"@timestamp":{"gte":"' +
                    ly_gte +
                    '","lte":"' +
                    ly_lte +
                    '"}}},"aggs":{"total":{"sum":{"field":"total"}},"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}},"sunday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    sun_gte +
                    '","lte": "' +
                    sun_lte +
                    '"}}},"aggs": {"total": {"sum": {"field": "total"}},"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}},"saturday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    sat_gte +
                    '","lte": "' +
                    sat_lte +
                    '"}}},"aggs": {"total": {"sum": {"field": "total"}},"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}},"friday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    fri_gte +
                    '","lte": "' +
                    fri_lte +
                    '"}}},"aggs": {"total": {"sum": {"field": "total"}},"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}},"thursday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    thu_gte +
                    '","lte": "' +
                    thu_lte +
                    '"}}},"aggs": {"total": {"sum": {"field": "total"}},"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}},"wednesday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    wed_gte +
                    '","lte": "' +
                    wed_lte +
                    '"}}},"aggs": {"total": {"sum": {"field": "total"}},"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}},"tuesday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    tue_gte +
                    '","lte": "' +
                    tue_lte +
                    '"}}},"aggs": {"total": {"sum": {"field": "total"}},"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}},"monday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    mon_gte +
                    '","lte": "' +
                    mon_lte +
                    '"}}},"aggs": {"total": {"sum": {"field": "total"}},"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}}}}'
                );
                /*       echo json_encode(requests);
			exit; */
                // Thirth Table
                /**24 */ requests.push(
                    '{"index":"eatos-orders","ignore_unavailable":true}'
                );
                /**24 */ requests.push(
                    '{"size":0,"query":{"bool":{"must":' +
                    conditions +
                    '}},"aggs":{"type":{"terms":{"field":"type.id", "size": 9999},"aggs":{"type_name":{"terms":{"field":"type.name.keyword"}},"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}},"tuesday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    tue_gte +
                    '","lte": "' +
                    tue_lte +
                    '"}}},"aggs": {"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}},"monday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    mon_gte +
                    '","lte": "' +
                    mon_lte +
                    '"}}},"aggs": {"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}},"this_week":{"date_histogram":{"field":"@timestamp","calendar_interval":"day","min_doc_count":0,"time_zone":"' +
                    time_zone +
                    '","format":"dd-MM-yyyy","extended_bounds":{"min":"' +
                    gte_f +
                    '","max":"' +
                    lte_f +
                    '"}},"aggs":{"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}}}},"this_week":{"date_histogram":{"field":"@timestamp","calendar_interval":"day","min_doc_count":0,"time_zone":"' +
                    time_zone +
                    '","format":"dd-MM-yyyy","extended_bounds":{"min":"' +
                    gte_f +
                    '","max":"' +
                    lte_f +
                    '"}},"aggs":{"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}}}}'
                );
                /**25 */ requests.push(
                    '{"index":"eatos-orders","ignore_unavailable":true}'
                );
                /**25 */ requests.push(
                    '{"size":0,"query":{"bool":{"must":' +
                    conditions2 +
                    '}},"aggs":{"type":{"terms":{"field":"type.id", "size": 9999},"aggs":{"name":{"terms":{"field":"type.name.keyword"}},"prev_week":{"filter":{"range":{"@timestamp":{"gte":"' +
                    prev_gte +
                    '","lte":"' +
                    prev_lte +
                    '"}}},"aggs":{"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}},"sunday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    sun_gte +
                    '","lte": "' +
                    sun_lte +
                    '"}}},"aggs": {"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}},"saturday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    sat_gte +
                    '","lte": "' +
                    sat_lte +
                    '"}}},"aggs": {"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}},"friday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    fri_gte +
                    '","lte": "' +
                    fri_lte +
                    '"}}},"aggs": {"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}},"thursday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    thu_gte +
                    '","lte": "' +
                    thu_lte +
                    '"}}},"aggs": {"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}},"wednesday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    wed_gte +
                    '","lte": "' +
                    wed_lte +
                    '"}}},"aggs": {"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}},"tuesday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    tue_gte +
                    '","lte": "' +
                    tue_lte +
                    '"}}},"aggs": {"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}},"monday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    mon_gte +
                    '","lte": "' +
                    mon_lte +
                    '"}}},"aggs": {"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}},"this_week":{"filter":{"range":{"@timestamp":{"gte":"' +
                    gte +
                    '","lte":"' +
                    lte +
                    '"}}},"aggs":{"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}},"this_month":{"filter":{"range":{"@timestamp":{"gte":"' +
                    month_gte +
                    '","lte":"' +
                    month_lte +
                    '"}}},"aggs":{"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}},"month_last_year":{"filter":{"range":{"@timestamp":{"gte":"' +
                    month_ly_gte +
                    '","lte":"' +
                    month_ly_lte +
                    '"}}},"aggs":{"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}},"last_year":{"filter":{"range":{"@timestamp":{"gte":"' +
                    ly_gte +
                    '","lte":"' +
                    ly_lte +
                    '"}}},"aggs":{"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}}}},"prev_week":{"filter":{"range":{"@timestamp":{"gte":"' +
                    prev_gte +
                    '","lte":"' +
                    prev_lte +
                    '"}}},"aggs":{"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}},"this_week":{"filter":{"range":{"@timestamp":{"gte":"' +
                    gte +
                    '","lte":"' +
                    lte +
                    '"}}},"aggs":{"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}},"this_month":{"filter":{"range":{"@timestamp":{"gte":"' +
                    month_gte +
                    '","lte":"' +
                    month_lte +
                    '"}}},"aggs":{"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}},"month_last_year":{"filter":{"range":{"@timestamp":{"gte":"' +
                    month_ly_gte +
                    '","lte":"' +
                    month_ly_lte +
                    '"}}},"aggs":{"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}},"last_year":{"filter":{"range":{"@timestamp":{"gte":"' +
                    ly_gte +
                    '","lte":"' +
                    ly_lte +
                    '"}}},"aggs":{"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}},"sunday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    sun_gte +
                    '","lte": "' +
                    sun_lte +
                    '"}}},"aggs": {"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}},"saturday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    sat_gte +
                    '","lte": "' +
                    sat_lte +
                    '"}}},"aggs": {"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}},"friday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    fri_gte +
                    '","lte": "' +
                    fri_lte +
                    '"}}},"aggs": {"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}},"thursday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    thu_gte +
                    '","lte": "' +
                    thu_lte +
                    '"}}},"aggs": {"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}},"wednesday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    wed_gte +
                    '","lte": "' +
                    wed_lte +
                    '"}}},"aggs": {"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}},"tuesday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    tue_gte +
                    '","lte": "' +
                    tue_lte +
                    '"}}},"aggs": {"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}},"monday": {"filter": {"range": {"@timestamp": {"gte":"' +
                    mon_gte +
                    '","lte": "' +
                    mon_lte +
                    '"}}},"aggs": {"customItemsValue":{"sum":{"field":"customItemsValue"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}}}}'
                );
            } else {
                return this.reportError();
            }

            var firstPart = await this.callReports(requests.slice(0, 12));
            var secondPart = await this.callReports(requests.slice(12, 24));
            var thirdPart = await this.callReports(requests.slice(24, 36));
            var fourthPart = await this.callReports(requests.slice(36, 52));
            var joined = { responses: [] };
            joined.responses = joined.responses.concat(firstPart.responses);
            joined.responses = joined.responses.concat(secondPart.responses);
            joined.responses = joined.responses.concat(thirdPart.responses);
            joined.responses = joined.responses.concat(fourthPart.responses);

            return new Promise((resolve, reject) => {
                resolve(joined.responses);
            });
        }

        reportError() {
            return new Promise((resolve, reject) => {
                resolve(
                    JSON.stringify({
                        success: 0,
                        errorCode: "eP-UI-100",
                        message: "Format Error",
                        messageDetails: ["Invalid or incomplete parameters"]
                    })
                );
            });
        }

        async grossTransactionReport2(params, cookie) {
            var merchantId = cookie.get("merchantId");
            this.elasticheaders2.Authorization = cookie.get("token");
            var requests = [];

            let condition = '{"size":0,"query":{"bool":{"must":[' +
                (params["storeLocationId"] ? '{"term":{"store.id":{"value":"' + params["storeLocationId"] + '"}}},' : '') +
                (params["service"] && params["service"] != 'All' ? '{"term":{"service.name":{"value":"' + params["service"] + '"}}},' : '') +
                '{"term":{"merchantId":{"value":"' +
                merchantId +
                '"}}},{"range":{"@timestamp":{"gte":' +
                params["gte"] +
                ',"lte":' +
                params["lte"] +
                '}}}]}},"aggs":{' +
                '"covers": {"sum": {"script": "doc[\'amount.total\'].value > doc[\'amount.refunded\'].value ? doc[\'covers\'].value : 0"}},"transactions":{"nested":{"path":"transactions"},"aggs":{"total":{"sum":{"field":"transactions.amount"}},"type":{"terms":{"field":"transactions.type.name"},"aggs":{"total":{"sum":{"field":"transactions.amount"}},"count":{"sum":{"script":"doc[\'transactions.amount\'].value > 0 && doc[\'transactions.status.id\'].value != 3 ? 1 : 0"}}}}}},"products":{"nested":{"path":"products"},"aggs":{"categories":{"terms":{"field":"products.category.name"},"aggs":{"quantity": {"sum": {"script": "!doc[\'products.refunded\'].value || doc[\'products.reason\'].value == \'QSA\' ? doc[\'products.quantity\'].value : 0"}},"total":{"sum":{"script":"!doc[\'products.refunded\'].value || doc[\'products.reason\'].value == \'QSA\' ? doc[\'products.price\'].value - (doc[\'products.addons\'].value * doc[\'products.quantity\'].value) : 0"}},"subcategories":{"terms":{"field":"products.subcategory.name"},"aggs":{"total":{"sum":{"script":"!doc[\'products.refunded\'].value || doc[\'products.reason\'].value == \'QSA\' ? doc[\'products.price\'].value - (doc[\'products.addons\'].value * doc[\'products.quantity\'].value) : 0"}},"quantity":{"sum":{"script":"!doc[\'products.refunded\'].value || doc[\'products.reason\'].value == \'QSA\' ? doc[\'products.quantity\'].value : 0"}}}}}},"addons":{"sum":{"script":"!doc[\'products.refunded\'].value || doc[\'products.reason\'].value == \'QSA\' ? doc[\'products.addons\'].value * doc[\'products.quantity\'].value : 0"}},"addonsCount": {"sum": {"script": "(!doc[\'products.refunded\'].value || doc[\'products.reason\'].value == \'QSA\') && doc[\'products.addons\'].value > 0 ? doc[\'products.quantity\'].value : 0"}},"discount":{"terms":{"field":"products.discount.reason"},"aggs":{"total":{"sum":{"script":"!doc[\'products.refunded\'].value || doc[\'products.reason\'].value == \'QSA\' ? doc[\'products.discount.total\'].value : 0"}},"count":{"sum":{"script":"!doc[\'products.refunded\'].value || doc[\'products.reason\'].value == \'QSA\' ? doc[\'products.quantity\'].value : 0"}}}}}},"tax":{"sum":{"script":"doc[\'tax.QSA\'].value > 0 ? doc[\'tax.total\'].value - doc[\'tax.QSA\'].value : doc[\'tax.total\'].value - doc[\'tax.refunded\'].value"}},"taxCount": {"sum": {"script": "doc[\'tax.QSA\'].value > 0 ? doc[\'tax.total\'].value - doc[\'tax.QSA\'].value > 0 ? 1 : 0 : doc[\'tax.total\'].value - doc[\'tax.refunded\'].value > 0 ? 1 : 0"}},"tips":{"sum":{"script":"doc[\'amount.total\'].value > doc[\'amount.refunded\'].value ? doc[\'tips\'].value : 0"}},"tipsCount": {"sum": {"script": "doc[\'amount.total\'].value > doc[\'amount.refunded\'].value && doc[\'tips\'].value > 0 ? 1 : 0"}},"serviceCharges":{"sum":{"script":"doc[\'serviceCharges.total\'].value - doc[\'serviceCharges.refunded\'].value"}}, "QSA":{"sum":{"script":"doc[\'amount.QSA\'].value - doc[\'tax.QSA\'].value"}},"QSACount": {"sum": {"script": "doc[\'amount.QSA\'].value  - doc[\'tax.QSA\'].value> 0 ? 1 : 0"}}}}'

            requests.push('{"index":"eatos-v2-orders","ignore_unavailable":true}')
            requests.push(condition)

            return this.callReports(requests).then((res: any) => {
                return res.responses;
            });
        }

        async grossTransactionShiftReport2(params, cookie) {
            var merchantId = cookie.get("merchantId");
            this.elasticheaders2.Authorization = cookie.get("token");
            var requests = [];

            let condition = '{"size":0,"query":{"bool":{"must":[' +
                (params["storeLocationId"] ? '{"term":{"store.id":{"value":"' + params["storeLocationId"] + '"}}},' : '') +
                (params["service"] && params["service"] != 'All' ? '{"term":{"service.name":{"value":"' + params["service"] + '"}}},' : '') +
                '{"term":{"merchantId":{"value":"' +
                merchantId +
                '"}}},{"range":{"@timestamp":{"gte":' +
                params["gte"] +
                ',"lte":' +
                params["lte"] +
                '}}}]}},"aggs":{' +
                '"service": {"terms": {"field": "service.name"},"aggs": {' +
                '"covers": {"sum": {"script": "doc[\'amount.total\'].value > doc[\'amount.refunded\'].value ? doc[\'covers\'].value : 0"}},"transactions":{"nested":{"path":"transactions"},"aggs":{"total":{"sum":{"field":"transactions.amount"}},"type":{"terms":{"field":"transactions.type.name"},"aggs":{"total":{"sum":{"field":"transactions.amount"}},"count":{"sum":{"script":"doc[\'transactions.amount\'].value > 0 && doc[\'transactions.status.id\'].value != 3 ? 1 : 0"}}}}}},"products":{"nested":{"path":"products"},"aggs":{"categories":{"terms":{"field":"products.category.name"},"aggs":{"quantity": {"sum": {"script": "!doc[\'products.refunded\'].value || doc[\'products.reason\'].value == \'QSA\' ? doc[\'products.quantity\'].value : 0"}},"total":{"sum":{"script":"!doc[\'products.refunded\'].value || doc[\'products.reason\'].value == \'QSA\' ? doc[\'products.price\'].value - (doc[\'products.addons\'].value * doc[\'products.quantity\'].value) : 0"}},"subcategories":{"terms":{"field":"products.subcategory.name"},"aggs":{"total":{"sum":{"script":"!doc[\'products.refunded\'].value || doc[\'products.reason\'].value == \'QSA\' ? doc[\'products.price\'].value - (doc[\'products.addons\'].value * doc[\'products.quantity\'].value) : 0"}},"quantity":{"sum":{"script":"!doc[\'products.refunded\'].value || doc[\'products.reason\'].value == \'QSA\' ? doc[\'products.quantity\'].value : 0"}}}}}},"addons":{"sum":{"script":"!doc[\'products.refunded\'].value || doc[\'products.reason\'].value == \'QSA\' ? doc[\'products.addons\'].value * doc[\'products.quantity\'].value : 0"}},"addonsCount": {"sum": {"script": "(!doc[\'products.refunded\'].value || doc[\'products.reason\'].value == \'QSA\') && doc[\'products.addons\'].value > 0 ? doc[\'products.quantity\'].value : 0"}},"discount":{"terms":{"field":"products.discount.reason"},"aggs":{"total":{"sum":{"script":"!doc[\'products.refunded\'].value || doc[\'products.reason\'].value == \'QSA\' ? doc[\'products.discount.total\'].value : 0"}},"count":{"sum":{"script":"!doc[\'products.refunded\'].value || doc[\'products.reason\'].value == \'QSA\' ? doc[\'products.quantity\'].value : 0"}}}}}},"tax":{"sum":{"script":"doc[\'tax.QSA\'].value > 0 ? doc[\'tax.total\'].value - doc[\'tax.QSA\'].value : doc[\'tax.total\'].value - doc[\'tax.refunded\'].value"}},"taxCount": {"sum": {"script": "doc[\'tax.QSA\'].value > 0 ? doc[\'tax.total\'].value - doc[\'tax.QSA\'].value > 0 ? 1 : 0 : doc[\'tax.total\'].value - doc[\'tax.refunded\'].value > 0 ? 1 : 0"}},"tips":{"sum":{"script":"doc[\'amount.total\'].value > doc[\'amount.refunded\'].value ? doc[\'tips\'].value : 0"}},"tipsCount": {"sum": {"script": "doc[\'amount.total\'].value > doc[\'amount.refunded\'].value && doc[\'tips\'].value > 0 ? 1 : 0"}},"serviceCharges":{"sum":{"script":"doc[\'serviceCharges.total\'].value - doc[\'serviceCharges.refunded\'].value"}}, "QSA":{"sum":{"script":"doc[\'amount.QSA\'].value - doc[\'tax.QSA\'].value"}},"QSACount": {"sum": {"script": "doc[\'amount.QSA\'].value  - doc[\'tax.QSA\'].value> 0 ? 1 : 0"}}}}'
                + '}}'
            requests.push('{"index":"eatos-v2-orders","ignore_unavailable":true}')
            console.log('condition', condition)
            requests.push(condition)

            return this.callReports(requests).then((res: any) => {
                return res.responses;
            });
        }

        async grosstransactionsreport(params, cookie) {
            var merchantId = cookie.get("merchantId");
            this.elasticheaders2.Authorization = cookie.get("token");
            var requests = [];

            /*             params["gte"]=1571428980000;
            params["lte"]=1571429100000; */
            if (params["gte"] && params["lte"]) {
                var gte = params["gte"];
                var lte = params["lte"];
                // Conditions
                if (params["tips"] == 1) {
                    var tips =
                        '[{"term":{"paymentStatusId":{"value":3}}},{"term":{"paymentStatusId":{"value":4}}},{"nested":{"path":"refunds","query":{"bool":{"must":[{"match":{"refunds.reason.keyword":"QSA"}},{"match":{"refunds.paymentStatusId": 5}}]}}}}]';
                } else {
                    var tips =
                        '[{"term":{"paymentStatusId":{"value":3}}},{"term":{"paymentStatusId":{"value":4}}},{"nested":{"path":"refunds","query":{"bool":{"must":[{"match":{"refunds.reason.keyword":"QSA"}},{"match":{"refunds.paymentStatusId": 5}}]}}}}]';
                }

                var conditions =
                    '[{"exists":{"field":"paymentId"}},{"bool":{"should":' +
                    tips +
                    '}},{"term":{"merchantId":{"value": "' +
                    merchantId +
                    '"}}},{"range":{"@timestamp":{"gte": ' +
                    gte +
                    ',"lte":' +
                    lte +
                    "}}}";
                if (params["storeLocationId"]) {
                    conditions =
                        conditions +
                        ',{"term": {"storeLocationId": {"value": "' +
                        params["storeLocationId"] +
                        '"}}}';
                }
                conditions = conditions + "]";

                if (params["option"] == "all") {
                    // Categories
                    requests.push(
                        '{"index":"eatos-orders-products","ignore_unavailable":true}'
                    );
                    requests.push(
                        '{"size":0,"query":{"bool":{"must":' +
                        conditions +
                        '}},"aggs":{"categories":{"terms":{"field":"product.main_category.productCategoryName.keyword","size":9999},"aggs":{"total":{"sum":{"script":"doc[\'product.main_category.amount\'].value"}},"average":{"avg":{"script":"doc[\'product.main_category.amount\'].value - doc[\'product.main_category.totalCustomizationPrice\'].value"}},"subcategories":{"terms":{"field":"product.category.productCategoryName.keyword","size":9999},"aggs":{"total":{"sum":{"script":"doc[\'product.category.amount\'].value"}},"totalCustomizationPrice":{"sum":{"field":"product.category.totalCustomizationPrice"}},"addonCount":{"sum":{"field":"adjustments"}},"quantity":{"sum":{"field":"quantity"}}}},"totalCustomizationPrice":{"sum":{"field":"product.main_category.totalCustomizationPrice"}},"addonCount":{"sum":{"field":"adjustments"}},"quantity":{"sum":{"field":"quantity"}}}}}}'
                    );
                    // Tax
                    requests.push(
                        '{"index":"eatos-orders","ignore_unavailable":true}'
                    );
                    requests.push(
                        '{"size":10,"query":{"bool":{"must":' +
                        conditions +
                        '}},"aggs":{"subtotal":{"sum":{"field":"subTotal"}},"tax":{"sum":{"field":"totalTax"}},"taxCount":{"sum":{"script":"doc[\'totalTax\'].value!= 0 ? 1 : 0"}},"serviceCharges":{"sum":{"field":"totalServiceCharge"}},"serviceChargeNoQSA": { "sum": { "field": "serviceChargeNoQSA" } },"serviceCount":{"sum":{"script":"doc[\'totalServiceCharge\'].value!= 0 ? 1 : 0"}},"tips":{"sum":{"field":"tips"}},"pendingTips":{"sum":{"field":"pendingTips"}},"tipCount":{"sum":{"script":"doc[\'tips\'].value!= 0 ? 1 : 0"}},"pendingTipCount":{"sum":{"script":"doc[\'pendingTips\'].value!= 0 ? 1 : 0"}},"total-without-discounts":{"sum":{"script":"doc[\'subTotal\'].value + doc[\'totalTax\'].value + doc[\'totalServiceCharge\'].value"}},"customItemsValue":{"sum":{"field":"customItemsValue"}},"customItemsQuantity":{"sum":{"field":"customItemsQuantity"}},"giftCardsQuantity":{"sum":{"field":"giftCardsQuantity"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}}'
                    );
                    // TransactionTypes
                    /*         if(params["tips"] == 0){
					tips = '{"script": "doc[\'nestedTransactionTypes.amount\'].value - doc[\'nestedTransactionTypes.tip\'].value"}';
				  }else{
					tips = '{"script": "doc[\'nestedTransactionTypes.amount\'].value - doc[\'nestedTransactionTypes.tip\'].value"}';
				  } */
                    tips =
                        '{"script": "doc[\'nestedTransactionTypes.amount\'].value"}';
                    requests.push(
                        '{"index":"eatos-orders","ignore_unavailable":true}'
                    );
                    requests.push(
                        '{"size":10,"query":{"bool":{"must":' +
                        conditions +
                        '}},"aggs":{"paytypes":{"nested":{"path":"nestedTransactionTypes"},"aggs":{"type":{"terms":{"field":"nestedTransactionTypes.id","size":9999},"aggs":{"name":{"terms":{"field":"nestedTransactionTypes.name.keyword","size":9999}},"card":{"terms":{"field":"nestedTransactionTypes.cardNames.keyword","size":9999},"aggs": {"total":{"sum":' +
                        tips +
                        ' },"transquantity":{"sum":{"field":"nestedTransactionTypes.transquantity"}},"tendered": {"sum": {"field": "nestedTransactionTypes.tenderedAmount"}},"change": {"sum":{"field": "nestedTransactionTypes.change"}},"transactions":{"sum":{"field":"transactions"}}}},"total":{"sum":' +
                        tips +
                        ' },"transquantity":{"sum":{"field":"nestedTransactionTypes.transquantity"}},"tendered": {"sum": {"field": "nestedTransactionTypes.tenderedAmount"}},"change": {"sum": { "field": "nestedTransactionTypes.change"}},"transactions":{"sum":{"field":"transactions"}}}}}},"transactionsTotals":{"terms":{"field":"transactionTypesShort.keyword","size":9999},"aggs":{"transactions":{"sum":{"field":"transactions"}}}},"refunds":{"nested":{"path":"refunds"},"aggs":{"name":{"terms":{"field":"refunds.reason.keyword","size":9999},"aggs":{"total":{"sum":{"field":"refunds.amount"}}}}}}}}'
                    );
                    // Comps Reasons
                    requests.push(
                        '{"index":"eatos-comps","ignore_unavailable":true}'
                    );
                    requests.push(
                        '{"size":0,"query":{"bool":{"must":' +
                        conditions +
                        '}},"aggs":{"reason":{"terms":{"field":"reason.keyword","size":9999},"aggs":{"total":{"sum":{"field":"amount"}}}}}}'
                    );
                    /*echo json_encode(requests);
				  exit;*/
                    // cash management Reasons
                    conditions =
                        '[{"term":{"merchantId":{"value": "' +
                        merchantId +
                        '"}}},{"range":{"@timestamp":{"gte": ' +
                        gte +
                        ',"lte":' +
                        lte +
                        "}}}";
                    if (params["storeLocationId"]) {
                        conditions =
                            conditions +
                            ',{"term": {"storeLocationId": {"value": "' +
                            params["storeLocationId"] +
                            '"}}}';
                    }
                    conditions = conditions + "]";
                    requests.push(
                        '{"index":"eatos-cashmanagement","ignore_unavailable":true}'
                    );
                    requests.push(
                        '{"size":0,"query":{"bool":{"must":' +
                        conditions +
                        ',"must_not":[{"term":{"cashmanagementType":{"value":1}}},{"term":{"cashmanagementReason.keyword":{"value":"Refund"}}},{"term":{"cashmanagementReason.keyword":{"value":"Recovery – card"}}},{"term":{"cashmanagementReason.keyword":{"value":"Drawer Closed"}}},{"term":{"cashmanagementReason.keyword":{"value":"Cash Out"}}},{"term":{"cashmanagementReason.keyword":{"value":""}}}]}},"aggs":{"reason":{"terms":{"field":"cashmanagementReason.keyword","size":9999},"aggs":{"total":{"sum":{"field":"amount"}}}}}}'
                    );
                    conditions =
                        '[{"term":{"merchantId":{"value": "' +
                        merchantId +
                        '"}}},{"range":{"@timestamp":{"gte": ' +
                        gte +
                        ',"lte":' +
                        lte +
                        "}}}";
                    if (params["storeLocationId"]) {
                        conditions =
                            conditions +
                            ',{"term": {"storeLocationId": {"value": "' +
                            params["storeLocationId"] +
                            '"}}}';
                    }
                    conditions = conditions + "]";
                    requests.push(
                        '{"index":"eatos-cashmanagement","ignore_unavailable":true}'
                    );
                    requests.push(
                        '{"size":0,"query":{"bool":{"must":' +
                        conditions +
                        ',"must_not":[{"term":{"cashmanagementType":{"value":2}}},{"term":{"cashmanagementReason.keyword":{"value":""}}},{"term":{"cashmanagementReason.keyword":{"value":"Recovery – card"}}}]}},"aggs":{"reason":{"terms":{"field":"cashmanagementReason.keyword","size":9999},"aggs":{"total":{"sum":{"field":"amount"}}}}}}'
                    );
                    conditions =
                        '[{"term":{"merchantId":{"value": "' +
                        merchantId +
                        '"}}},{"range":{"@timestamp":{"gte": ' +
                        gte +
                        ',"lte":' +
                        lte +
                        '}}},{"term":{"cashmanagementReason.keyword":{"value":"Recovery – card"}}}';
                    if (params["storeLocationId"]) {
                        conditions =
                            conditions +
                            ',{"term": {"storeLocationId": {"value": "' +
                            params["storeLocationId"] +
                            '"}}}';
                    }
                    conditions = conditions + "]";
                    requests.push(
                        '{"index":"eatos-cashmanagement","ignore_unavailable":true}'
                    );
                    requests.push(
                        '{"size":0,"query":{"bool":{"must":' +
                        conditions +
                        '}},"aggs":{"reason":{"terms":{"field":"cardType.keyword","size":9999},"aggs":{"total":{"sum":{"field":"amount"}}}}}}'
                    );
                } else {
                    //Shift
                    // Categories by Shift
                    requests.push(
                        '{"index":"eatos-orders-products","ignore_unavailable":true}'
                    );
                    requests.push(
                        '{"size":0,"query":{"bool":{"must":' +
                        conditions +
                        '}},"aggs":{"shift":{"terms":{"field":"service.keyword","size":999},"aggs":{"total":{"sum":{"script":"doc[\'product.category.amount\'].value"}},"categories":{"terms":{"field":"product.main_category.productCategoryName.keyword","size":999},"aggs":{"total":{"sum":{"script":"doc[\'product.main_category.amount\'].value"}},"average":{"avg":{"script":"doc[\'product.main_category.amount\'].value - doc[\'product.main_category.totalCustomizationPrice\'].value"}},"subcategories":{"terms":{"field":"product.category.productCategoryName.keyword","size":999},"aggs":{"total":{"sum":{"script":"doc[\'product.category.amount\'].value"}},"totalCustomizationPrice":{"sum":{"field":"product.category.totalCustomizationPrice"}},"addonCount":{"sum":{"field":"adjustments"}},"quantity":{"sum":{"field":"quantity"}}}},"totalCustomizationPrice":{"sum":{"field":"product.main_category.totalCustomizationPrice"}},"addonCount":{"sum":{"field":"adjustments"}},"quantity":{"sum":{"field":"quantity"}}}}}}}}'
                    );
                    // Tax by Shift
                    requests.push(
                        '{"index":"eatos-orders","ignore_unavailable":true}'
                    );
                    requests.push(
                        '{"size":0,"query":{"bool":{"must":' +
                        conditions +
                        '}},"aggs":{"shifts":{"terms":{"field":"service.keyword","size":999},"aggs":{"subtotal":{"sum":{"field":"subTotal"}},"tax":{"sum":{"field":"totalTax"}},"taxCount":{"sum":{"script":"doc[\'totalTax\'].value!= 0 ? 1 : 0"}},"serviceCharges":{"sum":{"field":"totalServiceCharge"}},"serviceChargeNoQSA": { "sum": { "field": "serviceChargeNoQSA" } },"serviceCount":{"sum":{"script":"doc[\'totalServiceCharge\'].value!= 0 ? 1 : 0"}},"total-without-discounts":{"sum":{"script":"doc[\'subTotal\'].value + doc[\'totalTax\'].value + doc[\'totalServiceCharge\'].value"}},"pendingTips":{"sum":{"field":"pendingTips"}},"tips":{"sum":{"field":"tips"}},"tipCount":{"sum":{"script":"doc[\'tips\'].value!= 0 ? 1 : 0"}},"pendingTipCount":{"sum":{"script":"doc[\'pendingTips\'].value!= 0 ? 1 : 0"}},"customItemsValue":{"sum":{"field":"customItemsValue"}},"customItemsQuantity":{"sum":{"field":"customItemsQuantity"}},"giftCardsQuantity":{"sum":{"field":"giftCardsQuantity"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}},"numberOrders":{"cardinality":{"field":"_id"}}}}}}'
                    );
                    // TransactionTypes
                    requests.push(
                        '{"index":"eatos-orders","ignore_unavailable":true}'
                    );
                    requests.push(
                        '{"size":0,"query":{"bool":{"must":' +
                        conditions +
                        '}},"aggs":{"paytypes":{"nested":{"path":"nestedTransactionTypes"},"aggs":{"type":{"terms":{"field":"nestedTransactionTypes.id","size":9999},"aggs":{"name":{"terms":{"field":"nestedTransactionTypes.name.keyword"}},"total":{"sum":{"field":"nestedTransactionTypes.amount"}},"transquantity":{"sum":{"field":"nestedTransactionTypes.transquantity"}},"tendered": {"sum": {"field": "nestedTransactionTypes.tenderedAmount"}},"change": {"sum": { "field": "nestedTransactionTypes.change"}},"transactions":{"sum":{"field":"transactions"}}}}}}}}'
                    );
                    // Comps Reasons
                    requests.push(
                        '{"index":"eatos-comps","ignore_unavailable":true}'
                    );
                    requests.push(
                        '{"size":0,"query":{"bool":{"must":' +
                        conditions +
                        '}},"aggs":{"reason":{"terms":{"field":"reason.keyword","size":9999},"aggs":{"total":{"sum":{"field":"amount"}}}}}}'
                    );
                    // cash management Reasons
                    conditions =
                        '[{"term":{"merchantId":{"value": "' +
                        merchantId +
                        '"}}},{"range":{"@timestamp":{"gte": ' +
                        gte +
                        ',"lte":' +
                        lte +
                        "}}}";
                    if (params["storeLocationId"]) {
                        conditions =
                            conditions +
                            ',{"term": {"storeLocationId": {"value": "' +
                            params["storeLocationId"] +
                            '"}}}';
                    }
                    conditions = conditions + "]";
                    requests.push(
                        '{"index":"eatos-cashmanagement","ignore_unavailable":true}'
                    );
                    requests.push(
                        '{"size":0,"query":{"bool":{"must":' +
                        conditions +
                        ',"must_not":[{"term":{"type.keyword":{"value":1}}},{"term":{"cashmanagementReason.keyword":{"value":"Refund"}}},{"term":{"cashmanagementReason.keyword":{"value":"Recovery – card"}}},{"term":{"cashmanagementReason.keyword":{"value":"Drawer Closed"}}},{"term":{"cashmanagementReason.keyword":{"value":"Cash Out"}}},{"term":{"cashmanagementReason.keyword":{"value":""}}}]}},"aggs":{"reason":{"terms":{"field":"cashmanagementReason.keyword","size":9999},"aggs":{"total":{"sum":{"field":"amount"}}}}}}'
                    );
                    conditions =
                        '[{"term":{"type.keyword":{"value":1}}},{"term":{"cashmanagementReason.keyword":{"value":"P/I  Change Order"}}},{"term":{"merchantId":{"value": "' +
                        merchantId +
                        '"}}},{"range":{"@timestamp":{"gte": ' +
                        gte +
                        ',"lte":' +
                        lte +
                        "}}}";
                    if (params["storeLocationId"]) {
                        conditions =
                            conditions +
                            ',{"term": {"storeLocationId": {"value": "' +
                            params["storeLocationId"] +
                            '"}}}';
                    }
                    conditions = conditions + "]";
                    requests.push(
                        '{"index":"eatos-cashmanagement","ignore_unavailable":true}'
                    );
                    requests.push(
                        '{"size":0,"query":{"bool":{"must":' +
                        conditions +
                        '}},"aggs":{"reason":{"terms":{"field":"cashmanagementReason.keyword","size":9999},"aggs":{"total":{"sum":{"field":"amount"}}}}}}'
                    );
                }
            } else {
                return this.reportError();
            }

            return this.callReports(requests).then((res: any) => {
                return res.responses;
            });
        }

        async cashoutreport(params, cookie) {
            var merchantId = cookie.get("merchantId");
            this.elasticheaders2.Authorization = cookie.get("token");
            if (params["gte"] && params["lte"]) {
                var gte = params["gte"];
                var lte = params["lte"];

                var requests = [];

                // Get employees
                var conditions =
                    '[{"term":{"merchantId":{"value": "' +
                    merchantId +
                    '"}}},{"term":{"status":{"value":1}}}';
                if (params["storeLocationId"]) {
                    var conditions =
                        conditions +
                        ',{"term": {"storeId": {"value": "' +
                        params["storeLocationId"] +
                        '"}}}';
                }
                if (params["roles"] && params["roles"].length > 0) {
                    // roles is an array
                    var base = '{"bool":{"should":[';
                    var roles_sentences = [];
                    params["roles"].forEach(role => {
                        roles_sentences.push(
                            '{"term":{"role":{"value":' + role + "}}}"
                        );
                    });

                    base = base + roles_sentences.join(",");
                    base = base + "]}}";
                    conditions = conditions + "," + base;
                }
                conditions = conditions + "]";
                requests.push(
                    '{"index":"eatos-users","ignore_unavailable":true}'
                );
                requests.push(
                    '{"size":9999,"_source":["id","employeeFirstName","employeeLastName", "employeeCustomId","employeeRoleId"],"query":{"bool":{"must":' +
                    conditions +
                    "}}}"
                );
                var response = await this.callReports(requests);
                var hits = response["responses"][0]["hits"]["hits"];

                var users = [];
                hits.forEach(hit => {
                    hit["_source"]["id"] = hit["_id"];
                    users.push(hit["_source"]);
                });
                // Hardcoded
                params["sameDay"] = false;
                if (!params["sameDay"]) {
                    var ServersIds = [];
                    users.forEach(value => {
                        ServersIds.push(value["id"]);
                    });

                    requests = [];

                    users.forEach(async user => {
                        var conditions2 =
                            '[{"exists":{"field":"paymentId"}},{"bool":{"should":[{"term":{"paymentStatusId":{"value":3}}},{"term":{"paymentStatusId":{"value":4}}},{"term":{"paymentStatusId":{"value":5}}}]}},{"term":{"server.id":{"value":"' +
                            user["id"] +
                            '"}}},{"term":{"merchantId":{"value": "' +
                            merchantId +
                            '"}}},{"range":{"@timestamp":{"gte": ' +
                            gte +
                            ',"lte":' +
                            lte +
                            "}}}";
                        if (params["storeLocationId"]) {
                            conditions2 =
                                conditions2 +
                                ',{"term": {"storeLocationId": {"value": "' +
                                params["storeLocationId"] +
                                '"}}}';
                        }
                        conditions2 = conditions2 + "]";
                        requests.push(
                            '{"index":"eatos-orders","ignore_unavailable":true}'
                        );
                        requests.push(
                            '{"size":0,"query":{"bool":{"must":' +
                            conditions2 +
                            '}},"aggs":{"revenueCenter":{"terms":{"field":"revenueCenterId.keyword","size":9999},"aggs":{"name":{"terms":{"field":"revenueCenter.name.keyword","size":9999}},"paytypes":{"nested":{"path":"nestedTransactionTypes"},"aggs":{"type":{"terms":{"field":"nestedTransactionTypes.id","size":9999},"aggs":{"name":{"terms":{"field":"nestedTransactionTypes.name.keyword","size":9999}},"card":{"terms":{"field":"nestedTransactionTypes.cardNames.keyword","size":9999},"aggs":{"total":{"sum":{"field":"nestedTransactionTypes.amount"}},"tendered":{"sum":{"field":"nestedTransactionTypes.tenderedAmount"}},"change":{"sum":{"field":"nestedTransactionTypes.change"}},"quantity": {"sum": {"script": "doc[\'nestedTransactionTypes.paid\'].value > 0 ? 1 : 0"}}}},"total":{"sum":{"field":"nestedTransactionTypes.amount"}},"tips":{"sum":{"field":"nestedTransactionTypes.tip"}},"countTips": {"sum": {"script": "doc[\'nestedTransactionTypes.tip\'].value > 0 ? 1 : 0"}},"quantity": {"sum": {"script": "doc[\'nestedTransactionTypes.paid\'].value > 0 ? 1 : 0" }}}},"total":{"sum":{"field":"nestedTransactionTypes.amount"}},"tips":{"sum":{"field":"nestedTransactionTypes.tip"}},"countTips": {"sum": {"script": "doc[\'nestedTransactionTypes.tip\'].value > 0 ? 1 : 0"}},"quantity": {"sum": {"script": "doc[\'nestedTransactionTypes.paid\'].value > 0 ? 1 : 0" }}}},"transactionsTotals":{"terms":{"field":"transactionTypesShort.keyword","size":9999},"aggs":{"transactions":{"sum":{"field":"transactions"}}}},"refunds":{"nested":{"path":"refunds"},"aggs":{"name":{"terms":{"field":"refunds.reason.keyword","size":9999},"aggs":{"total":{"sum":{"field":"refunds.amount"}}}}}}}}}}'
                        );

                        conditions =
                            '[{"term":{"merchantId":{"value": "' +
                            merchantId +
                            '"}}},{"range":{"@timestamp":{"gte": ' +
                            gte +
                            ',"lte":' +
                            lte +
                            '}}},{"term":{"employeeId":{"value":"' +
                            user["id"] +
                            '"}}}';
                        if (params["storeLocationId"]) {
                            conditions =
                                conditions +
                                ',{"term": {"storeLocationId": {"value": "' +
                                params["storeLocationId"] +
                                '"}}}';
                        }
                        conditions = conditions + "]";
                        requests.push(
                            '{"index":"eatos-cashmanagement","ignore_unavailable":true}'
                        );
                        requests.push(
                            '{"size":0,"query":{"bool":{"must":' +
                            conditions +
                            ',"must_not":[{"term":{"cashmanagementType":{"value":1}}},{"term":{"cashmanagementReason.keyword":{"value":"Refund"}}},{"term":{"cashmanagementReason.keyword":{"value":"Recovery – card"}}},{"term":{"cashmanagementReason.keyword":{"value":"Drawer Closed"}}},{"term":{"cashmanagementReason.keyword":{"value":"Cash Out"}}},{"term":{"cashmanagementReason.keyword":{"value":""}}}]}},"aggs":{"revenue":{"terms":{"field":"revenueCenterId.keyword","size":9999},"aggs":{"reason":{"terms":{"field":"cashmanagementReason.keyword","size":9999},"aggs":{"total":{"sum":{"field":"amount"}}}}}}}}'
                        );

                        conditions =
                            '[{"term":{"merchantId":{"value": "' +
                            merchantId +
                            '"}}},{"term":{"status":{"value":1}}},{"term":{"employeeId":{"value":"' +
                            user["id"] +
                            '"}}},{"range":{"@timestamp":{"gte": ' +
                            gte +
                            ',"lte":' +
                            lte +
                            "}}}";
                        if (params["storeLocationId"]) {
                            conditions =
                                conditions +
                                ',{"term": {"storeLocationId": {"value": "' +
                                params["storeLocationId"] +
                                '"}}}';
                        }
                        conditions = conditions + "]";
                    });

                    requests.push(
                        '{"index":"eatos-cashmanagement","ignore_unavailable":true}'
                    );

                    requests.push(
                        '{"size":0,"query":{"bool":{"must":' +
                        conditions +
                        ',"must_not":[{"term":{"cashmanagementType":{"value":2}}},{"term":{"cashmanagementReason.keyword":{"value":""}}}]}},"aggs":{"revenue":{"terms":{"field":"revenueCenterId.keyword","size":9999},"aggs":{"reason":{"terms":{"field":"cashmanagementReason.keyword","size":9999},"aggs":{"total":{"sum":{"field":"amount"}}}}}}}}'
                    );

                    conditions =
                        '[{"term":{"merchantId":{"value": "' +
                        merchantId +
                        '"}}},{"range":{"@timestamp":{"gte": ' +
                        gte +
                        ',"lte":' +
                        lte +
                        "}}}";
                    if (params["storeLocationId"]) {
                        conditions =
                            conditions +
                            ',{"term": {"storeLocationId": {"value": "' +
                            params["storeLocationId"] +
                            '"}}}';
                    }
                    conditions = conditions + "]";
                    requests.push(
                        '{"index":"eatos-cashmanagement","ignore_unavailable":true}'
                    );
                    requests.push(
                        '{"size":0,"query":{"bool":{"must":' +
                        conditions +
                        ',"must_not":[{"term":{"cashmanagementType":{"value":1}}},{"term":{"cashmanagementReason.keyword":{"value":"Refund"}}},{"term":{"cashmanagementReason.keyword":{"value":"Recovery – card"}}},{"term":{"cashmanagementReason.keyword":{"value":"Drawer Closed"}}},{"term":{"cashmanagementReason.keyword":{"value":"Cash Out"}}},{"term":{"cashmanagementReason.keyword":{"value":""}}}]}},"aggs":{"reason":{"terms":{"field":"cashmanagementReason.keyword","size":9999},"aggs":{"total":{"sum":{"field":"amount"}}}}}}'
                    );

                    conditions =
                        '[{"term":{"merchantId":{"value": "' +
                        merchantId +
                        '"}}},{"term":{"status":{"value":1}}},{"range":{"@timestamp":{"gte": ' +
                        gte +
                        ',"lte":' +
                        lte +
                        "}}}";
                    if (params["storeLocationId"]) {
                        conditions =
                            conditions +
                            ',{"term": {"storeLocationId": {"value": "' +
                            params["storeLocationId"] +
                            '"}}}';
                    }
                    conditions = conditions + "]";
                    requests.push(
                        '{"index":"eatos-cashmanagement","ignore_unavailable":true}'
                    );

                    requests.push(
                        '{"size":0,"query":{"bool":{"must":' +
                        conditions +
                        ',"must_not":[{"term":{"cashmanagementType":{"value":2}}},{"term":{"cashmanagementReason.keyword":{"value":""}}}]}},"aggs":{"reason":{"terms":{"field":"cashmanagementReason.keyword","size":9999},"aggs":{"total":{"sum":{"field":"amount"}}}}}}'
                    );

                    /* conditions3 = '[{"exists":{"field":"paymentId"}},{"bool":{"should":[{"term":{"paymentStatusId":{"value":4}}},{"term":{"paymentStatusId":{"value":5}}},{"term":{"paymentStatusId":{"value":12}}}]}},{"term":{"merchantId":{"value": "'+merchantId+'"}}},{"range":{"@timestamp":{"gte": '+gte+',"lte":'+lte+'}}}';
					if (params["storeLocationId"]) {
					  conditions3 = conditions3+',{"term": {"storeLocationId": {"value": "'+params["storeLocationId"]+'"}}}';
					}
					conditions3 = conditions3+']'; */
                    var conditions4 =
                        '[{"exists":{"field":"paymentId"}},{"bool":{"should":[{"term":{"paymentStatusId":{"value":3}}},{"term":{"paymentStatusId":{"value":4}}},{"term":{"paymentStatusId":{"value":5}}}]}},{"term":{"merchantId":{"value": "' +
                        merchantId +
                        '"}}},{"range":{"@timestamp":{"gte": ' +
                        gte +
                        ',"lte":' +
                        lte +
                        "}}}";
                    if (params["storeLocationId"]) {
                        conditions4 =
                            conditions4 +
                            ',{"term": {"storeLocationId": {"value": "' +
                            params["storeLocationId"] +
                            '"}}}';
                    }

                    if (ServersIds) {
                        // serverids is an array
                        var base1 = '{"bool":{"should":[';
                        var server_sentences = [];
                        ServersIds.forEach(ServerId => {
                            server_sentences.push(
                                '{"term":{"server.id":{"value":"' +
                                ServerId +
                                '"}}}'
                            );
                        });

                        base1 = base1 + server_sentences.join(",");
                        base1 = base1 + "]}}";
                        conditions4 = conditions4 + "," + base1;
                    }
                    conditions4 = conditions4 + "]";
                    requests.push(
                        '{"index":"eatos-orders","ignore_unavailable":true}'
                    );
                    requests.push(
                        '{"size":0,"query":{"bool":{"must":' +
                        conditions4 +
                        '}},"aggs":{"paytypes":{"nested":{"path":"nestedTransactionTypes"},"aggs":{"type":{"terms":{"field":"nestedTransactionTypes.id","size":9999},"aggs":{"name":{"terms":{"field":"nestedTransactionTypes.name.keyword","size":9999}},"card":{"terms":{"field":"nestedTransactionTypes.cardNames.keyword","size":9999},"aggs":{"total":{"sum":{"field":"nestedTransactionTypes.amount"}},"tendered":{"sum":{"field":"nestedTransactionTypes.tenderedAmount"}},"change":{"sum":{"field":"nestedTransactionTypes.change"}},"quantity": {"sum": {"script": "doc[\'nestedTransactionTypes.paid\'].value > 0 ? 1 : 0"}}}},"total":{"sum":{"field":"nestedTransactionTypes.amount"}},"tips":{"sum":{"field":"nestedTransactionTypes.tip"}},"countTips": {"sum": {"script": "doc[\'nestedTransactionTypes.tip\'].value > 0 ? 1 : 0"}},"quantity": {"sum": {"script": "doc[\'nestedTransactionTypes.paid\'].value > 0 ? 1 : 0" }}}},"total":{"sum":{"field":"nestedTransactionTypes.amount"}},"tips":{"sum":{"field":"nestedTransactionTypes.tip"}},"countTips": {"sum": {"script": "doc[\'nestedTransactionTypes.tip\'].value > 0 ? 1 : 0"}},"quantity": {"sum": {"script": "doc[\'nestedTransactionTypes.paid\'].value > 0 ? 1 : 0" }}}},"transactionsTotals":{"terms":{"field":"transactionTypesShort.keyword","size":9999},"aggs":{"transactions":{"sum":{"field":"transactions"}}}},"refunds":{"nested":{"path":"refunds"},"aggs":{"name":{"terms":{"field":"refunds.reason.keyword","size":9999},"aggs":{"total":{"sum":{"field":"refunds.amount"}}}}}},"employees": {"terms": {"field": "server.name.keyword","size": 9999},"aggs": {"id": {"terms": {"field": "server.id.keyword","size": 9999}},"role": {"terms": {"field": "server.role.keyword","size": 9999}},"refunds": {"nested": {"path": "refunds"},"aggs": {"name": {"terms": {"field": "refunds.reason.keyword","size": 9999},"aggs": {"total": {"sum": {"field": "refunds.amount"}}}}}},"paytypes": {"nested": {"path": "nestedTransactionTypes"},"aggs": {"type": {"terms": {"field": "nestedTransactionTypes.id","size": 9999},"aggs": {"name": {"terms": {"field": "nestedTransactionTypes.name.keyword","size": 9999}},"card": {"terms": {"field": "nestedTransactionTypes.cardNames.keyword","size": 9999},"aggs": {"total": {"sum": {"field": "nestedTransactionTypes.amount"}},"tendered": {"sum": {"field": "nestedTransactionTypes.tenderedAmount"}},"change": {"sum": {"field": "nestedTransactionTypes.change"}},"quantity": {"sum": {"script": "doc[\'nestedTransactionTypes.paid\'].value > 0 ? 1 : 0"}}}},"total": {"sum": {"field": "nestedTransactionTypes.amount"}},"tips": {"sum": {"field": "nestedTransactionTypes.tip"}},"countTips": {"sum": {"script": "doc[\'nestedTransactionTypes.tip\'].value > 0 ? 1 : 0"}},"quantity": {"sum": {"script": "doc[\'nestedTransactionTypes.paid\'].value > 0 ? 1 : 0"}}}},"total": {"sum": {"field": "nestedTransactionTypes.amount"}},"tips": {"sum": {"field": "nestedTransactionTypes.tip"}},"countTips": {"sum": {"script": "doc[\'nestedTransactionTypes.tip\'].value > 0 ? 1 : 0"}},"quantity": {"sum": {"script": "doc[\'nestedTransactionTypes.paid\'].value > 0 ? 1 : 0"}}}}}}}}'
                    );

                    requests.push('{"index":"eatos-orders","ignore_unavailable":true}')
                    requests.push('{"size":0,"query":{"bool":{"must":' +
                        conditions4 +
                        '}},"aggs":{"employees":{"terms":{"field":"server.id.keyword","size":9999},"aggs":{"refunds":{"nested":{"path":"refunds"},"aggs":{"name":{"terms":{"field":"refunds.reason.keyword","size":9999},"aggs":{"total":{"sum":{"field":"refunds.amount"}}}}}}}}}}')

                    var response = await this.callReports(requests);
                    var responses = response["responses"];

                    var final = {
                        success: 1,
                        response: {
                            users: users,
                            byuserandall: responses
                        }
                    };
                    return new Promise((resolve, reject) => {
                        resolve(final);
                    });
                    // echo json_encode(requests);
                } else {
                    // When they want the payment information separated by Cashout

                    if (params["process"] == "first") {
                        // Getting the Cashouts to filter the other queries
                        ServersIds = [];
                        users.forEach(value => {
                            ServersIds.push(value["id"]);
                        });

                        requests = [];
                        conditions =
                            '[{"term":{"merchantId":{"value":"' +
                            merchantId +
                            '"}}},{"term":{"cashmanagementType":{"value":2}}},{"term":{"status":{"value":1}}},{"term":{"cashmanagementReason.keyword":{"value":"Cash Out"}}},{"range":{"@timestamp":{"gte":' +
                            gte +
                            ',"lte":' +
                            lte +
                            "}}}";
                        if (params["storeLocationId"]) {
                            conditions =
                                conditions +
                                ',{"term": {"storeId": {"value": "' +
                                params["storeLocationId"] +
                                '"}}}';
                        }
                        conditions = conditions + "]";
                        requests.push(
                            '{"index":"eatos-cashmanagement","ignore_unavailable":true}'
                        );
                        requests.push(
                            '{"size":0,"query":{"bool":{"must":' +
                            conditions +
                            '}},"aggs":{"employees":{"terms":{"field":"employeeId.keyword","size":9999},"aggs":{"times":{"terms":{"field":"@timestamp","size":9999}}}}}}'
                        );
                        /*echo json_encode(requests);
                    exit;*/
                        console.log(requests);
                        var response = await this.callReports(requests);
                        var responses = response["responses"];

                        var final2 = {
                            success: 1,
                            response: {
                                cashout: responses,
                                users: users
                            }
                        };
                        // Aquí sabemos que primero debemos sacar los cashouts y luego debemos sacar la info separada por los intervalos de los cashouts
                        return new Promise((resolve, reject) => {
                            resolve(final2);
                        });
                    }

                    if (params["process"] == "second") {
                        var newIntervals = params["newIntervals"];
                        //first = params["newIntervals"][0]["intervalos"][0][1];
                        requests = [];
                        newIntervals.forEach(intervalUser => {
                            if (intervalUser["intervalos"].length) {
                                var conditions2 =
                                    '[{"exists":{"field":"paymentId"}},{"bool":{"should":[{"term":{"paymentStatusId":{"value":3}}},{"term":{"paymentStatusId":{"value":4}}},{"term":{"paymentStatusId":{"value":5}}}]}},{"term":{"server.id":{"value":"' +
                                    intervalUser["serverId"] +
                                    '"}}},{"term":{"merchantId":{"value": "' +
                                    merchantId +
                                    '"}}},{"range":{"@timestamp":{"gte": ' +
                                    gte +
                                    ',"lte":' +
                                    lte +
                                    "}}}";
                                if (params["storeLocationId"]) {
                                    conditions2 =
                                        conditions2 +
                                        ',{"term": {"storeId": {"value": "' +
                                        params["storeLocationId"] +
                                        '"}}}';
                                }
                                conditions2 = conditions2 + "]";
                                requests.push(
                                    '{"index":"eatos-orders","ignore_unavailable":true}'
                                );
                                requests.push(
                                    '{"size":0,"query":{"bool":{"must":' +
                                    conditions2 +
                                    '}},"aggs":{"revenueCenter":{"terms":{"field":"revenueCenterId.keyword","size":9999},"aggs":{"name":{"terms":{"field":"revenueCenter.name.keyword","size":9999}},"paytypes":{"nested":{"path":"nestedTransactionTypes"},"aggs":{"type":{"terms":{"field":"nestedTransactionTypes.id","size":9999},"aggs":{"name":{"terms":{"field":"nestedTransactionTypes.name.keyword","size":9999}},"card":{"terms":{"field":"nestedTransactionTypes.cardNames.keyword","size":9999},"aggs":{"total":{"sum":{"field":"nestedTransactionTypes.amount"}},"tendered":{"sum":{"field":"nestedTransactionTypes.tenderedAmount"}},"change":{"sum":{"field":"nestedTransactionTypes.change"}},"quantity": {"sum": {"script": "doc[\'nestedTransactionTypes.paid\'].value > 0 ? 1 : 0"}}}},"total":{"sum":{"field":"nestedTransactionTypes.amount"}},"tips":{"sum":{"field":"nestedTransactionTypes.tip"}},"countTips": {"sum": {"script": "doc[\'nestedTransactionTypes.tip\'].value > 0 ? 1 : 0"}},"quantity": {"sum": {"script": "doc[\'nestedTransactionTypes.paid\'].value > 0 ? 1 : 0" }}}},"total":{"sum":{"field":"nestedTransactionTypes.amount"}},"tips":{"sum":{"field":"nestedTransactionTypes.tip"}},"countTips": {"sum": {"script": "doc[\'nestedTransactionTypes.tip\'].value > 0 ? 1 : 0"}},"quantity": {"sum": {"script": "doc[\'nestedTransactionTypes.paid\'].value > 0 ? 1 : 0" }}}},"transactionsTotals":{"terms":{"field":"transactionTypesShort.keyword","size":9999},"aggs":{"transactions":{"sum":{"field":"transactions"}}}},"refunds":{"nested":{"path":"refunds"},"aggs":{"name":{"terms":{"field":"refunds.reason.keyword","size":9999},"aggs":{"total":{"sum":{"field":"refunds.amount"}}}}}}}}}}'
                                );

                                // cash management Reasons
                                conditions =
                                    '[{"term":{"merchantId":{"value": "' +
                                    merchantId +
                                    '"}}},{"range":{"@timestamp":{"gte": ' +
                                    gte +
                                    ',"lte":' +
                                    lte +
                                    '}}},{"term":{"employeeId":{"value":"' +
                                    intervalUser["employeeId"] +
                                    '"}}}';
                                if (params["storeLocationId"]) {
                                    conditions =
                                        conditions +
                                        ',{"term": {"storeId": {"value": "' +
                                        params["storeLocationId"] +
                                        '"}}}';
                                }
                                conditions = conditions + "]";
                                requests.push(
                                    '{"index":"eatos-cashmanagement","ignore_unavailable":true}'
                                );
                                requests.push(
                                    '{"size":0,"query":{"bool":{"must":' +
                                    conditions +
                                    ',"must_not":[{"term":{"cashmanagementType":{"value":1}}},{"term":{"cashmanagementReason.keyword":{"value":"Refund"}}},{"term":{"cashmanagementReason.keyword":{"value":"Recovery – card"}}},{"term":{"cashmanagementReason.keyword":{"value":"Drawer Closed"}}},{"term":{"cashmanagementReason.keyword":{"value":"Cash Out"}}},{"term":{"cashmanagementReason.keyword":{"value":""}}}]}},"aggs":{"revenue":{"terms":{"field":"revenueCenterId.keyword","size":9999},"aggs":{"reason":{"terms":{"field":"cashmanagementReason.keyword","size":9999},"aggs":{"total":{"sum":{"field":"amount"}}}}}}}}'
                                );

                                conditions =
                                    '[{"term":{"merchantId":{"value": "' +
                                    merchantId +
                                    '"}}},{"term":{"employeeId":{"value":"' +
                                    intervalUser["employeeId"] +
                                    '"}}},{"range":{"@timestamp":{"gte": ' +
                                    gte +
                                    ',"lte":' +
                                    lte +
                                    "}}}";
                                if (params["storeLocationId"]) {
                                    conditions =
                                        conditions +
                                        ',{"term": {"storeId": {"value": "' +
                                        params["storeLocationId"] +
                                        '"}}}';
                                }
                                conditions = conditions + "]";
                                requests.push(
                                    '{"index":"eatos-cashmanagement","ignore_unavailable":true}'
                                );
                                requests.push(
                                    '{"size":0,"query":{"bool":{"must":' +
                                    conditions +
                                    ',"must_not":[{"term":{"cashmanagementType":{"value":2}}},{"term":{"cashmanagementReason.keyword":{"value":""}}}]}},"aggs":{"revenue":{"terms":{"field":"revenueCenterId.keyword","size":9999},"aggs":{"reason":{"terms":{"field":"cashmanagementReason.keyword","size":9999},"aggs":{"total":{"sum":{"field":"amount"}}}}}}}}'
                                );
                            } else {
                                intervalUser["intervalos"].forEach(
                                    intervalIndividual => {
                                        conditions2 =
                                            '[{"exists":{"field":"paymentId"}},{"bool":{"should":[{"term":{"paymentStatusId":{"value":3}}},{"term":{"paymentStatusId":{"value":4}}},{"term":{"paymentStatusId":{"value":5}}}]}},{"term":{"server.id":{"value":"' +
                                            intervalUser["serverId"] +
                                            '"}}},{"term":{"merchantId":{"value": "' +
                                            merchantId +
                                            '"}}},{"range":{"@timestamp":{"gte": ' +
                                            intervalIndividual[0] +
                                            ',"lte":' +
                                            intervalIndividual[1] +
                                            "}}}";
                                        if (params["storeLocationId"]) {
                                            conditions2 =
                                                conditions2 +
                                                ',{"term": {"storeId": {"value": "' +
                                                params["storeLocationId"] +
                                                '"}}}';
                                        }
                                        conditions2 = conditions2 + "]";
                                        requests.push(
                                            '{"index":"eatos-orders","ignore_unavailable":true}'
                                        );
                                        requests.push(
                                            '{"size":0,"query":{"bool":{"must":' +
                                            conditions2 +
                                            '}},"aggs":{"revenueCenter":{"terms":{"field":"revenueCenterId.keyword","size":9999},"aggs":{"name":{"terms":{"field":"revenueCenter.name.keyword","size":9999}},"paytypes":{"nested":{"path":"nestedTransactionTypes"},"aggs":{"type":{"terms":{"field":"nestedTransactionTypes.id","size":9999},"aggs":{"name":{"terms":{"field":"nestedTransactionTypes.name.keyword","size":9999}},"card":{"terms":{"field":"nestedTransactionTypes.cardNames.keyword","size":9999},"aggs":{"total":{"sum":{"field":"nestedTransactionTypes.amount"}},"tendered":{"sum":{"field":"nestedTransactionTypes.tenderedAmount"}},"change":{"sum":{"field":"nestedTransactionTypes.change"}},"quantity": {"sum": {"script": "doc[\'nestedTransactionTypes.paid\'].value > 0 ? 1 : 0"}}}},"total":{"sum":{"field":"nestedTransactionTypes.amount"}},"tips":{"sum":{"field":"nestedTransactionTypes.tip"}},"countTips": {"sum": {"script": "doc[\'nestedTransactionTypes.tip\'].value > 0 ? 1 : 0"}},"quantity": {"sum": {"script": "doc[\'nestedTransactionTypes.paid\'].value > 0 ? 1 : 0" }}}},"total":{"sum":{"field":"nestedTransactionTypes.amount"}},"tips":{"sum":{"field":"nestedTransactionTypes.tip"}},"countTips": {"sum": {"script": "doc[\'nestedTransactionTypes.tip\'].value > 0 ? 1 : 0"}},"quantity": {"sum": {"script": "doc[\'nestedTransactionTypes.paid\'].value > 0 ? 1 : 0" }}}},"transactionsTotals":{"terms":{"field":"transactionTypesShort.keyword","size":9999},"aggs":{"transactions":{"sum":{"field":"transactions"}}}},"refunds":{"nested":{"path":"refunds"},"aggs":{"name":{"terms":{"field":"refunds.reason.keyword","size":9999},"aggs":{"total":{"sum":{"field":"refunds.amount"}}}}}}}}}}'
                                        );

                                        // cash management Reasons
                                        conditions =
                                            '[{"term":{"merchantId":{"value": "' +
                                            merchantId +
                                            '"}}},{"range":{"@timestamp":{"gte": ' +
                                            intervalIndividual[0] +
                                            ',"lte":' +
                                            intervalIndividual[1] +
                                            '}}},{"term":{"employeeId":{"value":"' +
                                            intervalUser["employeeId"] +
                                            '"}}}';
                                        if (params["storeLocationId"]) {
                                            conditions =
                                                conditions +
                                                ',{"term": {"storeId": {"value": "' +
                                                params["storeLocationId"] +
                                                '"}}}';
                                        }
                                        conditions = conditions + "]";
                                        requests.push(
                                            '{"index":"eatos-cashmanagement","ignore_unavailable":true}'
                                        );
                                        requests.push(
                                            '{"size":0,"query":{"bool":{"must":' +
                                            conditions +
                                            ',"must_not":[{"term":{"cashmanagementType":{"value":1}}},{"term":{"cashmanagementReason.keyword":{"value":"Refund"}}},{"term":{"cashmanagementReason.keyword":{"value":"Recovery – card"}}},{"term":{"cashmanagementReason.keyword":{"value":"Drawer Closed"}}},{"term":{"cashmanagementReason.keyword":{"value":"Cash Out"}}},{"term":{"cashmanagementReason.keyword":{"value":""}}}]}},"aggs":{"revenue":{"terms":{"field":"revenueCenterId.keyword","size":9999},"aggs":{"reason":{"terms":{"field":"cashmanagementReason.keyword","size":9999},"aggs":{"total":{"sum":{"field":"amount"}}}}}}}}'
                                        );

                                        conditions =
                                            '[{"term":{"merchantId":{"value": "' +
                                            merchantId +
                                            '"}}},{"term":{"employeeId":{"value":"' +
                                            intervalUser["employeeId"] +
                                            '"}}},{"range":{"@timestamp":{"gte": ' +
                                            intervalIndividual[0] +
                                            ',"lte":' +
                                            intervalIndividual[1] +
                                            "}}}";
                                        if (params["storeLocationId"]) {
                                            conditions =
                                                conditions +
                                                ',{"term": {"storeId": {"value": "' +
                                                params["storeLocationId"] +
                                                '"}}}';
                                        }
                                        conditions = conditions + "]";
                                        requests.push(
                                            '{"index":"eatos-cashmanagement","ignore_unavailable":true}'
                                        );
                                        requests.push(
                                            '{"size":0,"query":{"bool":{"must":' +
                                            conditions +
                                            ',"must_not":[{"term":{"cashmanagementType":{"value":2}}},{"term":{"cashmanagementReason.keyword":{"value":""}}}]}},"aggs":{"revenue":{"terms":{"field":"revenueCenterId.keyword","size":9999},"aggs":{"reason":{"terms":{"field":"cashmanagementReason.keyword","size":9999},"aggs":{"total":{"sum":{"field":"amount"}}}}}}}}'
                                        );
                                    }
                                );
                            }
                        });

                        conditions =
                            '[{"term":{"merchantId":{"value": "' +
                            merchantId +
                            '"}}},{"range":{"@timestamp":{"gte": ' +
                            gte +
                            ',"lte":' +
                            lte +
                            "}}}";
                        if (params["storeLocationId"]) {
                            conditions =
                                conditions +
                                ',{"term": {"storeId": {"value": "' +
                                params["storeLocationId"] +
                                '"}}}';
                        }

                        conditions = conditions + "]";
                        requests.push(
                            '{"index":"eatos-cashmanagement","ignore_unavailable":true}'
                        );
                        requests.push(
                            '{"size":0,"query":{"bool":{"must":' +
                            conditions +
                            ',"must_not":[{"term":{"cashmanagementType":{"value":1}}},{"term":{"cashmanagementReason.keyword":{"value":"Refund"}}},{"term":{"cashmanagementReason.keyword":{"value":"Recovery – card"}}},{"term":{"cashmanagementReason.keyword":{"value":"Drawer Closed"}}},{"term":{"cashmanagementReason.keyword":{"value":"Cash Out"}}},{"term":{"cashmanagementReason.keyword":{"value":""}}}]}},"aggs":{"reason":{"terms":{"field":"cashmanagementReason.keyword","size":9999},"aggs":{"total":{"sum":{"field":"amount"}}}}}}'
                        );

                        conditions =
                            '[{"term":{"merchantId":{"value": "' +
                            merchantId +
                            '"}}},{"term":{"status":{"value":1}}},{"range":{"@timestamp":{"gte": ' +
                            gte +
                            ',"lte":' +
                            lte +
                            "}}}";
                        if (params["storeLocationId"]) {
                            conditions =
                                conditions +
                                ',{"term": {"storeId": {"value": "' +
                                params["storeLocationId"] +
                                '"}}}';
                        }

                        conditions = conditions + "]";
                        requests.push(
                            '{"index":"eatos-cashmanagement","ignore_unavailable":true}'
                        );
                        requests.push(
                            '{"size":0,"query":{"bool":{"must":' +
                            conditions +
                            ',"must_not":[{"term":{"cashmanagementType":{"value":2}}},{"term":{"cashmanagementReason.keyword":{"value":""}}}]}},"aggs":{"reason":{"terms":{"field":"cashmanagementReason.keyword","size":9999},"aggs":{"total":{"sum":{"field":"amount"}}}}}}'
                        );

                        /* conditions3 = '[{"exists":{"field":"paymentId"}},{"bool":{"should":[{"term":{"paymentStatusId":{"value":3}}},{"term":{"paymentStatusId":{"value":4}}},{"nested":{"path":"refunds","query":{"bool":{"must":[[{"match":{"refunds.reason.keyword":"QSA"}},{"match":{"refunds.paymentStatusId": 5}}]]}}}}]}},{"term":{"merchantId":{"value": "'+merchantId+'"}}},{"range":{"@timestamp":{"gte": '+gte+',"lte":'+lte+'}}}';
					if (params["storeLocationId"]) {
					  conditions3 = conditions3+',{"term": {"storeLocationId": {"value": "'+params["storeLocationId"]+'"}}}';
					}
					conditions3 = conditions3+']'; */

                        conditions4 =
                            '[{"exists":{"field":"paymentId"}},{"bool":{"should":[{"term":{"paymentStatusId":{"value":3}}},{"term":{"paymentStatusId":{"value":4}}},{"term":{"paymentStatusId":{"value":5}}}]}},{"term":{"merchantId":{"value": "' +
                            merchantId +
                            '"}}},{"range":{"@timestamp":{"gte": ' +
                            gte +
                            ',"lte":' +
                            lte +
                            "}}}";
                        if (params["storeLocationId"]) {
                            conditions4 =
                                conditions4 +
                                ',{"term": {"storeId": {"value": "' +
                                params["storeLocationId"] +
                                '"}}}';
                        }

                        ServersIds = [];
                        users.forEach(value => {
                            ServersIds.push(value["id"]);
                        });

                        if (ServersIds) {
                            // serverids is an array
                            var base1 = '{"bool":{"should":[';
                            var server_sentences = [];
                            ServersIds.forEach(ServerId => {
                                server_sentences.push(
                                    '{"term":{"server.id":{"value":"' +
                                    ServerId +
                                    '"}}}'
                                );
                            });

                            base1 = base1 + server_sentences.join(",");
                            base1 = base1 + "]}}";
                            conditions4 = conditions4 + "," + base1;
                        }
                        conditions4 = conditions4 + "]";
                        requests.push(
                            '{"index":"eatos-orders","ignore_unavailable":true}'
                        );
                        requests.push(
                            '{"size":0,"query":{"bool":{"must":' +
                            conditions4 +
                            '}},"aggs":{"paytypes":{"nested":{"path":"nestedTransactionTypes"},"aggs":{"type":{"terms":{"field":"nestedTransactionTypes.id","size":9999},"aggs":{"name":{"terms":{"field":"nestedTransactionTypes.name.keyword","size":9999}},"card":{"terms":{"field":"nestedTransactionTypes.cardNames.keyword","size":9999},"aggs":{"total":{"sum":{"field":"nestedTransactionTypes.amount"}},"tendered":{"sum":{"field":"nestedTransactionTypes.tenderedAmount"}},"change":{"sum":{"field":"nestedTransactionTypes.change"}},"quantity": {"sum": {"script": "doc[\'nestedTransactionTypes.paid\'].value > 0 ? 1 : 0"}}}},"total":{"sum":{"field":"nestedTransactionTypes.amount"}},"tips":{"sum":{"field":"nestedTransactionTypes.tip"}},"countTips": {"sum": {"script": "doc[\'nestedTransactionTypes.tip\'].value > 0 ? 1 : 0"}},"quantity": {"sum": {"script": "doc[\'nestedTransactionTypes.paid\'].value > 0 ? 1 : 0" }}}},"total":{"sum":{"field":"nestedTransactionTypes.amount"}},"tips":{"sum":{"field":"nestedTransactionTypes.tip"}},"countTips": {"sum": {"script": "doc[\'nestedTransactionTypes.tip\'].value > 0 ? 1 : 0"}},"quantity": {"sum": {"script": "doc[\'nestedTransactionTypes.paid\'].value > 0 ? 1 : 0" }}}},"transactionsTotals":{"terms":{"field":"transactionTypesShort.keyword","size":9999},"aggs":{"transactions":{"sum":{"field":"transactions"}}}},"refunds":{"nested":{"path":"refunds"},"aggs":{"name":{"terms":{"field":"refunds.reason.keyword","size":9999},"aggs":{"total":{"sum":{"field":"refunds.amount"}}}}}},"employees": {"terms": {"field": "server.name.keyword","size": 9999},"aggs": {"id": {"terms": {"field": "server.id.keyword","size": 9999}},"role": {"terms": {"field": "server.role.keyword","size": 9999}},"refunds": {"nested": {"path": "refunds"},"aggs": {"name": {"terms": {"field": "refunds.reason.keyword","size": 9999},"aggs": {"total": {"sum": {"field": "refunds.amount"}}}}}},"paytypes": {"nested": {"path": "nestedTransactionTypes"},"aggs": {"type": {"terms": {"field": "nestedTransactionTypes.id","size": 9999},"aggs": {"name": {"terms": {"field": "nestedTransactionTypes.name.keyword","size": 9999}},"card": {"terms": {"field": "nestedTransactionTypes.cardNames.keyword","size": 9999},"aggs": {"total": {"sum": {"field": "nestedTransactionTypes.amount"}},"tendered": {"sum": {"field": "nestedTransactionTypes.tenderedAmount"}},"change": {"sum": {"field": "nestedTransactionTypes.change"}},"quantity": {"sum": {"script": "doc[\'nestedTransactionTypes.paid\'].value > 0 ? 1 : 0"}}}},"total": {"sum": {"field": "nestedTransactionTypes.amount"}},"tips": {"sum": {"field": "nestedTransactionTypes.tip"}},"countTips": {"sum": {"script": "doc[\'nestedTransactionTypes.tip\'].value > 0 ? 1 : 0"}},"quantity": {"sum": {"script": "doc[\'nestedTransactionTypes.paid\'].value > 0 ? 1 : 0"}}}},"total": {"sum": {"field": "nestedTransactionTypes.amount"}},"tips": {"sum": {"field": "nestedTransactionTypes.tip"}},"countTips": {"sum": {"script": "doc[\'nestedTransactionTypes.tip\'].value > 0 ? 1 : 0"}},"quantity": {"sum": {"script": "doc[\'nestedTransactionTypes.paid\'].value > 0 ? 1 : 0"}}}}}}}}'
                        );

                        requests.push('{"index":"eatos-orders","ignore_unavailable":true}')
                        requests.push('{"size":0,"query":{"bool":{"must":' +
                            conditions4 + '}},"aggs":{"employees":{"terms":{"field":"server.id.keyword","size":9999},"aggs":{"refunds":{"nested":{"path":"refunds"},"aggs":{"name":{"terms":{"field":"refunds.reason.keyword","size":9999},"aggs":{"total":{"sum":{"field":"refunds.amount"}}}}}}}}}}')
                        var response = await this.callReports(requests);
                        console.log(response);
                        var responses = response["responses"];
                        /* echo json_encode(requests);
					exit; */
                        var final3 = {
                            success: 1,
                            response: {
                                alldivided: responses,
                                users: users
                            }
                        };
                        return new Promise((resolve, reject) => {
                            resolve(final3);
                        });
                        // Aquí sabemos que primero debemos sacar los cashouts y luego debemos sacar la info separada por los intervalos de los cashouts
                        //echo json_encode(first);
                        //echo json_encode(params["newIntervals"]);
                        // forEach de params["newIntervals"] crear los nuevos requests
                    }
                }
            } else {
                return this.reportError();
            }
        }

        grossdetailed(params, cookie) {
            var merchantId = cookie.get("merchantId");
            this.elasticheaders2.Authorization = cookie.get("token");
            if (params["gte"] && params["lte"] && params["timeoffset"]) {
                var gte = params["gte"];
                var lte = params["lte"];
                var timeoffset = params["timeoffset"];
                var timezone = '"' + params["timezone"] + '"';
                var requests = [];
                // Conditions
                if (params["tips"] == 1) {
                    var tips =
                        '[{"term":{"paymentStatusId":{"value":3}}},{"term":{"paymentStatusId":{"value":4}}},{"nested":{"path":"refunds","query":{"bool":{"must":[[{"match":{"refunds.reason.keyword":"QSA"}},{"match":{"refunds.paymentStatusId": 5}}]]}}}}]';
                } else {
                    var tips =
                        '[{"term":{"paymentStatusId":{"value":3}}},{"term":{"paymentStatusId":{"value":4}}},{"nested":{"path":"refunds","query":{"bool":{"must":[[{"match":{"refunds.reason.keyword":"QSA"}},{"match":{"refunds.paymentStatusId": 5}}]]}}}}]';
                }
                // Get employees
                var conditions =
                    '[{"exists":{"field":"paymentId"}},{"bool":{"should":' +
                    tips +
                    '}},{"term":{"merchantId":{"value": "' +
                    merchantId +
                    '"}}},{"range":{"@timestamp":{"gte": "' +
                    gte +
                    '","lte":"' +
                    lte +
                    '","format":"dd-MM-yyyy","time_zone": "' +
                    timeoffset +
                    '"}}}';

                if (params["storeLocationId"]) {
                    conditions =
                        conditions +
                        ',{"term": {"storeLocationId": {"value": "' +
                        params["storeLocationId"] +
                        '"}}}';
                }
                conditions = conditions + "]";

                //0
                requests.push(
                    '{"index":"eatos-productcategories","ignore_unavailable":true}'
                );
                requests.push(
                    '{"size":9999,"query":{"bool":{"must":[{"term":{"merchantId.keyword":{"value":"' +
                    merchantId +
                    '"}}},{"term":{"status":{"value":1}}}],"must_not":[{"bool":{"filter":{"exists":{"field":"parentCategoryId"}}}}]}}}'
                );
                //1
                requests.push(
                    '{"index":"eatos-productcategories","ignore_unavailable":true}'
                );
                requests.push(
                    '{"size":9999,"query":{"bool":{"must":[{"term":{"merchantId.keyword":{"value":"' +
                    merchantId +
                    '"}}},{"bool":{"filter":{"exists":{"field":"parentCategoryId"}}}},{"term":{"status":{"value":1}}}]}}}'
                );
                //2 All products
                requests.push(
                    '{"index":"eatos-products","ignore_unavailable":true}'
                );
                requests.push(
                    '{"size":9999,"query":{"bool":{"must":[{"term":{"merchantId.keyword":{"value":"' +
                    merchantId +
                    '"}}},{"term":{"status":{"value":1}}}]}}}'
                );
                //3 TotalcustomizationPrice
                requests.push(
                    '{"index":"eatos-orders-variants","ignore_unavailable":true}'
                );
                requests.push(
                    '{"size":0,"query":{"bool":{"must":' +
                    conditions +
                    '}},"aggs":{"services":{"terms": {"field": "service.keyword","size": 9999},"aggs":{"categories":{"terms":{"field":"product.main_category.productCategoryName.keyword","size":9999},"aggs":{"main_name": {"terms": {"field": "product.main_category.productCategoryName.keyword","size":9999}},"totalcustomizationPrice":{"sum":{"field":"product.main_category.totalCustomizationPrice"}},"quantity":{"sum":{"field":"quantity"}},"total":{"sum":{"script":"doc[\'variant.calculatedPrice\'].value - doc[\'variant.customizationPrice\'].value"}},"average":{"avg":{"script":"doc[\'variant.calculatedPrice\'].value - doc[\'variant.customizationPrice\'].value"}},"week":{"terms":{"script":{"source": "Instant.ofEpochMilli(doc[\'@timestamp\'].value.toInstant().toEpochMilli()).atZone(ZoneId.of(params.tz)).dayOfWeek","params": {"tz":' +
                    timezone +
                    '}}},"aggs":{"totalCustomizationPrice":{"sum":{"field":"product.main_category.totalCustomizationPrice"}},"quantity":{"sum":{"field":"quantity"}},"total":{"sum":{"script":"doc[\'variant.calculatedPrice\'].value - doc[\'variant.customizationPrice\'].value"}}}},"sub_categories":{"terms":{"field":"product.category.productCategoryName.keyword","size":9999},"aggs":{"total":{"sum":{"script":"doc[\'variant.calculatedPrice\'].value - doc[\'variant.customizationPrice\'].value"}},"totalcustomizationPrice":{"sum":{"field":"product.category.totalCustomizationPrice"}},"average":{"avg":{"script":"doc[\'variant.calculatedPrice\'].value"}},"week":{"terms":{"script":{"source": "Instant.ofEpochMilli(doc[\'@timestamp\'].value.toInstant().toEpochMilli()).atZone(ZoneId.of(params.tz)).dayOfWeek","params": {"tz":' +
                    timezone +
                    '}}},"aggs":{"totalCustomizationPrice":{"sum":{"field":"product.category.totalCustomizationPrice"}},"quantity":{"sum":{"field":"quantity"}},"total":{"sum":{"script":"doc[\'variant.calculatedPrice\'].value - doc[\'variant.customizationPrice\'].value"}}}},"products":{"terms":{"field":"product.productId.keyword","size":9999},"aggs":{"name":{"terms":{"field":"product.name.keyword","size":9999}},"customizationPrice":{"sum":{"field":"variant.customizationPrice"}},"total":{"sum":{"script":"doc[\'variant.calculatedPrice\'].value - doc[\'variant.customizationPrice\'].value"}},"average":{"avg":{"script":"doc[\'variant.calculatedPrice\'].value"}},"week":{"terms":{"script":{"source": "Instant.ofEpochMilli(doc[\'@timestamp\'].value.toInstant().toEpochMilli()).atZone(ZoneId.of(params.tz)).dayOfWeek","params": {"tz":' +
                    timezone +
                    '}}},"aggs":{"total":{"sum":{"script":"doc[\'variant.calculatedPrice\'].value - doc[\'variant.customizationPrice\'].value "}}}},"variants":{"terms":{"field":"variant.variantId.keyword","size":9999},"aggs":{"variant_name":{"terms":{"field":"variant.name.keyword","size":9999}},"sku":{"terms":{"field":"variant.sku.keyword","size":9999}},"total":{"sum":{"script":"doc[\'variant.calculatedPrice\'].value - doc[\'variant.customizationPrice\'].value"}},"quantity":{"sum":{"field":"variant.quantity"}},"customization":{"sum":{"field":"variant.customizationPrice"}},"average":{"avg":{"script":"doc[\'variant.calculatedPrice\'].value + doc[\'discount\'].value"}},"week":{"terms":{"script":{"source": "Instant.ofEpochMilli(doc[\'@timestamp\'].value.toInstant().toEpochMilli()).atZone(ZoneId.of(params.tz)).dayOfWeek","params": {"tz":' +
                    timezone +
                    '}}},"aggs":{"total":{"sum":{"script":"doc[\'variant.calculatedPrice\'].value - doc[\'variant.customizationPrice\'].value"}}}}}}}}}}}},"total":{"sum":{"script":"doc[\'variant.calculatedPrice\'].value "}},"average":{"avg":{"script":"doc[\'variant.calculatedPrice\'].value"}},"week":{"terms":{"script":{"source": "Instant.ofEpochMilli(doc[\'@timestamp\'].value.toInstant().toEpochMilli()).atZone(ZoneId.of(params.tz)).dayOfWeek","params": {"tz":' +
                    timezone +
                    '}}},"aggs":{"total":{"sum":{"script":"doc[\'variant.calculatedPrice\'].value - doc[\'variant.customizationPrice\'].value"}},"customizationPrice":{"sum":{"script":"doc[\'variant.customizationPrice\'].value"}}}}}}}}'
                );
                //4
                requests.push(
                    '{"index":"eatos-orders","ignore_unavailable":true}'
                );
                requests.push(
                    '{"size":0,"query":{"bool":{"must":' +
                    conditions +
                    '}},"aggs":{"taxes":{"sum":{"field":"totalTax"}},"serviceCharges":{"sum":{"field":"totalServiceCharge"}},"serviceChargeNoQSA": { "sum": { "field": "serviceChargeNoQSA" } },"discounts":{"sum":{"field":"generalDiscount"}},"total":{"sum":{"field":"totalPrice"}},"tips":{"sum":{"field":"tips"}},"pendingTips":{"sum":{"field":"pendingTips"}},"customItemsValue":{"sum":{"field":"customItemsValue"}},"customItemsQuantity":{"sum":{"field":"customItemsQuantity"}},"giftCardsQuantity":{"sum":{"field":"giftCardsQuantity"}},"giftCardsValue":{"sum":{"field":"giftCardsValue"}}}}'
                );

                requests.push(
                    '{"index":"eatos-orders-products","ignore_unavailable":true}'
                );
                requests.push(
                    '{"size":0,"query":{"bool":{"must":' +
                    conditions +
                    '}},"aggs":{"categories":{"terms":{"field":"product.main_category.productCategoryName.keyword","size":9999},"aggs":{"main_name": {"terms": {"field": "product.main_category.productCategoryName.keyword","size":9999}},"totalcustomizationPrice":{"sum":{"field":"product.main_category.totalCustomizationPrice"}},"quantity":{"sum":{"field":"quantity"}},"total":{"sum":{"script":"doc[\'product.main_category.amount\'].value"}},"average":{"avg":{"script":"doc[\'product.main_category.amount\'].value"}},"week":{"terms":{"script":{"source": "Instant.ofEpochMilli(doc[\'@timestamp\'].value.toInstant().toEpochMilli()).atZone(ZoneId.of(params.tz)).dayOfWeek","params": {"tz":' +
                    timezone +
                    '}}},"aggs":{"total":{"sum":{"script":"doc[\'product.main_category.amount\'].value"}}}},"sub_categories":{"terms":{"field":"product.category.productCategoryName.keyword","size":9999},"aggs":{"total":{"sum":{"script":"doc[\'product.category.amount\'].value - doc[\'product.category.totalCustomizationPrice\'].value"}},"totalcustomizationPrice":{"sum":{"field":"product.category.totalCustomizationPrice"}},"quantity":{"sum":{"field":"quantity"}},"average":{"avg":{"script":"doc[\'product.main_category.amount\'].value"}},"week":{"terms":{"script":{"source": "Instant.ofEpochMilli(doc[\'@timestamp\'].value.toInstant().toEpochMilli()).atZone(ZoneId.of(params.tz)).dayOfWeek","params": {"tz":' +
                    timezone +
                    '}}},"aggs":{"total":{"sum":{"script":"doc[\'product.main_category.amount\'].value"}}}},"products":{"terms":{"field":"product.productId.keyword","size":9999},"aggs":{"name":{"terms":{"field":"product.name.keyword","size":9999}},"customizationPrice":{"sum":{"field":"product.variants.customizationPrice"}},"total":{"sum":{"script":"doc[\'product.main_category.amount\'].value"}},"average":{"avg":{"script":"doc[\'product.main_category.amount\'].value"}},"week":{"terms":{"script":{"source": "Instant.ofEpochMilli(doc[\'@timestamp\'].value.toInstant().toEpochMilli()).atZone(ZoneId.of(params.tz)).dayOfWeek","params": {"tz":' +
                    timezone +
                    '}}},"aggs":{"total":{"sum":{"script":"doc[\'product.main_category.amount\'].value"}}}},"variants":{"terms":{"field":"variant.variantId.keyword","size":9999},"aggs":{"variant_name":{"terms":{"field":"variant.name.keyword","size":9999}},"sku":{"terms":{"field":"variant.sku.keyword","size":9999}},"total":{"sum":{"script":"doc[\'product.main_category.amount\'].value"}},"average":{"avg":{"script":"doc[\'product.main_category.amount\'].value"}},"week":{"terms":{"script":{"source": "Instant.ofEpochMilli(doc[\'@timestamp\'].value.toInstant().toEpochMilli()).atZone(ZoneId.of(params.tz)).dayOfWeek","params": {"tz":' +
                    timezone +
                    '}}},"aggs":{"total":{"sum":{"script":"doc[\'product.main_category.amount\'].value"}}}}}}}}}}}},"total":{"sum":{"script":"doc[\'product.main_category.amount\'].value"}},"average":{"avg":{"script":"doc[\'product.main_category.amount\'].value"}},"week":{"terms":{"script":{"source": "Instant.ofEpochMilli(doc[\'@timestamp\'].value.toInstant().toEpochMilli()).atZone(ZoneId.of(params.tz)).dayOfWeek","params": {"tz":' +
                    timezone +
                    '}}},"aggs":{"total":{"sum":{"script":"doc[\'product.main_category.amount\'].value"}}}}}}'
                );
                //6
                requests.push(
                    '{"index":"eatos-orders-variants","ignore_unavailable":true}'
                );
                requests.push(
                    '{"size":0,"query":{"bool":{"must":' +
                    conditions +
                    '}},"aggs":{"total":{"nested":{"path":"addonsFinal"},"aggs":{"service":{"terms":{"field":"addonsFinal.service.keyword","size":9999},"aggs":{"categories":{"terms":{"field":"addonsFinal.id.productCategoryName.keyword","size":9999},"aggs":{"names":{"terms":{"field":"addonsFinal.name.keyword","size":999999},"aggs":{"amount":{"sum":{"field":"addonsFinal.amount"}},"count":{"sum":{"field":"addonsFinal.count"}},"week":{"terms":{"script":{"source": "Instant.ofEpochMilli(doc[\'addonsFinal.@timestamp\'].value.toInstant().toEpochMilli()).atZone(ZoneId.of(params.tz)).dayOfWeek","params": {"tz":' +
                    timezone +
                    '}}},"aggs":{"amount":{"sum":{"field":"addonsFinal.amount"}},"count":{"sum":{"field":"addonsFinal.count"}}}}}}}}}}}}}}'
                );
                //7
                requests.push(
                    '{"index":"eatos-orders","ignore_unavailable":true}'
                );
                requests.push(
                    '{"size":0,"query":{"bool":{"must":' +
                    conditions +
                    '}},"aggs":{"services":{"terms":{"field":"service.keyword","size":9999},"aggs":{"customItemsQuantity":{"sum":{"field":"customItemsQuantity"}},"customItemsValue":{"sum":{"field":"customItemsValue"}},"week":{"terms":{"script":{"source":"Instant.ofEpochMilli(doc[\'@timestamp\'].value.toInstant().toEpochMilli()).atZone(ZoneId.of(params.tz)).dayOfWeek","params":{"tz":' +
                    timezone +
                    '}}},"aggs":{"total":{"sum":{"field":"customItemsValue"}}}}}}}}'
                );
            } else {
                return this.reportError();
            }
            console.log(requests);
            return this.callReports(requests).then((res: any) => {
                return res.responses;
            });
        }

        sortByName(arr, attr, order) {
            if (order) {
                order = false;
            } else {
                order = true;
            }
            return arr.sort((first, second) => {
                if (first[attr].toUpperCase() > second[attr].toUpperCase()) {
                    if (order) {
                        return 1;
                    } else {
                        return -1;
                    }
                } else if (
                    first[attr].toUpperCase() < second[attr].toUpperCase()
                ) {
                    if (order) {
                        return -1;
                    } else {
                        return 1;
                    }
                }
            });
        }

        loadReceipt(checksum, paymentId, ReceiptType, shortUrl = 0) {
            //TODO: Get receipt info
            return new Promise((resolve, reject) => {
                resolve(
                    JSON.stringify({
                        success: 0,
                        errorCode: "eP-UI-100",
                        message: "Format Error",
                        messageDetails: ["Invalid or incomplete parameters"]
                    })
                );
            });
        }

        loadQuestions() {
            //TODO: ADD questions,
            return new Promise((resolve, reject) => {
                resolve(
                    JSON.stringify({
                        success: 0,
                        errorCode: "eP-UI-100",
                        message: "Format Error",
                        messageDetails: ["Invalid or incomplete parameters"]
                    })
                );
            });
        }

        sendReceiptReply(
            checksum,
            reply,
            merchantId,
            message,
            lastMessage,
            lastStatus
        ) {
            //TODO: Implement reply system, check docs
            return new Promise((resolve, reject) => {
                resolve(
                    JSON.stringify({
                        success: 0,
                        errorCode: "eP-UI-100",
                        message: "Format Error",
                        messageDetails: ["Invalid or incomplete parameters"]
                    })
                );
            });
        }

        viewAnswers(checksum, merchantId) {
            //TODO:Implement answers
            return new Promise((resolve, reject) => {
                resolve(
                    JSON.stringify({
                        success: 0,
                        errorCode: "eP-UI-100",
                        message: "Format Error",
                        messageDetails: ["Invalid or incomplete parameters"]
                    })
                );
            });
        }

        sendFeedback(checksum, reply, merchantId) {
            //TODO:Implement Feedback
            return new Promise((resolve, reject) => {
                resolve(
                    JSON.stringify({
                        success: 0,
                        errorCode: "eP-UI-100",
                        message: "Format Error",
                        messageDetails: ["Invalid or incomplete parameters"]
                    })
                );
            });
        }

        answersoutside(checksum) {
            //TODO:Implement answers
            return new Promise((resolve, reject) => {
                resolve(
                    JSON.stringify({
                        success: 0,
                        errorCode: "eP-UI-100",
                        message: "Format Error",
                        messageDetails: ["Invalid or incomplete parameters"]
                    })
                );
            });
        }

        private call(url, parameters) {
            return fetch(url, {
                method: this.method,
                headers: this.headers,
                body: JSON.stringify(parameters),
                credentials: "include"
            }).then((res: any) => {
                return res.json();
            });
        }

        private callReports(parameters) {
            var body: any = { elasticBody: [] };
            parameters.forEach(element => {
                body.elasticBody.push(encodeURI(element));
            });

            return fetch(environment.globalUrlApi + "/elastic", {
                method: this.method,
                headers: this.elasticheaders2,
                body: JSON.stringify(body)
            })
                .then((res: any) => {
                    return res.json();
                })
                .catch(err => {
                    console.log(err);
                });
        }
    }

    // @Injectable()
    // export class ApiCall {
    //     url: string = environment.server;
    //     method: string = "POST";
    //     headers = {
    //         Accept: "application/json",
    //         "Content-Type": "text/plain"
    //     };
    //     all(endpoint, properties = {}) {
    //         var parameters = this.build("GET", endpoint, properties);
    //         return this.call(parameters);
    //     }
    //     create(endpoint, properties) {
    //         var parameters = this.build("POST", endpoint, properties);
    //         return this.call(parameters);
    //     }
    //     update(endpoint, properties) {
    //         var parameters = this.build("PUT", endpoint, properties);
    //         return this.call(parameters);
    //     }
    //     delete(endpoint, properties) {
    //         var parameters = this.build("DELETE", endpoint, properties);
    //         return this.call(parameters);
    //     }

    //     private call(parameters) {
    //         return fetch(this.url, {
    //             method: this.method,
    //             headers: this.headers,
    //             body: parameters,
    //             credentials: "include"
    //         }).then((res: any) => {
    //             return res.json();
    //         });
    //     }

    //     private build(method, endpoint, extraparameters) {
    //         var parameters = {
    //             method: method,
    //             endpoint: endpoint
    //         };
    //         if (
    //             extraparameters.storeLocationId &&
    //             extraparameters.storeLocationId != "*"
    //         ) {
    //             parameters["storeLocationId"] = extraparameters.storeLocationId;
    //         }
    //         delete extraparameters.storeLocationId;
    //         Object.assign(parameters, extraparameters);
    //         return JSON.stringify(parameters);
    //     }
    // }
}

@Injectable()
export class EmitterService {
    // Event store
    private static _emitters: { [ID: string]: EventEmitter<any> } = {};
    // Set a new event in the store with a given ID
    // as key
    static get(ID: string): EventEmitter<any> {
        if (!this._emitters[ID]) this._emitters[ID] = new EventEmitter();
        return this._emitters[ID];
    }
}
